/*! Copyright 2016 Spin Games LLC. All Rights Reserved. */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(2);
	__webpack_require__(199);
	__webpack_require__(202);
	__webpack_require__(203);
	__webpack_require__(204);
	__webpack_require__(415);
	__webpack_require__(455);
	
	$.ready(function () {
		game.dimensions.width = 1740;
		game.dimensions.height = 1097;
	
		game.panel.buildHelp(7);
	
		/* globals controller spinDone */
		game.sounds.loadSounds({
			// _base: base,
			konami_bell: __webpack_require__(457),
			bell: __webpack_require__(457),
			trigger: __webpack_require__(458),
			drop: {
				// '0': [ null, null, null, null, null ],
				'12': [__webpack_require__(459), __webpack_require__(460), __webpack_require__(461), __webpack_require__(462), __webpack_require__(463)]
			},
			reel: [__webpack_require__(464), __webpack_require__(464), __webpack_require__(464), __webpack_require__(464), __webpack_require__(464)],
			reel_start: __webpack_require__(465),
			anticipate: {
				12: __webpack_require__(466)
			},
			multi_sweep: __webpack_require__(467),
			multi_sweep_twinkle: __webpack_require__(468),
			buttons: {
				denoms: {
					denom_0: __webpack_require__(469),
					denom_1: __webpack_require__(470),
					denom_2: __webpack_require__(471),
					denom_3: __webpack_require__(472),
					denom_4: __webpack_require__(473),
					denom_5: __webpack_require__(474),
					denom_6: __webpack_require__(475)
				},
				coins: {
					bet_0: __webpack_require__(476),
					bet_1: __webpack_require__(477),
					bet_2: __webpack_require__(478),
					bet_3: __webpack_require__(479),
					bet_4: __webpack_require__(480),
					bet_5: __webpack_require__(481),
					bet_6: __webpack_require__(481),
					bet_7: __webpack_require__(481),
					bet_8: __webpack_require__(481)
				},
				max: __webpack_require__(482),
				sound: __webpack_require__(483),
				help: __webpack_require__(484),
				close: __webpack_require__(485),
				next: __webpack_require__(486),
				prev: __webpack_require__(487)
			},
			freespin: {
				// default intro sound has bad timing for this title, used in freespin init
				intro: __webpack_require__(488),
				background2: __webpack_require__(489),
				smallTrigger: __webpack_require__(490),
				countUp: __webpack_require__(491)
	
			},
			pick: {
				waiting: __webpack_require__(492),
				pick: __webpack_require__(493),
				mysteryPick: __webpack_require__(494),
				mysteryRollup: __webpack_require__(495),
				mysteryFinish: __webpack_require__(496)
			},
			multiplierReveal: __webpack_require__(497),
			multiplierTypes: [__webpack_require__(498), __webpack_require__(499), __webpack_require__(500)],
			quake: __webpack_require__(501),
			win: {
				// decor : 'decor',
				intro1: __webpack_require__(502),
				intro2: __webpack_require__(503),
				win_1: __webpack_require__(504),
				win_2: __webpack_require__(505),
				win_3: __webpack_require__(506),
				bigwin_1: __webpack_require__(507),
				bigwin_2: __webpack_require__(508),
				bigwin_3: __webpack_require__(509)
			},
			konami_base_fallback: __webpack_require__(510)
		});
	
		game.specials = {
			12: { reels: [0, 1, 2, 3, 4], min: 2, needs: 3, anticipate: true }
		};
	
		game.pays.forceCycles = true;
		var numCoins = 31;
		var coinTimeout = 0;
		var celebrateTimeout = 0;
		var startCelebrateTimeout = 0;
	
		var reels = $.div('reels');
		reels.prependTo(game.container);
	
		var actionLogo = $.div('action-logo');
		actionLogo.appendTo(game.container);
	
		var xtraReward = $.div('xtra-reward');
		xtraReward.appendTo(game.container);
	
		var fortune = {};
	
		var freespin = game.features.freespin = game.generateFreespin({ symbol: 12, introTime: 1, banners: 1, noAutomatedSounds: true, outroTime: 500 });
	
		freespin.dimensions = {
			width: 1920,
			height: 1222,
			font: 32
		};
	
		var _choose = game.features.choose_math = $.div('bonus-choose');
		_choose.pick = $.div('choose').addClass('hide').appendTo(_choose);
		_choose.key = 'choose_math';
	
		_choose.intro = $.div().addClass('intro').appendTo(_choose);
		_choose.intro.text = $.div().addClass('text').appendTo(_choose.intro);
		_choose.intro.number = $.div().addClass('number').appendTo(_choose.intro);
	
		var items = $.div().addClass('items').appendTo(_choose.pick);
		_choose.items = [];
		for (var i = 0; i < 5; i++) {
			_choose.items[i] = $.div().addClass('item item-' + i).appendTo(items);
			_choose.items[i].flourish = $.div().addClass('flourish').appendTo(_choose.items[i]);
		}
	
		_choose.items[2].spins = $.div().addClass('spins').appendTo(_choose.items[2]);
	
		_choose.items[2].multipliers = [];
		_choose.items[2].multipliers[0] = $.div().addClass('mult mult-1').appendTo(_choose.items[2]);
		_choose.items[2].multipliers[1] = $.div().addClass('mult mult-2').appendTo(_choose.items[2]);
		_choose.items[2].multipliers[2] = $.div().addClass('mult mult-3').appendTo(_choose.items[2]);
	
		// set to false at the beginning of each spin, conditionally set to true when pays are shown
		var line_indicators = game.frame.line_indicators = [];
	
		game.features.choose_math.methods = {
			choose: function choose(response) {
				var delay = 2000;
	
				game.addClass('_' + response.index);
				game.sounds.stop(['pick', 'waiting']);
	
				if (response.index !== 2) {
					game.sounds.play(['pick', 'pick']);
				}
	
				for (var item in _choose.items) {
					if (_choose.items[item].hasClass('picked')) {
						_choose.items[item].flourish.addClass('picked');
					} else {
						_choose.items[item].flourish.addClass('none');
					}
				}
	
				if (typeof game.last.spins !== 'undefined') {
					game.last.spins = response.spins;
					freespin.spins.set(game.last.spins);
					_choose.intro.addClass('x' + response.spins);
					_choose.pickedMults = response.chosen_mults;
				}
	
				if (response.index === 2) {
					(function () {
						var possibleMults = [];
						var possibleSpins = [];
						var timer = 50;
	
						delay = 7000;
	
						possibleSpins = [3, 5, 10, 20];
	
						possibleMults[0] = [2, 3, 5];
						possibleMults[1] = [5, 8, 10];
						possibleMults[2] = [10, 15, 30];
						possibleMults[3] = [15, 30, 40];
	
						game.sounds.play(['pick', 'mysteryRollup']);
	
						var _loop = function _loop(index) {
							setTimeout(function () {
								_choose.items[response.index].spins.attr('class', 'spins show x' + possibleSpins[index % 4]);
							}, timer);
	
							timer += 50;
						};
	
						for (var index = 0; index < 40; index++) {
							_loop(index);
						}
	
						_choose.items[response.index].multipliers[0].attr('class', 'mult mult-1 spin show');
						_choose.items[response.index].multipliers[1].attr('class', 'mult mult-2 spin show');
						_choose.items[response.index].multipliers[2].attr('class', 'mult mult-3 spin show');
	
						setTimeout(function () {
							game.sounds.play(['pick', 'mysteryPick']);
							game.sounds.play(['pick', 'mysteryRollup']);
							_choose.items[response.index].spins.attr('class', 'spins show x' + response.spins);
						}, 2000);
	
						game.addClass('x' + _choose.pickedMults[0]);
	
						setTimeout(function () {
							game.sounds.play(['pick', 'mysteryFinish']);
							_choose.items[response.index].multipliers[0].attr('class', 'mult mult-1 show x' + _choose.pickedMults[0]);
							_choose.items[response.index].multipliers[1].attr('class', 'mult mult-2 show x' + _choose.pickedMults[1]);
							_choose.items[response.index].multipliers[2].attr('class', 'mult mult-3 show x' + _choose.pickedMults[2]);
						}, 4000);
					})();
				}
	
				setTimeout(function () {
					game.sounds.play(['freespin', 'intro']);
					_choose.pick.addClass('hide');
	
					setTimeout(function () {
						game.features.freespin.inited = true;
						game.features.freespin.playing.appendTo(game.panel.play);
						game.panel.show(true);
					}, 2000);
	
					setTimeout(function () {
						game.panel.disable('freespin');
	
						game.features.freespin.methods.next(response.spins);
					}, 3000);
				}, delay);
			}
		};
	
		var bubbles = 0;
		var recallFinish = false;
	
		game.panel.dialog.pager.bubbles.on('click', function () {
			if (bubbles > game.panel.dialog._page) {
				game.sounds.play(['buttons', 'prev']);
				bubbles = game.panel.dialog._page;
			} else if (bubbles < game.panel.dialog._page) {
				game.sounds.play(['buttons', 'next']);
				bubbles = game.panel.dialog._page;
			}
		});
	
		// Help screen close
		game.panel.dialog.pager.exit.on('click', function () {
			game.sounds.play(['buttons', 'close']);
			bubbles = 0;
		});
	
		// Help screen right arrow click
		game.panel.dialog.pager.right.on('click', function () {
			game.sounds.play(['buttons', 'next']);
			bubbles = game.panel.dialog._page;
		});
	
		// Help screen left arrow click
		game.panel.dialog.pager.left.on('click', function () {
			game.sounds.play(['buttons', 'prev']);
			bubbles = game.panel.dialog._page;
		});
	
		game.on('ui', function (e) {
			fortune.coins = $.div().addClass('fortune coins').appendTo(game.pays);
			fortune.coins.coins = [];
			fortune.coins.coin = 0;
	
			// Adding xtra reward cost to panel
			game.feature.cost = e.detail.xtra_reward.cost;
			game.pays.cost = 0.5;
	
			game.panel.disableBigWins([1, 3, 4, 6, 10, 14]);
	
			// Div's used for when 2 of a Kind shows full Line instead of Split lines
			var middleReelBlocks = game.frame.reels[2].middleReelBlocks = [];
			middleReelBlocks[0] = $.div().addClass('Row-0').appendTo(game.frame.reels[2]);
			middleReelBlocks[1] = $.div().addClass('Row-1').appendTo(game.frame.reels[2]);
			middleReelBlocks[2] = $.div().addClass('Row-2').appendTo(game.frame.reels[2]);
	
			for (var i = 0; i < numCoins; i++) {
				fortune.coins.coins[i] = $.div().addClass('coin-' + i).appendTo(fortune.coins);
			}
	
			fortune.stacks = $.div().addClass('fortune stacks').appendTo(game.pays);
	
			line_indicators[0] = $.div().addClass('line_indicator left').prependTo(game.pays);
			line_indicators[1] = $.div().addClass('line_indicator right').prependTo(game.pays);
	
			if (e.detail.recall && e.detail.recall.actions) {
				for (var recallAction in e.detail.recall.actions) {
					var type = e.detail.recall.actions[recallAction].response;
	
					if (type.action === 'finish') {
						recallFinish = true;
					}
				}
			}
		});
	
		game.on('bet', function (e) {
			e.detail.feature_cost = game.feature.cost;
		});
	
		game.panel.lines.on('update', function (e) {
			var value = this.values[this.value] / 2;
	
			value = $.plugins.meter.__format(value);
	
			if (game.panel.type === 'mobile') {
				game.panel.lines.items[0].label.html(value);
			} else {
				this.field.html(value);
			}
		});
	
		game.on('ready', function () {
			// Default bell timing is not right for this title, plays on freespin init
			setTimeout(function () {
				if (!game.sounds.fallback) {
					game.sounds.sounds.bell = null;
				}
			}, 15);
		});
	
		game.on('spin_init', function (e) {
			// REPLACE FEATURE
			this.spindle.attr('class', 's' + this.last.replace);
			this.frame.reels[2].attr('class', 'reel reel-2');
	
			if (!game.feature.active) {
				game.messaging.show('logo');
			}
		});
	
		game.pays.on('pay', function (e) {
			var pay = e.detail;
			var match = -1;
	
			if (pay.type === 'scatter') {
				return;
			}
	
			if (pay.line > 29) {
				pay.line %= 30;
				pay.lineAugment = ' B';
			} else {
				pay.lineAugment = ' A';
			}
	
			for (var line in game.pays.list) {
				if (game.pays.list[line].line === pay.line) {
					match = line;
					break;
				}
			}
	
			if (match === -1 && pay.spots.length === 2) {
				pay.lineAugment = '';
			} else if (match !== -1 && pay.spots.length !== 2) {
				if (game.pays.list[match].spots.length === 2) {
					if (pay.lineAugment === ' A') {
						game.pays.list[match].lineAugment = ' B';
					} else {
						game.pays.list[match].lineAugment = ' A';
					}
				}
			}
		});
	
		game.pays.on('line', function (e) {
			var line = e.detail;
			var row = 0;
	
			if (line.reel !== 2 || !line.pay) {
				return;
			}
	
			if (line.pay.lineAugment === ' B') {
				line.line = game.pays.lines[line.lineNumber + 30];
				row = line.line[2];
				line.track = game.frame.reels[line.reel].symbols[row];
			} else if (line.pay.lineAugment === '') {
				row = Math.floor(line.line[2] / 2);
				line.track = game.frame.reels[line.reel].middleReelBlocks[row];
			}
		});
	
		game.on('spin_pre_done', function () {
			var index = 0;
	
			if (!game.feature.active && !game.last.introShown && game.last.scatters.counts[12] > 2 && !recallFinish) {
				// game.last.delayWin = true;
				game.last.introShown = true;
				game.last.delayBonus = true;
				showBonusIntro(3000);
			} else if (game.last.wild_multiplier && !game.last.multShown) {
				game.frame.addClass('win');
	
				game.frame.reels[2].addClass('x');
				game.frame.reels[2].addClass('x' + game.last.wild_multiplier);
				game.frame.reels[2].addClass('intro');
	
				for (index = 0; index < _choose.pickedMults.length; index++) {
					if (game.last.wild_multiplier === _choose.pickedMults[index]) {
						break;
					}
				}
	
				game.sounds.play('multiplierReveal');
	
				setTimeout(function () {
					game.sounds.play(['multiplierTypes', index]);
				}, 500);
	
				setTimeout(function () {
					game.frame.reels[2].removeClass('intro');
				}, 2000);
	
				game.last.delayWin = true;
				game.last.multShown = true;
	
				setTimeout(function () {
					game.last.delayWin = false;
					spinDone();
					game.frame.addClass('win');
				}, 2000);
			} else if (!game.last.delayed) {
				decideCoins();
			}
		});
	
		game.on('spin_done', function () {
			if (game.feature.active && game.last.scatters.win && game.last.name) {
				_choose.intro.addClass('show');
				_choose.intro.addClass('retrigger');
				game.sounds.play(['freespin', 'smallTrigger']);
	
				setTimeout(function () {
					_choose.intro.removeClass('show');
				}, 2000);
			}
		});
	
		game.on('reel_stop', function (e) {
			var index = e.detail.index;
	
			fitToFrame(index);
		});
	
		freespin.on('init', function (e) {
			// let recall = e.detail.reacall;
			_choose.clicked = true;
	
			if (game.old) {
				game.old.quickTransition = false;
			}
	
			game.panel.disable(true);
	
			_choose.items[2].spins.attr('class', 'spins');
			_choose.items[2].multipliers[0].attr('class', 'mult mult-1');
			_choose.items[2].multipliers[1].attr('class', 'mult mult-2');
			_choose.items[2].multipliers[2].attr('class', 'mult mult-3');
	
			setTimeout(function () {
				game.panel.hide(true);
			}, 100);
	
			game.sounds.sounds.freespin.background = null;
		});
	
		freespin.on('begin', function (e) {
			_choose.appendTo(game.feature);
			game.last.delayWin = true;
			game.features.freespin.play.remove();
			game.features.freespin.play.message.html('');
	
			setTimeout(function () {
				if (game.last.spins_aquired === 0) {
					_choose.pick.removeClass('hide');
					_choose.clicked = false;
	
					setTimeout(function () {
						game.endCelebrate();
					}, 1000);
				} else {
					game.addClass('_' + game.config.recover.chosen_index);
					game.addClass('x' + game.config.recover.chosen_mults[0]);
	
					_choose.pickedMults = game.config.recover.chosen_mults;
					_choose.intro.addClass('x' + game.config.recover.chosen_spins);
	
					game.panel.show(true);
					_choose.intro.removeClass('show');
					_choose.clicked = true;
	
					game.features.freespin.inited = true;
	
					setTimeout(function () {
						game.features.freespin.methods.next(game.last.spins);
					}, 1000);
				}
	
				game.sounds.play(['pick', 'waiting'], true);
			}, 3000);
		});
	
		freespin.on('spin', function () {
			if (game.panel.play.hasClass('icon-begin')) {
				game.panel.play.removeClass('icon-begin');
				game.panel.play.addClass('icon-spin');
			}
	
			if (!this.swappedTheBackground) {
				this.swappedTheBackground = true;
				game.sounds.sounds.freespin.background = game.sounds.sounds.freespin.background2;
				game.sounds.play(['freespin', 'background'], true);
			}
		});
	
		freespin.on('finish', function () {
			game.attr('class', '');
			this.swappedTheBackground = false;
			game.old.delayed = false;
	
			setTimeout(function () {
				game.messaging.show('logo');
	
				setTimeout(function () {
					game.panel.setWin(game.last.win);
				}, 1000);
	
				if (game.autoplay.isActive()) {
					setTimeout(function () {
						game.play();
					}, 2000);
				}
	
				for (var item in _choose.items) {
					_choose.items[item].removeClass('picked');
					_choose.items[item].flourish.removeClass('none');
				}
	
				game.panel.setCredits(game.last.credits);
			}, 1500);
		});
	
		_choose.on('click', 'item', function () {
			if (_choose.clicked) {
				return;
			}
	
			this.addClass('picked');
	
			_choose.clicked = true;
			controller.socket.emit('feature', { name: 'choose_math', action: 'choose', index: this.index() });
		});
	
		game.startCelebrate = function () {
			fortune.stacks.addClass('shimmer');
	
			celebrateTimeout = setTimeout(function () {
				celebrateTimeout = setTimeout(function () {
					fortune.coins.addClass('flip');
					coinTimeout = setInterval(function () {
						game.flipCoins();
					}, 2000 / (numCoins - 2));
				}, 0);
			}, 450);
		};
	
		game.flipCoins = function () {
			var current = fortune.coins.coin;
			var coin = Math.floor(Math.random() * (6 - 1 + 1)) + 1; // coin image
			var left = Math.floor(Math.random() * (85 - 15 + 1)) + 15; // css displacement
	
			fortune.coins.coins[current].css('left', 50 + '%');
			fortune.coins.coins[current].attr('class', 'flip coin-' + coin);
	
			setTimeout(function () {
				fortune.coins.coins[current].css('left', left + '%');
			}, 250);
	
			setTimeout(function () {
				fortune.coins.coins[current].removeClass('flip');
			}, 2000);
	
			fortune.coins.coin = (fortune.coins.coin + 1) % fortune.coins.coins.length;
		};
	
		game.endCelebrate = function () {
			clearInterval(coinTimeout);
			clearInterval(celebrateTimeout);
			clearInterval(startCelebrateTimeout);
	
			fortune.coins.removeClass('flip');
			fortune.stacks.removeClass('shimmer');
	
			game.removeClass('quake');
			game.removeClass('quakeVert');
		};
	
		game.on('round_complete', function () {
			game.endCelebrate();
	
			if (game.last.bonuses && game.last.bonuses.length && !recallFinish) {
				game.feature.begin(game.last.bonuses.pop());
				game.last.triggereBonus = true;
			}
		});
	
		game.panel.spin.on('click', function () {
			game.endCelebrate();
	
			game.removeClass('quakeVert');
			game.removeClass('quake');
		});
	
		game.panel.disableBigWins = function (durations) {
			this.bigwin.celebrations = {};
	
			for (var i = 0; i < this.bigwin.levels.length; i++) {
				this.bigwin.levels[i] = [this.bigwin.levels[i][this.bigwin.levels[i].length - 1]];
	
				if (this.bigwin.levels[i][0].duration) {
					this.bigwin.levels[i][0].duration = undefined;
					delete this.bigwin.levels[i][0].duration;
				}
	
				if (durations && durations[i]) {
					this.bigwin.levels[i][0].duration = durations[i];
				}
	
				if (this.bigwin.levels[i][0].celebration) {
					this.bigwin.levels[i][0].celebration = undefined;
					delete this.bigwin.levels[i][0].celebration;
				}
			}
		};
	
		function fitToFrame(index) {
			for (var col = 0; col < game.config.reels; col++) {
				var rowLength = game.config.rows[col];
	
				for (var row = 0; row < rowLength; row++) {
					if (game.last.matrix[typeof index === 'number' ? index : col][row] === 12 && !game.last.animate[col][row]) {
						game.frame.reels[typeof index === 'number' ? index : col].symbols[row].addClass('symbol symbol-12');
					}
				}
			}
		}
	
		function decideCoins() {
			var decide = 0;
			var factor = 5;
			var winFactor = 0;
			var win = game.last.win;
	
			if (game.last._cost) {
				winFactor = win / game.last._cost;
			} else if (game.old && game.old._cost) {
				winFactor = win / game.old._cost;
			} else if (game.old && game.old._cost === 0) {
				winFactor = win / (game.panel.lines.get() * game.panel.coins.get());
			}
	
			for (decide = 0; decide < game.panel.bigwin.breakpoints.length; decide++) {
				if (winFactor < game.panel.bigwin.breakpoints[decide]) {
					break;
				}
			}
	
			if (decide >= factor) {
				game.last.delayWin = true;
				game.frame.addClass('win');
				game.addClass('quake');
				game.addClass('quakeVert');
				game.sounds.play('quake');
	
				startCelebrateTimeout = setTimeout(function () {
					game.startCelebrate();
					game.last.delayWin = false;
					game.last.delayed = true;
	
					if (game.last.bonuses && game.last.bonuses.length || game.last.triggereBonus) {
						game.last.delayBonus = true;
					}
	
					spinDone();
					game.frame.addClass('win');
					game.removeClass('quake');
					game.removeClass('quakeVert');
	
					if (game.last.bonuses && game.last.bonuses.length) {
						game.pays.show();
					}
				}, 2000);
			}
		}
	
		function showBonusIntro(time) {
			var message = $.div().addClass('false-messages').appendTo(game.pays);
			var text = $.div().addClass('text');
	
			message.addClass('intro');
			text.appendTo(message);
			game.sounds.play('konami_bell');
	
			setTimeout(function () {
				message.attr('class', 'false-messages');
				message.remove();
	
				game.messaging.hide('logo');
				game.panel.setWin(game.last.win);
				game.last.delayBonus = true;
	
				spinDone();
	
				if (game.last.scatters.counts[12] < 5) {
					game.pays.show();
				}
			}, time);
		}
	
		// recover cost
		game.on('ui', function (e) {
			if (!game.last._cost) {
				setTimeout(function () {
					var bet = game.panel.getBet();
					game.last._cost = bet.coins * bet.lines;
				}, 1);
			}
		});
		// --new
	});

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(3);
	__webpack_require__(170);

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(4);
	__webpack_require__(20);

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(5);
	__webpack_require__(7);
	__webpack_require__(9);
	__webpack_require__(16);
	__webpack_require__(17);
	
	__webpack_require__(18);
	
	window.onkeydown = function (e) {
		return !(e.keyCode === 32);
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ = window._ = __webpack_require__(6);
	
	(function () {
		var Wrapper = this.Wrapper = function (el) {
			if (el) {
				this.el = el;
			}
		};
	
		var $ = this.$ = function (element) {
			if (typeof element === 'string') {
				return $.getById(element);
			} else {
				return new Wrapper(element);
			}
		};
	
		$.namespaces = {
			svg: 'http://www.w3.org/2000/svg',
			xlink: 'http://www.w3.org/1999/xlink'
		};
	
		$.element = function (element, ns) {
			if (ns) {
				return $(document.createElementNS($.namespaces[ns] || ns, element));
			} else {
				return $(document.createElement(element));
			}
		};
	
		$.div = function (id) {
			var div = $.element('div');
	
			if (id) {
				div.id(id);
			}
	
			return div;
		};
	
		$.getAllByClass = function (c) {
			return $(document.getElementsByClassName(c));
		};
	
		$.getByClass = function (c) {
			return $(document.querySelector(c));
		};
	
		$.getById = function (element) {
			return $(document.getElementById(element));
		};
	
		var $p = this.$p = Wrapper.prototype;
	
		$p.appendTo = function (element) {
			if (element.el) {
				element.el.appendChild(this.el);
			} else {
				element.appendChild(this.el);
			}
	
			return this;
		};
	
		$p.prependTo = function (element) {
			var parent = element;
	
			if (parent.el) {
				parent = parent.el;
			}
	
			parent.insertBefore(this.el, parent.firstChild);
	
			return this;
		};
	
		$p.after = function (element) {
			element.el.parentNode.insertBefore(this.el, element.el.nextSibling);
	
			return this;
		};
	
		$p.before = function (element) {
			element.el.parentNode.insertBefore(this.el, element.el);
	
			return this;
		};
	
		$p.reinsert = function () {
			if (!this.el.parentNode) {
				return this;
			}
	
			var parent = this.el.parentNode;
			var before = this.el.nextSibling;
	
			parent.removeChild(this.el);
	
			if (before) {
				parent.insertBefore(this.el, before);
			} else {
				parent.appendChild(this.el);
			}
	
			return this;
		};
	
		$p._addClass = function (c, el) {
			if (c.length === 1) {
				if (c[0].length) {
					el.classList.add(c[0]);
				}
			} else {
				_.each(c, function (v) {
					if (v.length) {
						el.classList.add(v);
					}
				});
			}
		};
	
		$p.addClass = function (c) {
			c = c.split(' ');
	
			$p._addClass(c, this.el);
	
			return this;
		};
	
		$p._removeClass = function (c, el) {
			if (c.length === 1) {
				if (c[0].length) {
					el.classList.remove(c[0]);
				}
			} else {
				_.each(c, function (v) {
					if (v.length) {
						el.classList.remove(v);
					}
				});
			}
		};
	
		$p.removeClass = function (c) {
			c = c.split(' ');
	
			$p._removeClass(c, this.el);
	
			return this;
		};
	
		$p._toggleClass = function (c, force, el) {
			// IE does not respect classList.toggle(..., force) paramater.
			if (c.length === 1) {
				if (c[0].length) {
					if (typeof force === 'boolean') {
						if (force) {
							el.classList.add(c[0]);
						} else {
							el.classList.remove(c[0]);
						}
					} else {
						el.classList.toggle(c[0]);
					}
				}
			} else {
				_.each(c, function (v) {
					if (v.length) {
						if (typeof force === 'boolean') {
							if (force) {
								el.classList.add(v);
							} else {
								el.classList.remove(v);
							}
						} else {
							el.classList.toggle(v);
						}
					}
				});
			}
		};
	
		$p.toggleClass = function (c, force) {
			c = c.split(' ');
	
			$p._toggleClass(c, force, this.el);
	
			return this;
		};
	
		$p.hasClass = function (c) {
			return this.el.classList.contains(c);
		};
	
		$p.id = function (id) {
			return this.attr('id', id);
		};
	
		var prefixed = ['transition', 'transform'];
	
		$p.css = function (key, value) {
			if (typeof key === 'string') {
				var prefix = prefixed.reduce(function (prefix, property) {
					return prefix || key.indexOf(property) === 0;
				}, false);
	
				if (prefix) {
					this.css('-webkit-' + key, value);
				}
			}
	
			switch (true) {
				case _.isObject(key):
					_.each(key, function (v, k) {
						this.css(k, v);
					}, this);
					break;
	
				case _.isUndefined(value):
					return window.getComputedStyle(this.el, null).getPropertyValue(key);
	
				case _.isNull(value):
					this.el.style.removeProperty(key);
					break;
	
				case _.isNumber(value):
					this.el.style[key] = value.toString() + 'px';
					break;
	
				default:
					this.el.style[key] = value;
					break;
			}
	
			return this;
		};
	
		$p.attr = function (key, value, ns) {
			switch (true) {
				case _.isObject(key):
					_.each(key, function (v, k) {
						this.attr(k, v, ns);
					}, this);
					break;
	
				case _.isUndefined(value):
					return this.el.getAttribute(key);
	
				case _.isNull(value):
					this.el.removeAttribute(key);
					break;
	
				default:
					if (ns) {
						this.el.setAttributeNS($.namespaces[ns] || ns, key, value);
					} else {
						this.el.setAttribute(key, value);
					}
	
					break;
			}
	
			return this;
		};
	
		$p.html = function (html, append) {
			switch (true) {
				case _.isUndefined(html):
					return this.el.innerHTML;
	
				case _.isNull(html):
					this.el.innerHTML = '';
					break;
	
				default:
					if (append) {
						this.el.innerHTML += html;
					} else {
						this.el.innerHTML = html;
					}
	
					break;
			}
	
			return this;
		};
	
		$p.empty = function () {
			if (this.el.hasChildNodes()) {
				while (this.el.childNodes.length >= 1) {
					this.el.removeChild(this.el.firstChild);
				}
			}
	
			return this;
		};
	
		$p.index = function () {
			return Array.prototype.indexOf.call(this.el.parentNode.childNodes, this.el);
		};
	
		$p.child = function (index) {
			if (!this.el.childNodes.item(index)) {
				return null;
			}
	
			return $(this.el.childNodes.item(index));
		};
	
		$p.children = function () {
			return $(this.el.childNodes);
		};
	
		$p.first = function () {
			return $(this.el.firstChild);
		};
	
		$p.last = function () {
			return $(this.el.lastChild);
		};
	
		$p.remove = function () {
			if (!this.el.parentNode) {
				return this;
			}
	
			this.el.parentNode.removeChild(this.el);
	
			return this;
		};
	
		$p.clone = function (deep) {
			return $(this.el.cloneNode(deep));
		};
	
		$p.redraw = function () {
			return this.el.offsetHeight;
		};
	
		$.events = {};
	
		$p.on = function (event, check, fn, stop) {
			if (typeof check === 'function') {
				stop = fn;
				fn = check;
				check = undefined;
			}
	
			var callback = function callback(e) {
				var self = this;
	
				if (check) {
					self = $(e.target);
	
					if (!self.hasClass(check)) {
						return;
					}
				}
	
				fn.call(self, e);
	
				if (stop) {
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			};
	
			if (typeof $.events[event] === 'string') {
				event = $.events[event];
			}
	
			if (typeof $.events[event] === 'function') {
				$.events[event].call(this, callback.bind(this));
			} else {
				this.el.addEventListener(event, callback.bind(this));
			}
	
			return this;
		};
	
		$p.trigger = $p.emit = function (event, data) {
			if (typeof $.events[event] === 'string') {
				event = $.events[event];
			}
	
			if (event === 'click') {
				if (document.createEvent) {
					var obj = document.createEvent('MouseEvents');
					obj.initEvent(event, true, false);
	
					for (var i in data) {
						obj[i] = data[i];
					}
	
					this.el.dispatchEvent(obj);
				} else if (document.createEventObject) {
					var obj = document.createEventObject();
	
					for (var j in data) {
						obj[j] = data[j];
					}
	
					this.el.fireEvent('on' + event, obj);
				}
	
				return this;
			}
	
			if (document.createEvent) {
				var obj = document.createEvent('CustomEvent');
				obj.initCustomEvent(event, true, false, data);
				this.el.dispatchEvent(obj);
			} else {
				this.el.dispatchEvent(new CustomEvent(event, { detail: data }));
			}
	
			return this;
		};
	
		$.events.click = function (callback) {
			var state = {
				touch: false
			};
	
			this.el.addEventListener('click', function (e) {
				if (!state.touch || e.touch) {
					e.touch = e.touch || false;
					return callback(e);
				}
			});
	
			this.el.addEventListener('touchstart', function (e) {
				state.touch = true;
				state.dt = Date.now();
	
				state.x = e.touches[0].clientX;
				state.y = e.touches[0].clientY;
			});
	
			this.el.addEventListener('touchend', function (e) {
				var dx = e.changedTouches[0].clientX - state.x;
				var dy = e.changedTouches[0].clientY - state.y;
				var d = Math.sqrt(dx * dx + dy * dy);
	
				state.dt = Date.now() - state.dt;
				state.x = e.changedTouches[0].clientX;
				state.y = e.changedTouches[0].clientY;
	
				if (state.dt < 750 && d < 25) {
					$(e.target).trigger('click', {
						touchX: state.x,
						touchY: state.y,
						dx: dx,
						dy: dy,
						touch: true
					});
	
					e.preventDefault();
					e.stopImmediatePropagation();
				}
			});
		};
	
		var div = document.createElement('div');
	
		if ('WebkitTransition' in div.style) {
			$.events.animationstart = 'webkitAnimationStart';
			$.events.animationiteration = 'webkitAnimationIteration';
			$.events.animationend = 'webkitAnimationEnd';
	
			$.events.transitionstart = 'webkitTransitionStart';
			$.events.transitionend = 'webkitTransitionEnd';
		}
	
		$.plugins = {};
	
		$p.apply = function (plugin, config) {
			if (!$.plugins[plugin]) {
				return this;
			}
	
			_.each($.plugins[plugin], function (value, key) {
				if (key.substr(0, 2) === '__') {
					return;
				}
	
				if (this[key]) {
					return;
				}
	
				this[key] = value;
			}, this);
	
			if ($.plugins[plugin].__init) {
				$.plugins[plugin].__init.call(this, config);
			}
	
			return this;
		};
	
		/* global alert */
	
		var DomReady = {
			isReady: false,
			readyList: []
		};
	
		function domReady() {
			if (!DomReady.isReady) {
				DomReady.isReady = true;
	
				if (DomReady.readyList) {
					for (var fn = 0; fn < DomReady.readyList.length; fn++) {
						DomReady.readyList[fn].call();
					}
	
					DomReady.readyList = [];
				}
			}
		}
	
		DomReady.ready = function (fn, args) {
			if (DomReady.isReady) {
				fn.call(window, args);
			} else {
				DomReady.readyList.push(fn.bind(window, args));
			}
		};
	
		document.addEventListener('DOMContentLoaded', domReady, false);
	
		$.ready = DomReady.ready;
	
		$p.getBaseRect = function () {
			var rect = {};
	
			var rules = window.getMatchedCSSRules(this.el) || [];
	
			for (var i = 0; i < rules.length; i++) {
				if (rules[i].style.width) {
					rect.width = rules[i].style.width;
				}
	
				if (rules[i].style.height) {
					rect.height = rules[i].style.height;
				}
			}
	
			for (var i in rect) {
				if (rect[i].substr(-2) === 'px') {
					rect[i] = +rect[i].substr(0, rect[i].length - 2);
				}
			}
	
			return rect;
		};
	
		$.resize = function (game) {
			var parent = $(game.el.parentNode);
	
			document.addEventListener('touchmove', function (e) {
				e.preventDefault();
			});
	
			var resize = function resize() {
				parent.addClass('reset');
	
				window.scrollTo(0, 0);
	
				var dimensions = game.getBaseRect();
	
				var event = {
					scaleW: window.innerWidth / dimensions.width,
					scaleH: window.innerHeight / dimensions.height
				};
	
				event.scale = Math.min(event.scaleW, event.scaleH);
	
				var notify = game.emit || game.trigger;
				notify.call(game, 'scale', event);
	
				game.css({
					'transform': 'scale(' + event.scale + ')',
					'width': window.innerWidth / event.scale,
					'height': window.innerHeight / event.scale
				});
	
				parent.removeClass('reset');
			};
	
			window.addEventListener('resize', resize);
			document.addEventListener('resize', resize);
	
			setTimeout(resize, 100);
		};
	
		$.preload = function (items) {
			for (var i = 0; i < items.length; i++) {
				$.preload.total++;
				var image = new Image();
				image.onload = image.onerror = $.preload.done;
				image.src = items[i];
			}
		};
	
		$.preload.total = 0;
		$.preload.loaded = 0;
		$.preload.callback = null;
	
		$.preload.done = function () {
			$.preload.loaded++;
			$.preload.check();
		};
	
		$.preload.check = function () {
			if (this.loaded === this.total) {
				if (this.callback) {
					this.callback.call(null, this.total);
				}
			}
		};
	}).call(window);

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	//     Underscore.js 1.8.3
	//     http://underscorejs.org
	//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	//     Underscore may be freely distributed under the MIT license.
	
	(function () {
	
	  // Baseline setup
	  // --------------
	
	  // Establish the root object, `window` in the browser, or `exports` on the server.
	  var root = this;
	
	  // Save the previous value of the `_` variable.
	  var previousUnderscore = root._;
	
	  // Save bytes in the minified (but not gzipped) version:
	  var ArrayProto = Array.prototype,
	      ObjProto = Object.prototype,
	      FuncProto = Function.prototype;
	
	  // Create quick reference variables for speed access to core prototypes.
	  var push = ArrayProto.push,
	      slice = ArrayProto.slice,
	      toString = ObjProto.toString,
	      hasOwnProperty = ObjProto.hasOwnProperty;
	
	  // All **ECMAScript 5** native function implementations that we hope to use
	  // are declared here.
	  var nativeIsArray = Array.isArray,
	      nativeKeys = Object.keys,
	      nativeBind = FuncProto.bind,
	      nativeCreate = Object.create;
	
	  // Naked function reference for surrogate-prototype-swapping.
	  var Ctor = function Ctor() {};
	
	  // Create a safe reference to the Underscore object for use below.
	  var _ = function _(obj) {
	    if (obj instanceof _) return obj;
	    if (!(this instanceof _)) return new _(obj);
	    this._wrapped = obj;
	  };
	
	  // Export the Underscore object for **Node.js**, with
	  // backwards-compatibility for the old `require()` API. If we're in
	  // the browser, add `_` as a global object.
	  if (true) {
	    if (typeof module !== 'undefined' && module.exports) {
	      exports = module.exports = _;
	    }
	    exports._ = _;
	  } else {
	    root._ = _;
	  }
	
	  // Current version.
	  _.VERSION = '1.8.3';
	
	  // Internal function that returns an efficient (for current engines) version
	  // of the passed-in callback, to be repeatedly applied in other Underscore
	  // functions.
	  var optimizeCb = function optimizeCb(func, context, argCount) {
	    if (context === void 0) return func;
	    switch (argCount == null ? 3 : argCount) {
	      case 1:
	        return function (value) {
	          return func.call(context, value);
	        };
	      case 2:
	        return function (value, other) {
	          return func.call(context, value, other);
	        };
	      case 3:
	        return function (value, index, collection) {
	          return func.call(context, value, index, collection);
	        };
	      case 4:
	        return function (accumulator, value, index, collection) {
	          return func.call(context, accumulator, value, index, collection);
	        };
	    }
	    return function () {
	      return func.apply(context, arguments);
	    };
	  };
	
	  // A mostly-internal function to generate callbacks that can be applied
	  // to each element in a collection, returning the desired result — either
	  // identity, an arbitrary callback, a property matcher, or a property accessor.
	  var cb = function cb(value, context, argCount) {
	    if (value == null) return _.identity;
	    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	    if (_.isObject(value)) return _.matcher(value);
	    return _.property(value);
	  };
	  _.iteratee = function (value, context) {
	    return cb(value, context, Infinity);
	  };
	
	  // An internal function for creating assigner functions.
	  var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
	    return function (obj) {
	      var length = arguments.length;
	      if (length < 2 || obj == null) return obj;
	      for (var index = 1; index < length; index++) {
	        var source = arguments[index],
	            keys = keysFunc(source),
	            l = keys.length;
	        for (var i = 0; i < l; i++) {
	          var key = keys[i];
	          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	        }
	      }
	      return obj;
	    };
	  };
	
	  // An internal function for creating a new object that inherits from another.
	  var baseCreate = function baseCreate(prototype) {
	    if (!_.isObject(prototype)) return {};
	    if (nativeCreate) return nativeCreate(prototype);
	    Ctor.prototype = prototype;
	    var result = new Ctor();
	    Ctor.prototype = null;
	    return result;
	  };
	
	  var property = function property(key) {
	    return function (obj) {
	      return obj == null ? void 0 : obj[key];
	    };
	  };
	
	  // Helper for collection methods to determine whether a collection
	  // should be iterated as an array or as an object
	  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	  var getLength = property('length');
	  var isArrayLike = function isArrayLike(collection) {
	    var length = getLength(collection);
	    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	  };
	
	  // Collection Functions
	  // --------------------
	
	  // The cornerstone, an `each` implementation, aka `forEach`.
	  // Handles raw objects in addition to array-likes. Treats all
	  // sparse array-likes as if they were dense.
	  _.each = _.forEach = function (obj, iteratee, context) {
	    iteratee = optimizeCb(iteratee, context);
	    var i, length;
	    if (isArrayLike(obj)) {
	      for (i = 0, length = obj.length; i < length; i++) {
	        iteratee(obj[i], i, obj);
	      }
	    } else {
	      var keys = _.keys(obj);
	      for (i = 0, length = keys.length; i < length; i++) {
	        iteratee(obj[keys[i]], keys[i], obj);
	      }
	    }
	    return obj;
	  };
	
	  // Return the results of applying the iteratee to each element.
	  _.map = _.collect = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length,
	        results = Array(length);
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      results[index] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Create a reducing function iterating left or right.
	  function createReduce(dir) {
	    // Optimized iterator function as using arguments.length
	    // in the main function will deoptimize the, see #1991.
	    function iterator(obj, iteratee, memo, keys, index, length) {
	      for (; index >= 0 && index < length; index += dir) {
	        var currentKey = keys ? keys[index] : index;
	        memo = iteratee(memo, obj[currentKey], currentKey, obj);
	      }
	      return memo;
	    }
	
	    return function (obj, iteratee, memo, context) {
	      iteratee = optimizeCb(iteratee, context, 4);
	      var keys = !isArrayLike(obj) && _.keys(obj),
	          length = (keys || obj).length,
	          index = dir > 0 ? 0 : length - 1;
	      // Determine the initial value if none is provided.
	      if (arguments.length < 3) {
	        memo = obj[keys ? keys[index] : index];
	        index += dir;
	      }
	      return iterator(obj, iteratee, memo, keys, index, length);
	    };
	  }
	
	  // **Reduce** builds up a single result from a list of values, aka `inject`,
	  // or `foldl`.
	  _.reduce = _.foldl = _.inject = createReduce(1);
	
	  // The right-associative version of reduce, also known as `foldr`.
	  _.reduceRight = _.foldr = createReduce(-1);
	
	  // Return the first value which passes a truth test. Aliased as `detect`.
	  _.find = _.detect = function (obj, predicate, context) {
	    var key;
	    if (isArrayLike(obj)) {
	      key = _.findIndex(obj, predicate, context);
	    } else {
	      key = _.findKey(obj, predicate, context);
	    }
	    if (key !== void 0 && key !== -1) return obj[key];
	  };
	
	  // Return all the elements that pass a truth test.
	  // Aliased as `select`.
	  _.filter = _.select = function (obj, predicate, context) {
	    var results = [];
	    predicate = cb(predicate, context);
	    _.each(obj, function (value, index, list) {
	      if (predicate(value, index, list)) results.push(value);
	    });
	    return results;
	  };
	
	  // Return all the elements for which a truth test fails.
	  _.reject = function (obj, predicate, context) {
	    return _.filter(obj, _.negate(cb(predicate)), context);
	  };
	
	  // Determine whether all of the elements match a truth test.
	  // Aliased as `all`.
	  _.every = _.all = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (!predicate(obj[currentKey], currentKey, obj)) return false;
	    }
	    return true;
	  };
	
	  // Determine if at least one element in the object matches a truth test.
	  // Aliased as `any`.
	  _.some = _.any = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = !isArrayLike(obj) && _.keys(obj),
	        length = (keys || obj).length;
	    for (var index = 0; index < length; index++) {
	      var currentKey = keys ? keys[index] : index;
	      if (predicate(obj[currentKey], currentKey, obj)) return true;
	    }
	    return false;
	  };
	
	  // Determine if the array or object contains a given item (using `===`).
	  // Aliased as `includes` and `include`.
	  _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
	    if (!isArrayLike(obj)) obj = _.values(obj);
	    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	    return _.indexOf(obj, item, fromIndex) >= 0;
	  };
	
	  // Invoke a method (with arguments) on every item in a collection.
	  _.invoke = function (obj, method) {
	    var args = slice.call(arguments, 2);
	    var isFunc = _.isFunction(method);
	    return _.map(obj, function (value) {
	      var func = isFunc ? method : value[method];
	      return func == null ? func : func.apply(value, args);
	    });
	  };
	
	  // Convenience version of a common use case of `map`: fetching a property.
	  _.pluck = function (obj, key) {
	    return _.map(obj, _.property(key));
	  };
	
	  // Convenience version of a common use case of `filter`: selecting only objects
	  // containing specific `key:value` pairs.
	  _.where = function (obj, attrs) {
	    return _.filter(obj, _.matcher(attrs));
	  };
	
	  // Convenience version of a common use case of `find`: getting the first object
	  // containing specific `key:value` pairs.
	  _.findWhere = function (obj, attrs) {
	    return _.find(obj, _.matcher(attrs));
	  };
	
	  // Return the maximum element (or element-based computation).
	  _.max = function (obj, iteratee, context) {
	    var result = -Infinity,
	        lastComputed = -Infinity,
	        value,
	        computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Return the minimum element (or element-based computation).
	  _.min = function (obj, iteratee, context) {
	    var result = Infinity,
	        lastComputed = Infinity,
	        value,
	        computed;
	    if (iteratee == null && obj != null) {
	      obj = isArrayLike(obj) ? obj : _.values(obj);
	      for (var i = 0, length = obj.length; i < length; i++) {
	        value = obj[i];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index, list) {
	        computed = iteratee(value, index, list);
	        if (computed < lastComputed || computed === Infinity && result === Infinity) {
	          result = value;
	          lastComputed = computed;
	        }
	      });
	    }
	    return result;
	  };
	
	  // Shuffle a collection, using the modern version of the
	  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	  _.shuffle = function (obj) {
	    var set = isArrayLike(obj) ? obj : _.values(obj);
	    var length = set.length;
	    var shuffled = Array(length);
	    for (var index = 0, rand; index < length; index++) {
	      rand = _.random(0, index);
	      if (rand !== index) shuffled[index] = shuffled[rand];
	      shuffled[rand] = set[index];
	    }
	    return shuffled;
	  };
	
	  // Sample **n** random values from a collection.
	  // If **n** is not specified, returns a single random element.
	  // The internal `guard` argument allows it to work with `map`.
	  _.sample = function (obj, n, guard) {
	    if (n == null || guard) {
	      if (!isArrayLike(obj)) obj = _.values(obj);
	      return obj[_.random(obj.length - 1)];
	    }
	    return _.shuffle(obj).slice(0, Math.max(0, n));
	  };
	
	  // Sort the object's values by a criterion produced by an iteratee.
	  _.sortBy = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    return _.pluck(_.map(obj, function (value, index, list) {
	      return {
	        value: value,
	        index: index,
	        criteria: iteratee(value, index, list)
	      };
	    }).sort(function (left, right) {
	      var a = left.criteria;
	      var b = right.criteria;
	      if (a !== b) {
	        if (a > b || a === void 0) return 1;
	        if (a < b || b === void 0) return -1;
	      }
	      return left.index - right.index;
	    }), 'value');
	  };
	
	  // An internal function used for aggregate "group by" operations.
	  var group = function group(behavior) {
	    return function (obj, iteratee, context) {
	      var result = {};
	      iteratee = cb(iteratee, context);
	      _.each(obj, function (value, index) {
	        var key = iteratee(value, index, obj);
	        behavior(result, value, key);
	      });
	      return result;
	    };
	  };
	
	  // Groups the object's values by a criterion. Pass either a string attribute
	  // to group by, or a function that returns the criterion.
	  _.groupBy = group(function (result, value, key) {
	    if (_.has(result, key)) result[key].push(value);else result[key] = [value];
	  });
	
	  // Indexes the object's values by a criterion, similar to `groupBy`, but for
	  // when you know that your index values will be unique.
	  _.indexBy = group(function (result, value, key) {
	    result[key] = value;
	  });
	
	  // Counts instances of an object that group by a certain criterion. Pass
	  // either a string attribute to count by, or a function that returns the
	  // criterion.
	  _.countBy = group(function (result, value, key) {
	    if (_.has(result, key)) result[key]++;else result[key] = 1;
	  });
	
	  // Safely create a real, live array from anything iterable.
	  _.toArray = function (obj) {
	    if (!obj) return [];
	    if (_.isArray(obj)) return slice.call(obj);
	    if (isArrayLike(obj)) return _.map(obj, _.identity);
	    return _.values(obj);
	  };
	
	  // Return the number of elements in an object.
	  _.size = function (obj) {
	    if (obj == null) return 0;
	    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	  };
	
	  // Split a collection into two arrays: one whose elements all satisfy the given
	  // predicate, and one whose elements all do not satisfy the predicate.
	  _.partition = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var pass = [],
	        fail = [];
	    _.each(obj, function (value, key, obj) {
	      (predicate(value, key, obj) ? pass : fail).push(value);
	    });
	    return [pass, fail];
	  };
	
	  // Array Functions
	  // ---------------
	
	  // Get the first element of an array. Passing **n** will return the first N
	  // values in the array. Aliased as `head` and `take`. The **guard** check
	  // allows it to work with `_.map`.
	  _.first = _.head = _.take = function (array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[0];
	    return _.initial(array, array.length - n);
	  };
	
	  // Returns everything but the last entry of the array. Especially useful on
	  // the arguments object. Passing **n** will return all the values in
	  // the array, excluding the last N.
	  _.initial = function (array, n, guard) {
	    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	  };
	
	  // Get the last element of an array. Passing **n** will return the last N
	  // values in the array.
	  _.last = function (array, n, guard) {
	    if (array == null) return void 0;
	    if (n == null || guard) return array[array.length - 1];
	    return _.rest(array, Math.max(0, array.length - n));
	  };
	
	  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	  // Especially useful on the arguments object. Passing an **n** will return
	  // the rest N values in the array.
	  _.rest = _.tail = _.drop = function (array, n, guard) {
	    return slice.call(array, n == null || guard ? 1 : n);
	  };
	
	  // Trim out all falsy values from an array.
	  _.compact = function (array) {
	    return _.filter(array, _.identity);
	  };
	
	  // Internal implementation of a recursive `flatten` function.
	  var flatten = function flatten(input, shallow, strict, startIndex) {
	    var output = [],
	        idx = 0;
	    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	      var value = input[i];
	      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	        //flatten current level of array or arguments object
	        if (!shallow) value = flatten(value, shallow, strict);
	        var j = 0,
	            len = value.length;
	        output.length += len;
	        while (j < len) {
	          output[idx++] = value[j++];
	        }
	      } else if (!strict) {
	        output[idx++] = value;
	      }
	    }
	    return output;
	  };
	
	  // Flatten out an array, either recursively (by default), or just one level.
	  _.flatten = function (array, shallow) {
	    return flatten(array, shallow, false);
	  };
	
	  // Return a version of the array that does not contain the specified value(s).
	  _.without = function (array) {
	    return _.difference(array, slice.call(arguments, 1));
	  };
	
	  // Produce a duplicate-free version of the array. If the array has already
	  // been sorted, you have the option of using a faster algorithm.
	  // Aliased as `unique`.
	  _.uniq = _.unique = function (array, isSorted, iteratee, context) {
	    if (!_.isBoolean(isSorted)) {
	      context = iteratee;
	      iteratee = isSorted;
	      isSorted = false;
	    }
	    if (iteratee != null) iteratee = cb(iteratee, context);
	    var result = [];
	    var seen = [];
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var value = array[i],
	          computed = iteratee ? iteratee(value, i, array) : value;
	      if (isSorted) {
	        if (!i || seen !== computed) result.push(value);
	        seen = computed;
	      } else if (iteratee) {
	        if (!_.contains(seen, computed)) {
	          seen.push(computed);
	          result.push(value);
	        }
	      } else if (!_.contains(result, value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  };
	
	  // Produce an array that contains the union: each distinct element from all of
	  // the passed-in arrays.
	  _.union = function () {
	    return _.uniq(flatten(arguments, true, true));
	  };
	
	  // Produce an array that contains every item shared between all the
	  // passed-in arrays.
	  _.intersection = function (array) {
	    var result = [];
	    var argsLength = arguments.length;
	    for (var i = 0, length = getLength(array); i < length; i++) {
	      var item = array[i];
	      if (_.contains(result, item)) continue;
	      for (var j = 1; j < argsLength; j++) {
	        if (!_.contains(arguments[j], item)) break;
	      }
	      if (j === argsLength) result.push(item);
	    }
	    return result;
	  };
	
	  // Take the difference between one array and a number of other arrays.
	  // Only the elements present in just the first array will remain.
	  _.difference = function (array) {
	    var rest = flatten(arguments, true, true, 1);
	    return _.filter(array, function (value) {
	      return !_.contains(rest, value);
	    });
	  };
	
	  // Zip together multiple lists into a single array -- elements that share
	  // an index go together.
	  _.zip = function () {
	    return _.unzip(arguments);
	  };
	
	  // Complement of _.zip. Unzip accepts an array of arrays and groups
	  // each array's elements on shared indices
	  _.unzip = function (array) {
	    var length = array && _.max(array, getLength).length || 0;
	    var result = Array(length);
	
	    for (var index = 0; index < length; index++) {
	      result[index] = _.pluck(array, index);
	    }
	    return result;
	  };
	
	  // Converts lists into objects. Pass either a single array of `[key, value]`
	  // pairs, or two parallel arrays of the same length -- one of keys, and one of
	  // the corresponding values.
	  _.object = function (list, values) {
	    var result = {};
	    for (var i = 0, length = getLength(list); i < length; i++) {
	      if (values) {
	        result[list[i]] = values[i];
	      } else {
	        result[list[i][0]] = list[i][1];
	      }
	    }
	    return result;
	  };
	
	  // Generator function to create the findIndex and findLastIndex functions
	  function createPredicateIndexFinder(dir) {
	    return function (array, predicate, context) {
	      predicate = cb(predicate, context);
	      var length = getLength(array);
	      var index = dir > 0 ? 0 : length - 1;
	      for (; index >= 0 && index < length; index += dir) {
	        if (predicate(array[index], index, array)) return index;
	      }
	      return -1;
	    };
	  }
	
	  // Returns the first index on an array-like that passes a predicate test
	  _.findIndex = createPredicateIndexFinder(1);
	  _.findLastIndex = createPredicateIndexFinder(-1);
	
	  // Use a comparator function to figure out the smallest index at which
	  // an object should be inserted so as to maintain order. Uses binary search.
	  _.sortedIndex = function (array, obj, iteratee, context) {
	    iteratee = cb(iteratee, context, 1);
	    var value = iteratee(obj);
	    var low = 0,
	        high = getLength(array);
	    while (low < high) {
	      var mid = Math.floor((low + high) / 2);
	      if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
	    }
	    return low;
	  };
	
	  // Generator function to create the indexOf and lastIndexOf functions
	  function createIndexFinder(dir, predicateFind, sortedIndex) {
	    return function (array, item, idx) {
	      var i = 0,
	          length = getLength(array);
	      if (typeof idx == 'number') {
	        if (dir > 0) {
	          i = idx >= 0 ? idx : Math.max(idx + length, i);
	        } else {
	          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	        }
	      } else if (sortedIndex && idx && length) {
	        idx = sortedIndex(array, item);
	        return array[idx] === item ? idx : -1;
	      }
	      if (item !== item) {
	        idx = predicateFind(slice.call(array, i, length), _.isNaN);
	        return idx >= 0 ? idx + i : -1;
	      }
	      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	        if (array[idx] === item) return idx;
	      }
	      return -1;
	    };
	  }
	
	  // Return the position of the first occurrence of an item in an array,
	  // or -1 if the item is not included in the array.
	  // If the array is large and already in sort order, pass `true`
	  // for **isSorted** to use binary search.
	  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	  // Generate an integer Array containing an arithmetic progression. A port of
	  // the native Python `range()` function. See
	  // [the Python documentation](http://docs.python.org/library/functions.html#range).
	  _.range = function (start, stop, step) {
	    if (stop == null) {
	      stop = start || 0;
	      start = 0;
	    }
	    step = step || 1;
	
	    var length = Math.max(Math.ceil((stop - start) / step), 0);
	    var range = Array(length);
	
	    for (var idx = 0; idx < length; idx++, start += step) {
	      range[idx] = start;
	    }
	
	    return range;
	  };
	
	  // Function (ahem) Functions
	  // ------------------
	
	  // Determines whether to execute a function as a constructor
	  // or a normal function with the provided arguments
	  var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	    var self = baseCreate(sourceFunc.prototype);
	    var result = sourceFunc.apply(self, args);
	    if (_.isObject(result)) return result;
	    return self;
	  };
	
	  // Create a function bound to a given object (assigning `this`, and arguments,
	  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	  // available.
	  _.bind = function (func, context) {
	    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	    var args = slice.call(arguments, 2);
	    var bound = function bound() {
	      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	    };
	    return bound;
	  };
	
	  // Partially apply a function by creating a version that has had some of its
	  // arguments pre-filled, without changing its dynamic `this` context. _ acts
	  // as a placeholder, allowing any combination of arguments to be pre-filled.
	  _.partial = function (func) {
	    var boundArgs = slice.call(arguments, 1);
	    var bound = function bound() {
	      var position = 0,
	          length = boundArgs.length;
	      var args = Array(length);
	      for (var i = 0; i < length; i++) {
	        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	      }
	      while (position < arguments.length) {
	        args.push(arguments[position++]);
	      }return executeBound(func, bound, this, this, args);
	    };
	    return bound;
	  };
	
	  // Bind a number of an object's methods to that object. Remaining arguments
	  // are the method names to be bound. Useful for ensuring that all callbacks
	  // defined on an object belong to it.
	  _.bindAll = function (obj) {
	    var i,
	        length = arguments.length,
	        key;
	    if (length <= 1) throw new Error('bindAll must be passed function names');
	    for (i = 1; i < length; i++) {
	      key = arguments[i];
	      obj[key] = _.bind(obj[key], obj);
	    }
	    return obj;
	  };
	
	  // Memoize an expensive function by storing its results.
	  _.memoize = function (func, hasher) {
	    var memoize = function memoize(key) {
	      var cache = memoize.cache;
	      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	      return cache[address];
	    };
	    memoize.cache = {};
	    return memoize;
	  };
	
	  // Delays a function for the given number of milliseconds, and then calls
	  // it with the arguments supplied.
	  _.delay = function (func, wait) {
	    var args = slice.call(arguments, 2);
	    return setTimeout(function () {
	      return func.apply(null, args);
	    }, wait);
	  };
	
	  // Defers a function, scheduling it to run after the current call stack has
	  // cleared.
	  _.defer = _.partial(_.delay, _, 1);
	
	  // Returns a function, that, when invoked, will only be triggered at most once
	  // during a given window of time. Normally, the throttled function will run
	  // as much as it can, without ever going more than once per `wait` duration;
	  // but if you'd like to disable the execution on the leading edge, pass
	  // `{leading: false}`. To disable execution on the trailing edge, ditto.
	  _.throttle = function (func, wait, options) {
	    var context, args, result;
	    var timeout = null;
	    var previous = 0;
	    if (!options) options = {};
	    var later = function later() {
	      previous = options.leading === false ? 0 : _.now();
	      timeout = null;
	      result = func.apply(context, args);
	      if (!timeout) context = args = null;
	    };
	    return function () {
	      var now = _.now();
	      if (!previous && options.leading === false) previous = now;
	      var remaining = wait - (now - previous);
	      context = this;
	      args = arguments;
	      if (remaining <= 0 || remaining > wait) {
	        if (timeout) {
	          clearTimeout(timeout);
	          timeout = null;
	        }
	        previous = now;
	        result = func.apply(context, args);
	        if (!timeout) context = args = null;
	      } else if (!timeout && options.trailing !== false) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  // Returns a function, that, as long as it continues to be invoked, will not
	  // be triggered. The function will be called after it stops being called for
	  // N milliseconds. If `immediate` is passed, trigger the function on the
	  // leading edge, instead of the trailing.
	  _.debounce = function (func, wait, immediate) {
	    var timeout, args, context, timestamp, result;
	
	    var later = function later() {
	      var last = _.now() - timestamp;
	
	      if (last < wait && last >= 0) {
	        timeout = setTimeout(later, wait - last);
	      } else {
	        timeout = null;
	        if (!immediate) {
	          result = func.apply(context, args);
	          if (!timeout) context = args = null;
	        }
	      }
	    };
	
	    return function () {
	      context = this;
	      args = arguments;
	      timestamp = _.now();
	      var callNow = immediate && !timeout;
	      if (!timeout) timeout = setTimeout(later, wait);
	      if (callNow) {
	        result = func.apply(context, args);
	        context = args = null;
	      }
	
	      return result;
	    };
	  };
	
	  // Returns the first function passed as an argument to the second,
	  // allowing you to adjust arguments, run code before and after, and
	  // conditionally execute the original function.
	  _.wrap = function (func, wrapper) {
	    return _.partial(wrapper, func);
	  };
	
	  // Returns a negated version of the passed-in predicate.
	  _.negate = function (predicate) {
	    return function () {
	      return !predicate.apply(this, arguments);
	    };
	  };
	
	  // Returns a function that is the composition of a list of functions, each
	  // consuming the return value of the function that follows.
	  _.compose = function () {
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	      var i = start;
	      var result = args[start].apply(this, arguments);
	      while (i--) {
	        result = args[i].call(this, result);
	      }return result;
	    };
	  };
	
	  // Returns a function that will only be executed on and after the Nth call.
	  _.after = function (times, func) {
	    return function () {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  // Returns a function that will only be executed up to (but not including) the Nth call.
	  _.before = function (times, func) {
	    var memo;
	    return function () {
	      if (--times > 0) {
	        memo = func.apply(this, arguments);
	      }
	      if (times <= 1) func = null;
	      return memo;
	    };
	  };
	
	  // Returns a function that will be executed at most one time, no matter how
	  // often you call it. Useful for lazy initialization.
	  _.once = _.partial(_.before, 2);
	
	  // Object Functions
	  // ----------------
	
	  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	  var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
	  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	  function collectNonEnumProps(obj, keys) {
	    var nonEnumIdx = nonEnumerableProps.length;
	    var constructor = obj.constructor;
	    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
	
	    // Constructor is a special case.
	    var prop = 'constructor';
	    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	    while (nonEnumIdx--) {
	      prop = nonEnumerableProps[nonEnumIdx];
	      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	        keys.push(prop);
	      }
	    }
	  }
	
	  // Retrieve the names of an object's own properties.
	  // Delegates to **ECMAScript 5**'s native `Object.keys`
	  _.keys = function (obj) {
	    if (!_.isObject(obj)) return [];
	    if (nativeKeys) return nativeKeys(obj);
	    var keys = [];
	    for (var key in obj) {
	      if (_.has(obj, key)) keys.push(key);
	    } // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve all the property names of an object.
	  _.allKeys = function (obj) {
	    if (!_.isObject(obj)) return [];
	    var keys = [];
	    for (var key in obj) {
	      keys.push(key);
	    } // Ahem, IE < 9.
	    if (hasEnumBug) collectNonEnumProps(obj, keys);
	    return keys;
	  };
	
	  // Retrieve the values of an object's properties.
	  _.values = function (obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var values = Array(length);
	    for (var i = 0; i < length; i++) {
	      values[i] = obj[keys[i]];
	    }
	    return values;
	  };
	
	  // Returns the results of applying the iteratee to each element of the object
	  // In contrast to _.map it returns an object
	  _.mapObject = function (obj, iteratee, context) {
	    iteratee = cb(iteratee, context);
	    var keys = _.keys(obj),
	        length = keys.length,
	        results = {},
	        currentKey;
	    for (var index = 0; index < length; index++) {
	      currentKey = keys[index];
	      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	    }
	    return results;
	  };
	
	  // Convert an object into a list of `[key, value]` pairs.
	  _.pairs = function (obj) {
	    var keys = _.keys(obj);
	    var length = keys.length;
	    var pairs = Array(length);
	    for (var i = 0; i < length; i++) {
	      pairs[i] = [keys[i], obj[keys[i]]];
	    }
	    return pairs;
	  };
	
	  // Invert the keys and values of an object. The values must be serializable.
	  _.invert = function (obj) {
	    var result = {};
	    var keys = _.keys(obj);
	    for (var i = 0, length = keys.length; i < length; i++) {
	      result[obj[keys[i]]] = keys[i];
	    }
	    return result;
	  };
	
	  // Return a sorted list of the function names available on the object.
	  // Aliased as `methods`
	  _.functions = _.methods = function (obj) {
	    var names = [];
	    for (var key in obj) {
	      if (_.isFunction(obj[key])) names.push(key);
	    }
	    return names.sort();
	  };
	
	  // Extend a given object with all the properties in passed-in object(s).
	  _.extend = createAssigner(_.allKeys);
	
	  // Assigns a given object with all the own properties in the passed-in object(s)
	  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	  _.extendOwn = _.assign = createAssigner(_.keys);
	
	  // Returns the first key on an object that passes a predicate test
	  _.findKey = function (obj, predicate, context) {
	    predicate = cb(predicate, context);
	    var keys = _.keys(obj),
	        key;
	    for (var i = 0, length = keys.length; i < length; i++) {
	      key = keys[i];
	      if (predicate(obj[key], key, obj)) return key;
	    }
	  };
	
	  // Return a copy of the object only containing the whitelisted properties.
	  _.pick = function (object, oiteratee, context) {
	    var result = {},
	        obj = object,
	        iteratee,
	        keys;
	    if (obj == null) return result;
	    if (_.isFunction(oiteratee)) {
	      keys = _.allKeys(obj);
	      iteratee = optimizeCb(oiteratee, context);
	    } else {
	      keys = flatten(arguments, false, false, 1);
	      iteratee = function iteratee(value, key, obj) {
	        return key in obj;
	      };
	      obj = Object(obj);
	    }
	    for (var i = 0, length = keys.length; i < length; i++) {
	      var key = keys[i];
	      var value = obj[key];
	      if (iteratee(value, key, obj)) result[key] = value;
	    }
	    return result;
	  };
	
	  // Return a copy of the object without the blacklisted properties.
	  _.omit = function (obj, iteratee, context) {
	    if (_.isFunction(iteratee)) {
	      iteratee = _.negate(iteratee);
	    } else {
	      var keys = _.map(flatten(arguments, false, false, 1), String);
	      iteratee = function iteratee(value, key) {
	        return !_.contains(keys, key);
	      };
	    }
	    return _.pick(obj, iteratee, context);
	  };
	
	  // Fill in a given object with default properties.
	  _.defaults = createAssigner(_.allKeys, true);
	
	  // Creates an object that inherits from the given prototype object.
	  // If additional properties are provided then they will be added to the
	  // created object.
	  _.create = function (prototype, props) {
	    var result = baseCreate(prototype);
	    if (props) _.extendOwn(result, props);
	    return result;
	  };
	
	  // Create a (shallow-cloned) duplicate of an object.
	  _.clone = function (obj) {
	    if (!_.isObject(obj)) return obj;
	    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	  };
	
	  // Invokes interceptor with the obj, and then returns obj.
	  // The primary purpose of this method is to "tap into" a method chain, in
	  // order to perform operations on intermediate results within the chain.
	  _.tap = function (obj, interceptor) {
	    interceptor(obj);
	    return obj;
	  };
	
	  // Returns whether an object has a given set of `key:value` pairs.
	  _.isMatch = function (object, attrs) {
	    var keys = _.keys(attrs),
	        length = keys.length;
	    if (object == null) return !length;
	    var obj = Object(object);
	    for (var i = 0; i < length; i++) {
	      var key = keys[i];
	      if (attrs[key] !== obj[key] || !(key in obj)) return false;
	    }
	    return true;
	  };
	
	  // Internal recursive comparison function for `isEqual`.
	  var eq = function eq(a, b, aStack, bStack) {
	    // Identical objects are equal. `0 === -0`, but they aren't identical.
	    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	    if (a === b) return a !== 0 || 1 / a === 1 / b;
	    // A strict comparison is necessary because `null == undefined`.
	    if (a == null || b == null) return a === b;
	    // Unwrap any wrapped objects.
	    if (a instanceof _) a = a._wrapped;
	    if (b instanceof _) b = b._wrapped;
	    // Compare `[[Class]]` names.
	    var className = toString.call(a);
	    if (className !== toString.call(b)) return false;
	    switch (className) {
	      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	      case '[object RegExp]':
	      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	      case '[object String]':
	        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	        // equivalent to `new String("5")`.
	        return '' + a === '' + b;
	      case '[object Number]':
	        // `NaN`s are equivalent, but non-reflexive.
	        // Object(NaN) is equivalent to NaN
	        if (+a !== +a) return +b !== +b;
	        // An `egal` comparison is performed for other numeric values.
	        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	      case '[object Date]':
	      case '[object Boolean]':
	        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	        // millisecond representations. Note that invalid dates with millisecond representations
	        // of `NaN` are not equivalent.
	        return +a === +b;
	    }
	
	    var areArrays = className === '[object Array]';
	    if (!areArrays) {
	      if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) != 'object' || (typeof b === 'undefined' ? 'undefined' : _typeof(b)) != 'object') return false;
	
	      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	      // from different frames are.
	      var aCtor = a.constructor,
	          bCtor = b.constructor;
	      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
	        return false;
	      }
	    }
	    // Assume equality for cyclic structures. The algorithm for detecting cyclic
	    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	    // Initializing stack of traversed objects.
	    // It's done here since we only need them for objects and arrays comparison.
	    aStack = aStack || [];
	    bStack = bStack || [];
	    var length = aStack.length;
	    while (length--) {
	      // Linear search. Performance is inversely proportional to the number of
	      // unique nested structures.
	      if (aStack[length] === a) return bStack[length] === b;
	    }
	
	    // Add the first object to the stack of traversed objects.
	    aStack.push(a);
	    bStack.push(b);
	
	    // Recursively compare objects and arrays.
	    if (areArrays) {
	      // Compare array lengths to determine if a deep comparison is necessary.
	      length = a.length;
	      if (length !== b.length) return false;
	      // Deep compare the contents, ignoring non-numeric properties.
	      while (length--) {
	        if (!eq(a[length], b[length], aStack, bStack)) return false;
	      }
	    } else {
	      // Deep compare objects.
	      var keys = _.keys(a),
	          key;
	      length = keys.length;
	      // Ensure that both objects contain the same number of properties before comparing deep equality.
	      if (_.keys(b).length !== length) return false;
	      while (length--) {
	        // Deep compare each member
	        key = keys[length];
	        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	      }
	    }
	    // Remove the first object from the stack of traversed objects.
	    aStack.pop();
	    bStack.pop();
	    return true;
	  };
	
	  // Perform a deep comparison to check if two objects are equal.
	  _.isEqual = function (a, b) {
	    return eq(a, b);
	  };
	
	  // Is a given array, string, or object empty?
	  // An "empty" object has no enumerable own-properties.
	  _.isEmpty = function (obj) {
	    if (obj == null) return true;
	    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	    return _.keys(obj).length === 0;
	  };
	
	  // Is a given value a DOM element?
	  _.isElement = function (obj) {
	    return !!(obj && obj.nodeType === 1);
	  };
	
	  // Is a given value an array?
	  // Delegates to ECMA5's native Array.isArray
	  _.isArray = nativeIsArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	  };
	
	  // Is a given variable an object?
	  _.isObject = function (obj) {
	    var type = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	    return type === 'function' || type === 'object' && !!obj;
	  };
	
	  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
	    _['is' + name] = function (obj) {
	      return toString.call(obj) === '[object ' + name + ']';
	    };
	  });
	
	  // Define a fallback version of the method in browsers (ahem, IE < 9), where
	  // there isn't any inspectable "Arguments" type.
	  if (!_.isArguments(arguments)) {
	    _.isArguments = function (obj) {
	      return _.has(obj, 'callee');
	    };
	  }
	
	  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	  // IE 11 (#1621), and in Safari 8 (#1929).
	  if (typeof /./ != 'function' && (typeof Int8Array === 'undefined' ? 'undefined' : _typeof(Int8Array)) != 'object') {
	    _.isFunction = function (obj) {
	      return typeof obj == 'function' || false;
	    };
	  }
	
	  // Is a given object a finite number?
	  _.isFinite = function (obj) {
	    return isFinite(obj) && !isNaN(parseFloat(obj));
	  };
	
	  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	  _.isNaN = function (obj) {
	    return _.isNumber(obj) && obj !== +obj;
	  };
	
	  // Is a given value a boolean?
	  _.isBoolean = function (obj) {
	    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	  };
	
	  // Is a given value equal to null?
	  _.isNull = function (obj) {
	    return obj === null;
	  };
	
	  // Is a given variable undefined?
	  _.isUndefined = function (obj) {
	    return obj === void 0;
	  };
	
	  // Shortcut function for checking if an object has a given property directly
	  // on itself (in other words, not on a prototype).
	  _.has = function (obj, key) {
	    return obj != null && hasOwnProperty.call(obj, key);
	  };
	
	  // Utility Functions
	  // -----------------
	
	  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	  // previous owner. Returns a reference to the Underscore object.
	  _.noConflict = function () {
	    root._ = previousUnderscore;
	    return this;
	  };
	
	  // Keep the identity function around for default iteratees.
	  _.identity = function (value) {
	    return value;
	  };
	
	  // Predicate-generating functions. Often useful outside of Underscore.
	  _.constant = function (value) {
	    return function () {
	      return value;
	    };
	  };
	
	  _.noop = function () {};
	
	  _.property = property;
	
	  // Generates a function for a given object that returns a given property.
	  _.propertyOf = function (obj) {
	    return obj == null ? function () {} : function (key) {
	      return obj[key];
	    };
	  };
	
	  // Returns a predicate for checking whether an object has a given set of
	  // `key:value` pairs.
	  _.matcher = _.matches = function (attrs) {
	    attrs = _.extendOwn({}, attrs);
	    return function (obj) {
	      return _.isMatch(obj, attrs);
	    };
	  };
	
	  // Run a function **n** times.
	  _.times = function (n, iteratee, context) {
	    var accum = Array(Math.max(0, n));
	    iteratee = optimizeCb(iteratee, context, 1);
	    for (var i = 0; i < n; i++) {
	      accum[i] = iteratee(i);
	    }return accum;
	  };
	
	  // Return a random integer between min and max (inclusive).
	  _.random = function (min, max) {
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  // A (possibly faster) way to get the current timestamp as an integer.
	  _.now = Date.now || function () {
	    return new Date().getTime();
	  };
	
	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };
	  var unescapeMap = _.invert(escapeMap);
	
	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function createEscaper(map) {
	    var escaper = function escaper(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped
	    var source = '(?:' + _.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function (string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };
	  _.escape = createEscaper(escapeMap);
	  _.unescape = createEscaper(unescapeMap);
	
	  // If the value of the named `property` is a function then invoke it with the
	  // `object` as context; otherwise, return it.
	  _.result = function (object, property, fallback) {
	    var value = object == null ? void 0 : object[property];
	    if (value === void 0) {
	      value = fallback;
	    }
	    return _.isFunction(value) ? value.call(object) : value;
	  };
	
	  // Generate a unique integer id (unique within the entire client session).
	  // Useful for temporary DOM ids.
	  var idCounter = 0;
	  _.uniqueId = function (prefix) {
	    var id = ++idCounter + '';
	    return prefix ? prefix + id : id;
	  };
	
	  // By default, Underscore uses ERB-style template delimiters, change the
	  // following template settings to use alternative delimiters.
	  _.templateSettings = {
	    evaluate: /<%([\s\S]+?)%>/g,
	    interpolate: /<%=([\s\S]+?)%>/g,
	    escape: /<%-([\s\S]+?)%>/g
	  };
	
	  // When customizing `templateSettings`, if you don't want to define an
	  // interpolation, evaluation or escaping regex, we need one that is
	  // guaranteed not to match.
	  var noMatch = /(.)^/;
	
	  // Certain characters need to be escaped so that they can be put into a
	  // string literal.
	  var escapes = {
	    "'": "'",
	    '\\': '\\',
	    '\r': 'r',
	    '\n': 'n',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	  var escapeChar = function escapeChar(match) {
	    return '\\' + escapes[match];
	  };
	
	  // JavaScript micro-templating, similar to John Resig's implementation.
	  // Underscore templating handles arbitrary delimiters, preserves whitespace,
	  // and correctly escapes quotes within interpolated code.
	  // NB: `oldSettings` only exists for backwards compatibility.
	  _.template = function (text, settings, oldSettings) {
	    if (!settings && oldSettings) settings = oldSettings;
	    settings = _.defaults({}, settings, _.templateSettings);
	
	    // Combine delimiters into one regular expression via alternation.
	    var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');
	
	    // Compile the template source, escaping string literals appropriately.
	    var index = 0;
	    var source = "__p+='";
	    text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
	      source += text.slice(index, offset).replace(escaper, escapeChar);
	      index = offset + match.length;
	
	      if (escape) {
	        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	      } else if (interpolate) {
	        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	      } else if (evaluate) {
	        source += "';\n" + evaluate + "\n__p+='";
	      }
	
	      // Adobe VMs need the match returned to produce the correct offest.
	      return match;
	    });
	    source += "';\n";
	
	    // If a variable is not specified, place data values in local scope.
	    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	    source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
	
	    try {
	      var render = new Function(settings.variable || 'obj', '_', source);
	    } catch (e) {
	      e.source = source;
	      throw e;
	    }
	
	    var template = function template(data) {
	      return render.call(this, data, _);
	    };
	
	    // Provide the compiled source as a convenience for precompilation.
	    var argument = settings.variable || 'obj';
	    template.source = 'function(' + argument + '){\n' + source + '}';
	
	    return template;
	  };
	
	  // Add a "chain" function. Start chaining a wrapped Underscore object.
	  _.chain = function (obj) {
	    var instance = _(obj);
	    instance._chain = true;
	    return instance;
	  };
	
	  // OOP
	  // ---------------
	  // If Underscore is called as a function, it returns a wrapped object that
	  // can be used OO-style. This wrapper holds altered versions of all the
	  // underscore functions. Wrapped objects may be chained.
	
	  // Helper function to continue chaining intermediate results.
	  var result = function result(instance, obj) {
	    return instance._chain ? _(obj).chain() : obj;
	  };
	
	  // Add your own custom functions to the Underscore object.
	  _.mixin = function (obj) {
	    _.each(_.functions(obj), function (name) {
	      var func = _[name] = obj[name];
	      _.prototype[name] = function () {
	        var args = [this._wrapped];
	        push.apply(args, arguments);
	        return result(this, func.apply(_, args));
	      };
	    });
	  };
	
	  // Add all of the Underscore functions to the wrapper object.
	  _.mixin(_);
	
	  // Add all mutator Array functions to the wrapper.
	  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function () {
	      var obj = this._wrapped;
	      method.apply(obj, arguments);
	      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	      return result(this, obj);
	    };
	  });
	
	  // Add all accessor Array functions to the wrapper.
	  _.each(['concat', 'join', 'slice'], function (name) {
	    var method = ArrayProto[name];
	    _.prototype[name] = function () {
	      return result(this, method.apply(this._wrapped, arguments));
	    };
	  });
	
	  // Extracts the result from a wrapped and chained object.
	  _.prototype.value = function () {
	    return this._wrapped;
	  };
	
	  // Provide unwrapping proxy for some methods used in engine operations
	  // such as arithmetic and JSON stringification.
	  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	  _.prototype.toString = function () {
	    return '' + this._wrapped;
	  };
	
	  // AMD registration happens at the end for compatibility with AMD loaders
	  // that may not enforce next-turn semantics on modules. Even though general
	  // practice for AMD registration is to be anonymous, underscore registers
	  // as a named module because, like jQuery, it is a base library that is
	  // popular enough to be bundled in a third party lib, but not be part of
	  // an AMD load request. Those cases could generate an error when an
	  // anonymous define() is called outside of a loader request.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return _;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	}).call(undefined);

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	/* globals OldSoundManager, loader */
	
	__webpack_require__(8);
	
	var SoundManager = window.SoundManager = function (sounds, gametype, callback) {
		if (typeof AudioContext === 'undefined') {
			window.AudioContext = window.AudioContext || window.webkitAudioContext;
		}
	
		if (typeof AudioContext !== 'undefined') {
			this.context = new AudioContext();
		}
	
		if (!this.context) {
			console.log('Setting SoundManager to legacy mode.');
	
			return new OldSoundManager(gametype, callback);
		}
	
		var audio = new Audio();
	
		this.path = base;
	
		if (!audio.canPlayType('audio/mpeg')) {
			return callback && callback(false);
		}
	
		if (!this.context.createGain && this.context.createGainNode) {
			this.context.createGain = this.context.createGainNode;
		}
	
		this.ready = false;
	
		var gain = this.context.createGain();
		gain.connect(this.context.destination);
		this.gain = gain.gain;
	
		this.destination = gain;
	
		this.sounds = {};
		this.sources = {};
	
		this.requested = 0;
		this.responsed = 0;
	
		this.callback = callback;
	
		this.loadSounds(sounds);
	};
	
	SoundManager.prototype.volume = function (value) {
		this.gain.value = value;
	};
	
	SoundManager.prototype.loaded = function () {
		if (!this.context) {
			return this;
		}
	
		if (this.responsed !== this.requested) {
			return this;
		}
	
		this.ready = true;
	
		if (this.callback) {
			this.callback(this.requested);
		}
	
		return this;
	};
	
	SoundManager.prototype.loadSounds = function (sounds, prefix, base, store) {
		if (!this.context) {
			return this;
		}
	
		if (!sounds) {
			return this;
		}
	
		if (typeof store === 'undefined') {
			store = this.sounds;
		}
	
		if (prefix && typeof prefix === 'string') {
			prefix = [prefix];
		}
	
		if (!prefix) {
			prefix = [];
		}
	
		for (var name in sounds) {
			prefix.push(name);
	
			if (sounds[name] === null) {
				delete store[name];
			} else if (sounds[name] instanceof Array) {
				if (!store[name]) {
					store[name] = [];
				}
	
				for (var i = 0; i < sounds[name].length; i++) {
					if (sounds[name][i] === null) {
						delete store[name][i];
						continue;
					}
	
					prefix.push(i);
					store[name][i] = sounds[name][i];
					this._load(prefix, store[name], i);
					prefix.pop();
				}
			} else if (_typeof(sounds[name]) === 'object') {
				if (!store[name]) {
					store[name] = {};
				}
	
				this.loadSounds(sounds[name], prefix, base, store[name]);
			} else if (typeof sounds[name] === 'string') {
				store[name] = sounds[name];
				this._load(prefix, store, name);
			}
	
			prefix.pop();
		}
	
		return this;
	};
	
	SoundManager.prototype._load = function (prefix, store, key) {
		if (!this.context) {
			return this;
		}
	
		loader.count(true);
		loader.count(true);
		this.requested++;
	
		store[key] = this.path + store[key];
	
		var request = new XMLHttpRequest();
		request.open('GET', store[key], true);
		request.responseType = 'arraybuffer';
	
		var that = this;
		request.onerror = function () {
			delete store[key];
			loader.count(false);
			loader.count(false);
			that.responsed++;
			that.loaded();
		};
	
		var original = store[key];
		request.onload = function () {
			loader.count(false);
	
			/* jscs:disable requirePaddingNewLinesAfterBlocks */
			that.context.decodeAudioData(request.response, function (buffer) {
				if (store[key] === original) {
					store[key] = buffer;
				}
	
				loader.count(false);
				that.responsed++;
				that.loaded();
			}, function () {
				if (store[key] === original) {
					delete store[key];
				}
	
				loader.count(false);
				that.responsed++;
				that.loaded();
			});
			/* jscs:enable requirePaddingNewLinesAfterBlocks */
		};
	
		request.send();
	
		return this;
	};
	
	SoundManager.prototype._play = function (buffer, options) {
		if (!options) {
			options = {};
		}
	
		if (typeof options === 'number') {
			options = { time: options };
		}
	
		if (typeof options === 'boolean') {
			options = { loop: options };
		}
	
		if (options.time) {
			options.time += this.context.currentTime;
		} else {
			options.time = 0;
		}
	
		var source = this.context.createBufferSource();
		source.buffer = buffer;
	
		if (options.loop) {
			source.loop = true;
		}
	
		if (source.gain) {
			source.connect(this.destination);
		} else {
			var gain = this.context.createGain();
			gain.connect(this.destination);
			source.connect(gain);
	
			source.gain = gain.gain;
		}
	
		if (options.gain) {
			source.gain.value = options.gain;
		}
	
		if (!source.start && source.noteOn) {
			source.start = source.noteOn;
		}
	
		if (options.detune && source.detune) {
			source.detune.value = options.detune;
		}
	
		source.playing = true;
		source.start(options.time);
	
		return source;
	};
	
	SoundManager.prototype._stop = function (source, options) {
		if (!options) {
			options = {};
		}
	
		if (typeof options === 'number') {
			options = { time: options };
		}
	
		if (options.time) {
			options.time += this.context.currentTime;
		} else {
			options.time = 0;
		}
	
		if (!source.stop && source.noteOff) {
			source.stop = source.noteOff;
		}
	
		if (source.constructor.prototype.hasOwnProperty('isPrototypeOf')) {
			for (var s in source) {
				if (source[s].playing) {
					this._stop(source[s], options);
					source[s].playing = false;
				}
			}
		} else {
			if (source.playing) {
				source.stop(options.time);
				source.playing = false;
			}
		}
	
		return this;
	};
	
	SoundManager.prototype._source = function (path, buff) {
		var source = this.sources;
		var buffer = buff ? this.sounds : null;
	
		for (var p = 0; p <= path.length - (buff ? 2 : 1); p++) {
			if (!source[path[p]]) {
				if (buff) {
					source[path[p]] = {};
				} else {
					return null;
				}
			}
	
			source = source[path[p]];
	
			if (buff) {
				if (!buffer[path[p]]) {
					return null;
				}
	
				buffer = buffer[path[p]];
			}
		}
	
		if (buff) {
			if ((typeof path[path.length - 1] !== 'number' || buffer.constructor !== Object) && !buffer[path[path.length - 1]]) {
				return null;
			}
	
			return [source, buffer];
		} else {
			return source;
		}
	};
	
	SoundManager.prototype.fade = function (path, start, end, time) {
		if (!this.context || !this.ready) {
			return this;
		}
	
		if (typeof path === 'string') {
			path = [path];
		}
	
		var source = this._source(path);
	
		if (!source) {
			return this;
		}
	
		var now = this.context.currentTime;
		source.gain.setValueAtTime(start, now);
		source.gain.linearRampToValueAtTime(end, now + time);
	
		return this;
	};
	
	SoundManager.prototype.play = function (path, options) {
		if (!this.context || !this.ready) {
			return this;
		}
	
		if (typeof path === 'string') {
			path = [path];
		}
	
		var temp = this._source(path, true);
	
		if (!temp) {
			return null;
		}
	
		var source = temp[0];
		var buffer = temp[1];
	
		if (!buffer[path[path.length - 1]]) {
			if (typeof path[path.length - 1] === 'number' && buffer.constructor === Array) {
				path[path.length - 1] = path[path.length - 1] % buffer.length;
			} else if (typeof path[path.length - 1] === 'number' && buffer.constructor === Object) {
				for (var k in buffer) {
					if (path[path.length - 1] >= k) {
						path[path.length - 1] = k;
						break;
					}
				}
	
				if (!buffer[path[path.length - 1]]) {
					return null;
				}
			} else {
				return null;
			}
		}
	
		buffer = buffer[path[path.length - 1]];
	
		if (buffer instanceof Array) {
			var i = Math.floor(Math.random() * buffer.length);
			buffer = buffer[i];
		}
	
		if (typeof buffer === 'string') {
			return null;
		}
	
		source[path[path.length - 1]] = this._play(buffer, options);
	
		return source[path[path.length - 1]];
	};
	
	SoundManager.prototype.stop = function (path, options) {
		if (!this.context || !this.ready) {
			return this;
		}
	
		if (typeof path === 'string') {
			path = [path];
		}
	
		var source = this._source(path);
	
		if (!source) {
			return this;
		}
	
		this._stop(source, options);
	
		return this;
	};

/***/ },
/* 8 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OldSoundManager = window.OldSoundManager = function (fallback, callback) {
		this.ready = false;
		this.sounds = {};
	
		this.context = {
			get currentTime() {
				return Date.now() / 1000;
			}
		};
	
		if (fallback === 'slot') {
			fallback = {
				// button: [ 0, 0.444 ],
				spin: [45.362, 0.640],
				win: {
					win_1: [1, 1.619],
					win_2: [3, 3.004],
					win_3: [7, 5.093],
					bigwin_1: [13, 6.608],
					bigwin_2: [19, 5.799],
					bigwin_3: [27, 5.799]
				},
				buttons: {
					auto: [39.620, 0.276],
					denom: [40.000, 0.5],
					menu2: [40.600, 0.218],
					help: [40.802, 0.349],
					max: [41.684, 1.120],
					lobby: [43.219, 0.407],
					menu: [43.719, 0.204],
					recall: [43.966, 0.378],
					sound: [44.500, 0.5],
					spin: [45.362, 0.640],
					autos: {
						auto_0: [46.000, 0.287],
						auto_1: [46.290, 0.313],
						auto_2: [46.600, 0.313],
						auto_3: [46.916, 0.313],
						auto_4: [47.229, 0.313],
						auto_5: [47.543, 0.313],
						auto_6: [47.856, 0.144]
					},
					coins: {
						bet_0: [48.486, 0.627],
						bet_1: [49.113, 0.627],
						bet_2: [49.740, 0.627],
						bet_3: [50.367, 0.627],
						bet_4: [50.993, 0.627],
						bet_5: [51.620, 0.627]
					},
					denoms: {
						denom_0: [52.247, 0.313],
						denom_1: [52.656, 0.470],
						denom_2: [53.030, 0.731],
						denom_3: [53.762, 1.202],
						denom_4: [55.128, 1.750],
						denom_5: [56.878, 0.862],
						denom_6: [57.740, 0.862]
					},
					lines: {
						line_0: [58.602, 0.287],
						line_1: [58.890, 0.287],
						line_2: [59.177, 0.261],
						line_3: [59.438, 0.235],
						line_4: [59.673, 0.235],
						line_5: [59.910, 0.235]
					}
				},
				reels: [34, 0.261],
				bell: [35, 4.362]
			};
		}
	
		if (fallback === 'bingo') {
			fallback = {
				// button: [ 0, 0.444 ],
				win: {
					win_1: [1, 1.619],
					win_2: [3, 3.004],
					win_3: [7, 5.093],
					bigwin_1: [13, 6.608],
					bigwin_2: [19, 5.799],
					bigwin_3: [27, 5.799]
				},
	
				ball: [34.15, 0.182],
				deal: [35.00, 1.097],
				extra: [37.00, 3.840],
	
				buttons: {
					auto: [41.000, 0.200],
					denom: [41.750, 0.200],
					menu2: [42.000, 0.338],
					lobby: [42.441, 0.270],
					max: [43.300, 1.100],
					help: [44.850, 0.301],
					menu: [45.129, 0.200],
					recall: [45.500, 0.323],
					sound: [46.200, 0.361],
					spin: [46.964, 0.579],
					denoms: {
						denom_0: [47.543, 0.313],
						denom_1: [47.856, 0.470],
						denom_2: [48.327, 0.731],
						denom_3: [49.058, 1.202],
						denom_4: [50.260, 1.750],
						denom_5: [52.010, 0.862],
						denom_6: [52.872, 0.862]
					},
					coins: {
						bet_0: [53.734, 0.627],
						bet_1: [54.361, 0.627],
						bet_2: [54.988, 0.627],
						bet_3: [55.615, 0.627],
						bet_4: [56.242, 0.627],
						bet_5: [56.869, 0.627]
					}
				},
				spin: [46.964, 0.579]
			};
		}
	
		if (fallback === 'poker') {
			fallback = {
				win: {
					win_1: [1, 1.619],
					win_2: [3, 3.004],
					win_3: [7, 5.093],
					bigwin_1: [13, 6.608],
					bigwin_2: [19, 5.799],
					bigwin_3: [27, 5.799]
				},
	
				card: [34, 0.200],
				hold: [35, 0.200],
				done: [[36, 0.548], [37, 0.548], [38, 0.548]],
				feature: {
					spin: [40, 3.840],
					activate: [45, 0.731]
				},
				buttons: {
					denom: [46.500, 0.365],
					menu2: [47.000, 0.281],
					help: [47.338, 0.365],
					max: [48.000, 1.224],
					lobby: [49.743, 0.415],
					menu: [50.100, 0.232],
					recall: [50.456, 0.348],
					sound: [51.000, 0.400],
					spin: [51.883, 0.597],
					coins: {
						bet_0: [52.480, 0.627],
						bet_1: [53.107, 0.627],
						bet_2: [53.734, 0.627],
						bet_3: [54.361, 0.627],
						bet_4: [54.988, 0.627],
						bet_5: [55.615, 0.627]
					},
					denoms: {
						denom_0: [56.242, 0.313],
						denom_1: [56.555, 0.470],
						denom_2: [57.025, 0.731],
						denom_3: [57.757, 1.202],
						denom_4: [58.958, 1.750],
						denom_5: [60.710, 0.862],
						denom_6: [61.571, 0.862]
					}
				},
				spin: [51.883, 0.597]
			};
		}
		if (fallback === 'keno') {
			var _buttons;
	
			fallback = {
				//	draw: [ 0, 0.5 ],
				buttons: (_buttons = {
					miss: [0.50, 0.3],
					quick: [0.80, 1.30],
					max: [2.10, 1.64],
					denom: [4, 1.43],
					clear: [5.5, 1.69]
				}, _defineProperty(_buttons, 'denom', [7.50, 1.43]), _defineProperty(_buttons, 'cash_flag', [9, 1.25]), _defineProperty(_buttons, 'bet_up', [10.5, 1.41]), _defineProperty(_buttons, 'bet_down', [12, 1.3]), _defineProperty(_buttons, 'speeds', {
					speed1: [13.5, 2],
					speed2: [15.54, 1.93],
					speed3: [17.48, 1.98],
					speed4: [19.46, 2],
					speed5: [21.5, 2]
				}), _buttons)
			};
		}
	
		if ((typeof fallback === 'undefined' ? 'undefined' : _typeof(fallback)) !== 'object') {
			console.log('Unknown fallback. Sounds not loaded.');
	
			return callback && callback(false);
		}
	
		this.fallback = fallback;
	
		var src = fallback._;
	
		if (!src) {
			src = OldSoundManager.base + 'sounds/fallback';
		}
	
		this.callback = callback;
		this.base = '';
	
		this.sounds._ = new Audio();
	
		if (this.sounds._.canPlayType('audio/mpeg')) {
			src += '.mp3';
		} else {
			console.log('MP3 playback is not supported by your browser.');
			callback(false);
	
			return;
		}
	
		this.sounds._.src = src;
		this.sounds._start = 0;
		this.sounds._stop = 0;
	
		var that = this;
		$(this.sounds._).on('progress', function () {
			that.ready = true;
			that.callback(1);
		});
	
		setInterval(function () {
			if (!that.sounds._.paused && that.sounds._.currentTime > that.sounds._stop) {
				if (that.sounds._loop) {
					that.sounds._.currentTime = that.sounds._start;
				} else {
					that._stop();
				}
			}
		}, 100);
	
		this.ready = true;
	
		if (this.callback) {
			this.callback(1);
		}
	};
	
	OldSoundManager.base = '';
	
	OldSoundManager.prototype.loadSounds = function () {
		// OldSoundManager does not support loading additional sounds.
	};
	
	OldSoundManager.prototype.setFallback = function (base, fallbackData) {
		var srcCheck = base + 'sounds/' + fallbackData._ + '.mp3';
	
		this.fallback = fallbackData;
		this.sounds._.src = srcCheck;
	};
	
	OldSoundManager.prototype._play = function (info, options) {
		if (!options) {
			options = {};
		}
	
		if (typeof options === 'number') {
			options = { time: options };
		}
	
		if (typeof options === 'boolean') {
			options = { loop: options };
		}
	
		this.sounds._.pause();
		this.sounds._start = info[0];
		this.sounds._stop = info[0] + info[1];
	
		if (this.sounds._.currentTime > 0) {
			this.sounds._.currentTime = this.sounds._start || 0;
		} else {
			if (this.sounds._start !== 0) {
				this.sounds._stop = 0;
			}
		}
	
		if (options.loop) {
			this.sounds._loop = true;
		} else {
			this.sounds._loop = false;
		}
	
		var that = this;
		var go = function go() {
			that.sounds._.play();
		};
	
		if (options.time) {
			setTimeout(go, options.time);
		} else {
			go();
		}
	};
	
	OldSoundManager.prototype._stop = function (info, options) {
		if (!info || this.sounds._.currentTime > info[0] && this.sounds._.currentTime < info[0] + info[1]) {
			if (!options) {
				options = {};
			}
	
			if (typeof options === 'number') {
				options = { time: options };
			}
	
			var that = this;
			var go = function go() {
				that.sounds._loop = false;
				that.sounds._.pause();
			};
	
			if (options.time) {
				setTimeout(go, options.time);
			} else {
				go();
			}
		}
	};
	
	OldSoundManager.prototype._source = function (path) {
		var source = this.fallback;
	
		for (var p = 0; p < path.length; p++) {
			if (!source[path[p]]) {
				if (typeof path[p] === 'number') {
					return source;
				} else {
					return null;
				}
			}
	
			source = source[path[p]];
		}
	
		return source;
	};
	
	OldSoundManager.prototype.fade = function (path /* , from, to, time */) {
		this.stop(path);
	};
	
	OldSoundManager.prototype.play = function (path, options) {
		if (!this.ready) {
			return;
		}
	
		if (typeof path === 'string') {
			path = [path];
		}
	
		var info = this._source(path);
	
		if (!info) {
			return null;
		} else if (info.constructor === Object && typeof path[path.length - 1] === 'number') {
			for (var k in info) {
				if (path[path.length - 1] >= k) {
					info = info[k];
					break;
				}
			}
		}
	
		if (info.constructor !== Array || info.length !== 2) {
			throw new Error('Incorrect sound configuration: ' + path.join());
		}
	
		this._play(info, options);
	
		return {
			buffer: { duration: info[1] }
		};
	};
	
	OldSoundManager.prototype.stop = function (path, options) {
		if (!this.ready) {
			return;
		}
	
		if (typeof path === 'string') {
			path = [path];
		}
	
		var info = this._source(path);
	
		this._stop(info, options);
	
		return this;
	};
	
	OldSoundManager.prototype.volume = function (value) {
		this.sounds._.volume = value;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(10);
	
	/* globals $, game */
	
	$.ready(function () {
		/* globals base */
		var body = $(document.body).addClass('loading loading-0');
	
		var loader = window.loader = $.div('loader').appendTo(body);
		loader.progress = $.div().addClass('progress');
		loader.bar = $.div().appendTo(loader.progress);
		loader.play = $.div().addClass('play').appendTo(loader);
	
		loader.on('click', function () {
			if (!loader.play.hasClass('show') || body.hasClass('done')) {
				return;
			}
	
			game.trigger('ready');
			body.addClass('done');
	
			setTimeout(function () {
				loader.remove();
				body.attr('class', 'done');
			}, 1000);
		});
	
		var tracking = {};
		var counts = {
			total: 0,
			loaded: 0
		};
	
		loader.start = function (key) {
			tracking[key] = false;
			this.count(true);
		};
	
		loader.stop = function (key) {
			if (body.hasClass('done') || loader.play.hasClass('show')) {
				return;
			}
	
			tracking[key] = true;
			this.count(false);
	
			for (var k in tracking) {
				if (!tracking[k]) {
					return;
				}
			}
	
			finish();
		};
	
		loader.count = function (dir) {
			if (dir === true) {
				counts.total++;
			} else if (dir === false) {
				counts.loaded++;
			}
	
			var percent = counts.loaded / counts.total;
			loader.bar.css('width', percent * 100 + '%');
		};
	
		loader.loadImages = function () {
			loader.start('images');
	
			var images = getStyleImages();
	
			if (!images.length) {
				setTimeout(function () {
					loader.stop('images');
					phase1();
				}, 250);
	
				return;
			}
	
			var container = $.div().appendTo(game);
			container.loaded = 0;
	
			function loaded() {
				loader.count(false);
				container.loaded++;
	
				if (container.loaded !== images.length) {
					return;
				}
	
				container.remove();
				loader.stop('images');
				phase1();
			}
	
			for (var i = 0; i < images.length; i++) {
				loader.count(true);
	
				var url = images[i];
	
				var image = new Image();
	
				image.src = url;
	
				image.style.backgroundImage = 'url(' + url + ')';
				image.addEventListener('load', loaded);
				image.addEventListener('error', loaded);
	
				$(image).appendTo(container);
			}
		};
	
		loader.setRecall = function () {
			this.addClass('mode-recall');
		};
	
		start();
	
		function start() {
			loader.progress.appendTo(loader);
			body.addClass('loading-0');
	
			loader.count(true);
	
			setTimeout(function () {
				phase1();
			}, 3000);
		}
	
		function phase1() {
			if (!phase1.ready) {
				phase1.ready = true;
	
				return;
			}
	
			body.addClass('loading-1').removeClass('loading-0');
	
			loader.count(true);
			loader.count(false);
	
			setTimeout(function () {
				phase2();
			}, 3000);
		}
	
		function phase2() {
			body.addClass('loading-2').removeClass('loading-1');
	
			loader.count(true);
			loader.count(false);
	
			setTimeout(function () {
				finish();
			}, 2000);
		}
	
		function finish() {
			if (!finish.ready) {
				finish.ready = true;
	
				return;
			}
	
			loader.count(false);
	
			loader.play.addClass('show');
			loader.progress.remove();
	
			if (loader.hasClass('mode-recall')) {
				loader.trigger('click');
			}
		}
	
		function getStyleImages() {
			var url = /(https?:\/\/)?([A-Za-z0-9-_\.]+(?::[0-9]+)?)?(\/[A-Za-z0-9-_\/\.]+)?/;
			var images = [];
			var rules = getStyleRules();
	
			for (var i = 0; i < rules.length; i++) {
				var rule = rules[i];
	
				var path = [];
				if (rule.parentStyleSheet.href) {
					path = rule.parentStyleSheet.href.split('/').slice(0, -1);
				}
	
				for (var j = 0; j < rule.style.length; j++) {
					var key = rule.style[j];
					var value = rule.style[key];
	
					if (!value) {
						continue;
					}
	
					if (typeof value !== 'string') {
						continue;
					}
	
					var search = /url\(["']?(.+?)['"]?\)/g;
					var match = null;
	
					while (match = search.exec(value)) {
						match = match[1].match(url);
	
						if (match[3]) {
							if (match[1] === 'http://' || match[1] === 'https://') {
								match = match.slice(1, 4).join('');
							} else {
								match = match.slice(2, 4).join('');
								match = path.concat(match).join('/');
							}
						} else {
							match = match[2];
							match = path.concat(match).join('/');
						}
	
						var extension = match.split('.').pop();
	
						if (['png', 'jpg', 'gif'].indexOf(extension) === -1) {
							continue;
						}
	
						images.push(match);
					}
				}
			}
	
			return images;
		}
	
		function getStyleRules() {
			var rules = [];
	
			var sheets = window.document.styleSheets;
	
			for (var i = 0; i < sheets.length; i++) {
				var sheetRules = getStyleSheetRules(sheets[i]);
	
				var rule = null;
				while (rule = sheetRules.shift()) {
					if (rule.styleSheet) {
						sheetRules = getStyleSheetRules(rule.styleSheet).concat(sheetRules);
						continue;
					} else if (rule.cssRules) {
						sheetRules = getStyleSheetRules(rule).concat(sheetRules);
						continue;
					}
	
					if (!rule.style || !rule.style.length) {
						continue;
					}
	
					rules.push(rule);
				}
			}
	
			return rules;
		}
	
		function getStyleSheetRules(stylesheet) {
			if (stylesheet.disabled) {
				return [];
			}
	
			if (!stylesheet.cssRules) {
				return [];
			}
	
			var media = stylesheet.media && stylesheet.media.mediaText;
	
			if (media && media.length && !window.matchMedia(media).matches) {
				return [];
			}
	
			return Array.prototype.slice.call(stylesheet.cssRules);
		}
	});

/***/ },
/* 10 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	/* jscs:disable */
	/* jshint ignore:start */
	// QueryData.js - Created by Stephen Morley and released under the terms of the CC0 1.0 Universal legal code:
	function QueryString() {
		var a = location.search || "";"?" == a.charAt(0) && (a = a.substring(1));if (a.length) for (var a = a.replace(/\+/g, " "), a = a.split(/[&;]/g), c = 0; c < a.length; c++) {
			var b = a[c].split("="),
			    d = decodeURIComponent(b[0]),
			    b = 1 < b.length ? decodeURIComponent(b[1]) : "";this[d] = b;
		}
	};
	window.QueryString = QueryString;
	/* jshint ignore:end */
	/* jscs:enable */
	
	/* globals QueryString, io */
	
	var controller = window.controller = {
		namespace: '/game'
	};
	
	$.ready(function () {
		controller.socket = io.connect(controller.namespace);
	
		controller.socket.on('connect', function () {
			var querystring = new QueryString();
	
			var request = { engine: game.attr('data-engine'), game: game.attr('data-game'), playerid: querystring.playerid };
	
			if (!request.playerid && querystring.cycleid) {
				delete request.playerid;
				request.cycleid = querystring.cycleid;
			}
	
			controller.socket.emit('open', request);
		});
	
		controller.socket.on('reconnect', function () {
			if (game.panel.dialog._content && game.panel.dialog._content.slug === 'disconnect') {
				game.panel.dialog.hide();
			}
		});
	
		controller.socket.on('disconnect', function () {
			game.panel.dialog.show('disconnect');
		});
	
		controller.socket.on('notice', function (response) {
			controller.error = response;
			game.panel.dialog.show(response.slug);
			game.panel.reable();
		});
	
		controller.socket.on('fatal', function (response) {
			console.log('fatal', response);
			controller.error = response;
			game.panel.dialog.show('fatal');
		});
	
		controller.socket.on('error', function (response) {
			console.log('error', response);
			controller.error = response;
			game.panel.dialog.show('fatal');
		});
	});

/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	document.addEventListener('touchmove', function (e) {
		e.preventDefault();
	});
	
	$.ready(function () {
		/* globals loader */
	
		var resize = function resize() {
			var viewport = {
				width: document.documentElement.clientWidth, // window.innerWidth
				height: document.documentElement.clientHeight };
	
			loader.css(viewport);
			window.scrollTo(0, 0);
	
			game.emit('viewport', viewport);
			game.css(viewport);
	
			game.emit('scale', {
				viewport: viewport,
				resize: function resize(dimensions, element, _viewport) {
					_viewport = _viewport || this.viewport;
	
					var scaleW = _viewport.width / dimensions.width;
					var scaleH = _viewport.height / dimensions.height;
					var scale = Math.min(scaleW, scaleH);
	
					var width = scale * _viewport.width / scaleW;
					var height = scale * _viewport.height / scaleH;
	
					var font = Math.floor(scale * dimensions.font);
	
					if (element) {
						element.css({
							width: width,
							height: height,
							'font-size': font
						});
					}
	
					return {
						width: width,
						height: height,
						font: font
					};
				}
			});
		};
	
		window.addEventListener('resize', resize);
		document.addEventListener('resize', resize);
	
		setTimeout(resize, 0);
	});

/***/ },
/* 18 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(21);
	__webpack_require__(60);
	__webpack_require__(61);
	__webpack_require__(62);
	__webpack_require__(66);
	__webpack_require__(67);
	__webpack_require__(68);
	__webpack_require__(69);
	__webpack_require__(70);
	__webpack_require__(71);
	__webpack_require__(72);
	__webpack_require__(73);
	__webpack_require__(74);
	
	__webpack_require__(75);

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* globals loader, SoundManager */
	
	var SPINJS = window.SPINJS = window.SPINJS || {};
	
	SPINJS.panel_base = '/spinjs/panel';
	
	$.plugins.panel = {
		disabled: true,
		state: null,
	
		__init: function __init(config) {
			config.version = game.attr('data-version');
	
			/* Game Scaling */
			{
				game.on('scale', function (e) {
					var width = e.detail.viewport.width;
					var height = e.detail.viewport.height;
	
					var size = e.detail.resize(game.panel.dimensions, game.panel, {
						width: width,
						height: height * game.panel.dimensions.height / game.panel.dimensions.screen_height
					});
	
					game.panel.dialog.css('font-size', size.font + 'px');
	
					e.detail.resize(game.dimensions, game.container, {
						width: width,
						height: height * game.dimensions.height / game.dimensions.screen_height
					});
	
					for (var key in game.features) {
						var dimensions = game.features[key].dimensions || game.dimensions;
	
						var factor = dimensions.full ? 1 : game.dimensions.height / game.dimensions.screen_height;
	
						e.detail.resize(dimensions, game.features[key], {
							width: width,
							height: height * factor
						});
					}
				});
	
				game.animationResize = function (animation) {
					animation.css('width', null);
					animation.css('width', animation.el.offsetWidth);
				};
	
				game.resetAnimationResize = function (animation) {
					animation.css('width', null);
				};
			}
	
			/* Button Sound */
			{
				this.on('click', function (e) {
					if (this.disabled) {
						return;
					}
	
					var el = e.target;
	
					if (game.panel.denom.el === el || game.panel.denom.label && game.panel.denom.label.el === el || game.panel.denom.field && game.panel.denom.field.el === el) {
						game.sounds.play(['buttons', 'denom']);
	
						return;
					}
				});
			}
	
			/* Auto-Close Menus */
			{
				var menus = this.menus = [];
				$(document).on('click', function (e) {
					loop: for (var m in menus) {
						var menu = menus[m].el;
						var parent = menus[m].el.parentNode;
	
						var el = e.target;
	
						do {
							if (menu === el || parent === el) {
								continue loop;
							}
						} while ((el = el.parentNode) && el && el.classList);
	
						menus[m].hide();
					}
				});
			}
	
			/* Currency Switch */
			{
				this.metersCash = [];
				this.metersCredits = [];
				this.isCash = false;
			}
	
			/* Dialog */
			{
				this.dialog = $.div('dialog').apply('dialog');
	
				if (config.version) {
					var version = config.version.split('-')[0];
	
					game.version = $.div('version').html('v' + version);
					game.version.appendTo(this.dialog.container);
				}
	
				this.dialog.pages.disconnect = $.div().addClass('noexit').html('<h2>Disconnected</h2><p>You have been disconnected from the server. Please refresh the game to continue. If the problem persists, please contact the operator.</p>');
				this.dialog.pages.fatal = $.div().addClass('noexit').html('<h2>Error</h2><p>An error has occured. Please refresh the game to continue. If the error persists, please contact the operator.</p>');
				this.dialog.pages.credits = $.div().html('<h2>Out Of Credits</h2><p>You do not have enough credits.</p>');
			}
	
			/* Recall */
			{
				var recall = game.recall = $.div('recall');
				$.element('h2').html('Game Recall').appendTo(recall);
				recall.table = $.element('table').appendTo(recall);
				$.element('p').html('Click a row to replay the game.').appendTo(recall);
				$.element('p').html('1 Credit = $0.01. *If applicable.').appendTo(recall);
	
				recall.show = function (list) {
					this.table.empty();
	
					var row = $.element('tr').appendTo(this.table);
					$.element('th').html('Date').appendTo(row);
					$.element('th').html('Beginning').appendTo(row);
					$.element('th').html('Bet').appendTo(row);
					$.element('th').html('Win').appendTo(row);
					$.element('th').html('Final').appendTo(row);
	
					for (var i = 0; i < list.length; i++) {
						var cycle = list[i];
	
						cycle.balance = $.plugins.meter.__format(cycle.balance);
						cycle.bet = $.plugins.meter.__format(cycle.bet);
						cycle.win = $.plugins.meter.__format(cycle.win);
						cycle.credits = $.plugins.meter.__format(cycle.credits);
	
						row = $.element('tr').appendTo(this.table);
						$.element('td').html(new Date(cycle.date).toLocaleString()).appendTo(row);
						$.element('td').html(cycle.balance).appendTo(row);
						$.element('td').html(cycle.bet).appendTo(row);
						$.element('td').html(cycle.win).appendTo(row);
						$.element('td').html(cycle.credits).appendTo(row);
	
						row.on('click', function (cycle) {
							var url = [window.location.origin, window.location.pathname, '?cycleid=', cycle.id].join('');
							window.open(url, 'recall-' + cycle.id);
						}.bind(null, cycle));
					}
	
					game.panel.dialog.show(recall);
				};
			}
	
			/* Sounds */
			{
				loader.start('sounds');
	
				game.sounds = new SoundManager({
					buttons: {
						auto: __webpack_require__(22),
						denom: __webpack_require__(23),
						help: __webpack_require__(24),
						lobby: __webpack_require__(25),
						max: __webpack_require__(26),
						menu: __webpack_require__(27),
						recall: __webpack_require__(28),
						sound: __webpack_require__(29),
						spin: __webpack_require__(30),
						play: __webpack_require__(30),
	
						// Necessary style for fallback
						autos: {
							auto_0: __webpack_require__(31),
							auto_1: __webpack_require__(32),
							auto_2: __webpack_require__(33),
							auto_3: __webpack_require__(34),
							auto_4: __webpack_require__(35),
							auto_5: __webpack_require__(36),
							auto_6: __webpack_require__(37)
						},
						coins: {
							bet_0: __webpack_require__(38),
							bet_1: __webpack_require__(39),
							bet_2: __webpack_require__(40),
							bet_3: __webpack_require__(41),
							bet_4: __webpack_require__(42),
							bet_5: __webpack_require__(43)
						},
						denoms: {
							denom_0: __webpack_require__(44),
							denom_1: __webpack_require__(45),
							denom_2: __webpack_require__(46),
							denom_3: __webpack_require__(47),
							denom_4: __webpack_require__(48),
							denom_5: __webpack_require__(49),
							denom_6: __webpack_require__(50)
						},
						lines: {
							line_0: __webpack_require__(51),
							line_1: __webpack_require__(52),
							line_2: __webpack_require__(53),
							line_3: __webpack_require__(54),
							line_4: __webpack_require__(55),
							line_5: __webpack_require__(56)
						}
					},
					win: {
						win_1: __webpack_require__(57),
						win_2: __webpack_require__(58),
						win_3: __webpack_require__(59)
					}
				}, window.sound_fallback || game.engine, function () {
					loader.stop('sounds');
				});
			}
	
			/* Apply Full Panel */
			{
				if (Math.max(screen.width, screen.height) >= 1024) {
					this.dialog.addClass('desktop');
					this.apply('panel_desktop', config);
				} else {
					this.dialog.addClass('mobile');
					this.apply('panel_mobile', config);
				}
			}
	
			/* Wins */
			{
				this.bigwin = new SPINJS.BigWin(this);
			}
	
			this.disable(null);
		},
	
		setRecall: function setRecall() {
			game.panel.disable(true);
			game.inRecall = true;
			$.div('mode-recall').html('Recall Mode').appendTo(this);
		},
	
		registerMenu: function registerMenu(menu) {
			this.menus.push(menu);
		},
	
		registerCash: function registerCash(meter, click) {
			this.metersCash.push(meter);
	
			meter.field.addClass('cash');
	
			if (click) {
				meter.on('click', function () {
					this.toggleCash();
				}.bind(this));
			}
		},
	
		registerCredits: function registerCredits(meter, click) {
			this.metersCredits.push(meter);
	
			meter.field.addClass('cash');
	
			if (click) {
				meter.on('click', function () {
					this.toggleCash();
				}.bind(this));
			}
		},
	
		toggleCash: function toggleCash(force) {
			if (typeof force === 'boolean') {
				this.isCash = !!force;
			} else {
				this.isCash = !this.isCash;
			}
	
			this.updateCash();
		},
	
		updateCash: function updateCash() {
			var denom = this.denom.get();
	
			for (var i = 0; i < this.metersCash.length; i++) {
				this.metersCash[i].scale(this.isCash ? 0 : denom);
				this.metersCash[i]._field.toggleClass('cash', this.isCash);
			}
	
			for (var i = 0; i < this.metersCredits.length; i++) {
				this.metersCredits[i].scale(this.isCash ? 1 / denom / 10 : 1);
				this.metersCredits[i]._field.toggleClass('cash', this.isCash);
			}
	
			this.emit('cash', denom);
		},
	
		enable: function enable() {
			this.disabled = false;
			this.removeClass('disabled');
			this.state = null;
		},
	
		disable: function disable(state) {
			this.disabled_last = this.disabled;
			this.state_last = this.state;
	
			this.disabled = true;
			this.addClass('disabled');
	
			if (typeof state !== 'undefined') {
				this.state = state;
			}
		},
	
		reable: function reable() {
			if (this.disabled_last) {
				this.disable(this.state_last);
			} else {
				this.enable();
			}
	
			game.emit('reable');
		},
	
		setBet: function setBet() /* values */{
			throw new Error('panel.setBet should be overridden.');
		},
	
		getBet: function getBet() {
			throw new Error('panel.getBet should be overridden.');
		},
	
		setCredits: function setCredits(value) {
			this.credits.set(value);
		},
	
		incCredits: function incCredits(value) {
			this.credits.inc(value);
		},
	
		setWin: function setWin(value, immediate) {
			if (immediate) {
				this.win.set(value, true);
				this.bigwin.stop(true);
	
				if (value === 0) {
					game.panel.bigwin.meter.field.css('font-size', ''); // reset big win meter value
					this.bigwin_reset = setTimeout(this.bigwin.meter.set.bind(this.bigwin.meter, value, true), 1000);
				} else {
					this.bigwin.meter.set(value, true);
				}
	
				return;
			}
	
			if (value === true) {
				this.win.update(true);
				this.bigwin.stop();
	
				return;
			}
	
			var track = null;
	
			if (typeof value === 'number') {
				var factor = value / (game.last._cost || game.old._cost);
	
				track = this.bigwin.play(factor);
			}
	
			clearTimeout(this.bigwin_reset);
	
			this.win.set(value, track);
	
			if (value >= 1000000 && value < 10000000) {
				// one hundred thousand to a million
				game.panel.bigwin.meter.field.css('font-size', '90%');
			} else if (value >= 10000000 && value < 1000000000) {
				// a million to one hundred million
				game.panel.bigwin.meter.field.css('font-size', '80%');
			} else if (value > 1000000000) {
				// assuming that it won't go much higher than that
				game.panel.bigwin.meter.field.css('font-size', '50%');
			}
	
			this.bigwin.meter.set(0, true);
			this.bigwin.meter.set(value, track);
			this.win.trigger('setWin', { value: value, immediate: track });
		},
	
		incWin: function incWin(value, immediate) {
			this.win.inc(value, immediate);
		}
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/caa4b7dc6b966468919832a2ddd320dd.mp3";

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/f04f0bea7447a07ee2d832649a04dbba.mp3";

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/33ddcff0046e4c55975d7bd6af425c16.mp3";

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/dbb6ef4afd91c9f9ffbf146160950b11.mp3";

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/52f5e41546831202e68962fa30c8ef77.mp3";

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/685d757f5667df4b13a905acaedbe9b6.mp3";

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/8f32ec4fca16a1ca7a26cca89ebf1d07.mp3";

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/264b809fe6e553beff0b009a302a6be5.mp3";

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/6068ce6ba6477147ddb6faab8bea361a.mp3";

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/485ffb2379669fefc310ed5328621382.mp3";

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/063d2708584da7e70e4ff6ad830f8a96.mp3";

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4f3f0b4002b04cffcb89e25918c4f3c6.mp3";

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bbf21cbb70ac7f3c6b88a32dd90d7d3e.mp3";

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/db0c81f0eae759f2bbfe792c2c3610c4.mp3";

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/faa350285e07c8de79be8afb0f591526.mp3";

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fde969805f42b1f5d53518c8ced03740.mp3";

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4edc6cf30efa0fde966424b6436f19eb.mp3";

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/f282a45ea754fdf16f9f3b7eafbfc2cd.mp3";

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/3089c455c2a13fdb17e258b4abe1752b.mp3";

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4b1e9e30045718ebfc410211afc4a054.mp3";

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/5d41516027801260e584dc01d37cf876.mp3";

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/0fecfe16d577349a1c445a76a56f1c85.mp3";

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/9e6362719e59d187895605833060d1f9.mp3";

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/669681afdfa41ba6cc3777cb968a9cd6.mp3";

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e61d348ab0fcd0debe806f09b6f51ede.mp3";

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fabbfecdf4b9f45c93a1446da03f1ce8.mp3";

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/a692a9a076e5553bdd0fe749f36bb04b.mp3";

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/9c32a0302249dc271d1ce40d83aca1d4.mp3";

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/1054233ae23399e2f10e147c68cf606f.mp3";

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/58b6bac6fba830c148ee5a93898258a1.mp3";

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/7b7a8575cce927fbfece914110828999.mp3";

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/1bac64984151bf8ae5764a7bea672325.mp3";

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/c7c469244d5386d3792111a331c6d231.mp3";

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/8675f7dc27dffb6f38883516da085538.mp3";

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ef0981645698e23423e22722257fc376.mp3";

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e82f5a8f41b618e671ea5725ffc2926b.mp3";

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/04b1f4abc2de81e98a74f1bcb442e932.mp3";

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/91b38543699eea04adee6e4911bc830b.mp3";

/***/ },
/* 60 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.panel_desktop = {
		__init: function __init() {
			this.addClass('desktop');
			this.type = 'desktop';
	
			this.dimensions = {
				width: 1700,
				height: 174,
				font: 36,
				screen_width: 1920,
				screen_height: 1080
			};
	
			/* Meters */
			{
				this.credits = $.div().addClass('credits').apply('meter', { label: 'Balance', value: 0 }).appendTo(this);
				this.registerCash(this.credits, true);
	
				this.win = $.div().addClass('win').apply('meter', { label: 'Win', value: 0, animate: true }).appendTo(this);
				this.registerCash(this.win, true);
	
				this.win.label.appendTo(this.win);
			}
	
			/* Play Button */
			{
				this.play = $.div('play').apply('button', {});
				this.addItem(this.play, 'middle');
	
				this.play.on('click', function () {
					if (this.hasClass('hide') || this.hasClass('disabled')) {
						return;
					}
	
					if (game.panel.state && game.panel.state === 'lock') {
						return;
					}
	
					if (game.panel.disabled) {
						this.emit('slam');
	
						return;
					}
	
					this.emit('play');
					game.sounds.play(['buttons', 'spin']);
				});
	
				$(document).on('keydown', function (e) {
					if (e.keyCode === 32) {
						game.panel.play.trigger('click');
					}
				});
			}
	
			/* Help */
			{
				this.buildHelp = function (count) {
					this.help = [];
					this.help.slug = 'help';
	
					for (var i = 1; i <= count; i++) {
						this.help.push($.div().addClass('help help-' + i));
					}
				};
			}
	
			/* Menu Button */
			{
				this.info = $.div().apply('button', { label: 'Menu' });
				this.addItem(this.info, 'left far');
				this.info.on('click', function (e) {
					if (e.target === this.el || e.target === this.label.el) {
						game.sounds.play(['buttons', 'menu']);
					}
				});
	
				var menu = this.info.addMenu({ transition: 'up' });
				this.registerMenu(menu);
	
				this.info.lobby = $.div().apply('button', { label: 'Return To Lobby' });
				this.info.menu.addItem(this.info.lobby);
				this.info.lobby.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.sounds.play(['buttons', 'lobby']);
					game.panel.trigger('lobby');
				});
	
				this.info.sound = $.div().apply('toggle', { label: 'Sound' });
				this.info.menu.addItem(this.info.sound);
				this.info.sound.on('update', function () {
					game.sounds.volume(this.is() ? 1 : 0);
	
					if (this.is()) {
						game.sounds.play(['buttons', 'sound']);
					}
				});
	
				this.info.turbo = $.div().apply('toggle', { label: 'Turbo', value: false });
				this.info.menu.addItem(this.info.turbo);
				this.info.turbo.on('update', function () {
					game.setTurbo(this.is());
	
					game.sounds.play(['buttons', 'turbo']);
				});
	
				this.info.recall = $.div().apply('button', { label: 'Game Recall' });
				this.info.menu.addItem(this.info.recall);
				this.info.recall.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.sounds.play(['buttons', 'recall']);
					game.panel.trigger('recall');
					menu.hide();
				});
	
				this.info.help = $.div().apply('button', { label: 'Help/Pay' });
				this.info.menu.addItem(this.info.help);
				this.info.help.on('click', function () {
					game.sounds.play(['buttons', 'help']);
					game.panel.dialog.show(game.panel.help);
					menu.hide();
				});
			}
		},
	
		addItem: function addItem(item, position) {
			item.addClass(position);
			item.appendTo(this);
	
			return item;
		},
	
		hide: function hide(value) {
			if (!value) {
				return;
			}
	
			this.addClass('hide');
	
			this.bigwin.stop(true);
	
			if (this.info.menu.hasClass('show')) {
				this.info.menu.toggle();
			}
	
			if (this.auto && this.auto.menu.hasClass('show')) {
				this.auto.menu.toggle();
			}
		},
	
		show: function show(value) {
			if (!value) {
				return;
			}
	
			this.removeClass('hide');
		}
	};

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.panel_mobile = {
		__init: function __init() {
			this.addClass('mobile');
			this.type = 'mobile';
	
			this.dimensions = {
				width: 1800,
				height: 108,
				font: 60,
				screen_width: 1920,
				screen_height: 1080
			};
	
			this.rotate_device = $.div().addClass('rotate-device').appendTo(game);
			game.on('scale', function (e) {
				var width = e.detail.viewport.width;
				var height = e.detail.viewport.height;
	
				var size = e.detail.resize(game.panel.dimensions, null, {
					width: width,
					height: height * game.panel.dimensions.height / game.panel.dimensions.screen_height
				});
	
				game.panel.rotate_device.css('font-size', size.font + 'px');
			});
			/* Meters */
			{
				this.credits = $.div().apply('meter', { label: 'Bal', value: 0 });
				this.addItem(this.credits, 'bottom left');
				this.registerCash(this.credits, true);
	
				this.win = $.div().apply('meter', { label: 'Win', value: 0, animate: true });
				this.win.label.appendTo(this.win);
				this.addItem(this.win, 'bottom right');
				this.registerCash(this.win, true);
			}
	
			/* Play Button */
			{
				this.play = $.div().apply('button', { value: true });
				this.addItem(this.play, 'main right');
	
				this.play.on('click', function () {
					game.panel.hud.hide();
	
					if (this.hasClass('hide') || this.hasClass('disabled')) {
						return;
					}
	
					if (game.panel.state && game.panel.state === 'lock') {
						return;
					}
	
					if (game.panel.disabled) {
						this.emit('slam');
	
						return;
					}
	
					this.emit('play');
					game.sounds.play(['buttons', 'spin']);
				});
			}
	
			/* Menu Button */
			{
				this.menu = $.div().apply('button', {});
				this.addItem(this.menu, 'main left icon-hud');
	
				this.menu.addMenu({
					callback: function callback() {
						if (this.disabled) {
							return false;
						}
	
						game.sounds.play(['buttons', 'menu']);
					}
				});
			}
	
			/* Help */
			{
				this.buildHelp = function (count) {
					this.help = [];
					this.help.slug = 'help';
	
					for (var i = 1; i <= count + 1; i++) {
						this.help.push($.div().addClass('help help-' + i));
					}
				};
			}
	
			/* HUD */
			{
				this.hud = this.menu.menu.addClass('hud').appendTo(this);
				this.menu.appendTo(this);
				this.registerMenu(this.hud);
	
				this.hud.help = $.div().apply('button', { label: 'Game Help' });
				this.addItem(this.hud.help, 'hud left top');
				this.hud.help.on('click', function () {
					game.panel.dialog.show(game.panel.help);
					game.panel.hud.hide();
					game.sounds.play(['buttons', 'help']);
				});
	
				this.hud.settings = $.div().apply('button', { label: 'Game Settings' });
				this.addItem(this.hud.settings, 'hud left bottom');
				this.hud.settings.on('click', function () {
					game.panel.dialog.show(game.panel.settings);
					game.panel.hud.hide();
					game.sounds.play(['buttons', 'menu']);
				});
	
				this.hud.bet = $.div().apply('button', { label: 'Bet' });
				this.addItem(this.hud.bet, 'hud right bottom');
				this.hud.bet.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.panel.dialog.show(game.panel.bet);
					game.panel.hud.hide();
				});
			}
	
			/* Betting */
			{
				this.bet = $.div();
				this.bet.slug = 'bet';
				this.bet.items = [];
	
				this.bet.max = $.div().apply('button', { label: 'Bet Max' }).addClass('max').appendTo(this.bet);
				this.bet.max.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					for (var i = 0; i < game.panel.bet.items.length; i++) {
						if (!game.panel.bet.items[i].max) {
							continue;
						}
	
						game.panel.bet.items[i].max();
					}
	
					game.sounds.play(['buttons', 'max']);
				});
	
				this.bet.play = $.div().apply('button', { label: 'Bet play' }).addClass('play').appendTo(this.bet);
				this.bet.play.on('click', function () {
					game.panel.dialog.hide();
				});
			}
	
			/* Settings */
			{
				this.settings = $.div();
				this.settings.slug = 'settings';
	
				this.settings.sound = $.div().apply('toggle', { label: 'Sound', value: true });
				this.settings.sound.addClass('sound');
				this.addItem(this.settings.sound, 'settings');
				this.settings.sound.on('update', function () {
					game.sounds.volume(this.is() ? 1 : 0);
	
					if (this.is()) {
						game.sounds.play(['buttons', 'sound']);
					}
				});
	
				this.settings.turbo = $.div().apply('toggle', { label: 'Turbo', value: false });
				this.settings.turbo.addClass('turbo');
				this.addItem(this.settings.turbo, 'settings');
				this.settings.turbo.on('update', function () {
					game.setTurbo(this.is());
	
					game.sounds.play(['buttons', 'turbo']);
				});
	
				this.settings.hand = $.div().apply('toggle', { label: 'Handedness', value: false });
				this.settings.hand.addClass('hand');
				this.addItem(this.settings.hand, 'settings');
				this.settings.hand.on('update', function () {
					game.toggleClass('flip-flop', this.is());
				});
	
				this.settings.recall = $.div().apply('button', { label: 'Game Recall' });
				this.settings.recall.addClass('recall');
				this.addItem(this.settings.recall, 'settings');
				this.settings.recall.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.panel.trigger('recall');
					game.sounds.play(['buttons', 'recall']);
				});
	
				this.settings.lobby = $.div().apply('button', { label: 'Back to Lobby' });
				this.settings.lobby.addClass('lobby');
				this.addItem(this.settings.lobby, 'settings');
				this.settings.lobby.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.panel.trigger('lobby');
					game.sounds.play(['buttons', 'lobby']);
				});
			}
		},
	
		addItem: function addItem(item, position) {
			position = position.split(' ');
	
			if (has('main', false)) {
				item.appendTo(this);
			} else if (has('bet')) {
				item.appendTo(this.bet);
				this.bet.items.push(item);
			} else if (has('hud')) {
				item.appendTo(this.hud);
			} else if (has('settings')) {
				item.appendTo(this.settings);
			} else if (has('bottom', false)) {
				item.prependTo(this);
			} else {
				throw new Error('Panel: Unknown position: "' + position.join(' ') + '"');
			}
	
			item.addClass(position.join(' '));
	
			return item;
	
			function has(key, remove) {
				if (position.indexOf(key) === -1) {
					return false;
				}
	
				if (remove !== false) {
					position.splice(position.indexOf(key), 1);
				}
	
				return true;
			}
		},
	
		hide: function hide(value) {
			if (game.turbo && !value) {
				return;
			}
	
			this.menu.disabled = true;
			this.addClass('hide');
		},
	
		show: function show() {
			this.removeClass('hide');
			this.menu.disabled = false;
		},
	
		metersHide: function metersHide() {
			for (var meter in this.metersCash) {
				this.metersCash[meter].addClass('hide');
			}
		},
	
		metersShow: function metersShow() {
			for (var meter in this.metersCash) {
				this.metersCash[meter].removeClass('hide');
			}
		}
	};

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var SPINJS = window.SPINJS = window.SPINJS || {};
	var level;
	
	SPINJS.BigWin = function (panel) {
		this.meter = $.div('bigwin').apply('meter', { animate: true }).removeClass('meter').addClass('reset');
	
		this.meter.prependTo(panel);
		panel.registerCash(this.meter, true);
	
		var levels = {
			win_1: { name: 'win_1' },
			win_2: { name: 'win_2' },
			win_3: { name: 'win_3' },
	
			bigwin_1: {
				name: 'bigwin_1',
				duration: 5,
				celebration: 'confetti'
			},
	
			bigwin_2: {
				name: 'bigwin_2',
				duration: 5,
				celebration: 'coins'
			},
	
			bigwin_3: {
				name: 'bigwin_3',
				duration: 5,
				celebration: 'fireworks'
			}
		};
	
		this.breakpoints = [1, 2, 5, 10, 25];
		this.levels = [[levels.win_1], [levels.win_2], [levels.win_3], [levels.bigwin_1], [levels.bigwin_1, levels.bigwin_2], [levels.bigwin_1, levels.bigwin_2, levels.bigwin_3]];
	
		this.celebrations = {};
	
		if (panel.type === 'desktop') {
			this.celebrations.confetti = new SPINJS.BigWin.Celebration([{
				src: __webpack_require__(63),
				position: 'left',
				width: '24%'
			}, {
				src: __webpack_require__(63),
				position: 'right',
				width: '24%'
			}], panel);
	
			this.celebrations.coins = new SPINJS.BigWin.Celebration([{
				src: __webpack_require__(64),
				position: 'middle',
				width: '82%'
			}], panel);
	
			this.celebrations.fireworks = new SPINJS.BigWin.Celebration([{
				src: __webpack_require__(65),
				position: 'middle',
				width: '95%'
			}], panel);
		}
	};
	
	SPINJS.BigWin.prototype.play = function (factor, index) {
		if (!index) {
			for (index = 0; index < this.breakpoints.length; index++) {
				if (factor < this.breakpoints[index]) {
					break;
				}
			}
		}
	
		level = this.levels[index];
	
		var start = game.sounds.context.currentTime;
	
		var total = level.reduce(function (total, level) {
			level.source = game.sounds.play(['win', level.name], total);
	
			var duration = 2;
	
			if (level.duration || level.source) {
				duration = level.duration || level.source.buffer.duration;
			}
	
			if (level.celebration) {
				level.timer = setTimeout(function () {
					if (this.celebrations[level.celebration]) {
						this.celebrations[level.celebration].play();
					}
	
					this.meter.attr('class', level.name);
				}.bind(this), total * 1000);
			}
	
			return total + duration;
		}.bind(this), 0);
	
		level.timer = setTimeout(function () {
			this.stop(true);
		}.bind(this), total * 1000 + 5000);
	
		this.playing = true;
	
		return {
			get progress() {
				return (game.sounds.context.currentTime - start) / total;
			}
		};
	};
	
	SPINJS.BigWin.prototype.stop = function (immediate) {
		this.playing = false;
	
		if (immediate) {
			game.sounds.stop('win');
		} else {
			if (level) {
				game.sounds.fade(['win', level[0].name], 1, 0, 0.5);
				setTimeout(function () {
					game.sounds.stop('win');
				}, 500);
			}
		}
	
		for (var i in this.levels) {
			if (this.levels[i].timer) {
				clearTimeout(this.levels[i].timer);
	
				if (!immediate) {
					this.levels[i].timer = setTimeout(function () {
						this.stop(true);
					}.bind(this), 5000);
				}
			}
	
			for (var j in this.levels[i]) {
				if (j === 'timer') {
					continue;
				}
	
				if (this.levels[i][j].timer) {
					clearTimeout(this.levels[i][j].timer);
					delete this.levels[i][j].timer;
	
					this.meter.attr('class', this.levels[i][j].name);
				}
			}
		}
	
		for (var key in this.celebrations) {
			this.celebrations[key].stop();
		}
	
		this.meter.update(true);
	
		if (immediate) {
			this.meter.addClass('reset');
		}
	};
	
	SPINJS.BigWin.Celebration = function (items, panel) {
		if (!/Chrome/.test(navigator.userAgent)) {
			return;
		}
	
		this.videos = items.map(function (item) {
			var video = $.element('video').attr('poster', 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABAQMAAAAl21bKAAAAA1BMVEVMaXFNx9g6AAAAAXRSTlMAQObYZgAAAApJREFUCNdjYAAAAAIAAeIhvDMAAAAASUVORK5CYII=');
			var source = $.element('source').attr('type', 'video/webm');
	
			video.on('ended', function () {
				this.css('display', 'none');
			});
	
			var style = {
				display: 'none',
				position: 'absolute',
				bottom: '100%',
				width: item.width
			};
	
			switch (item.position) {
				case 'left':
					style.left = '0%';
					break;
	
				case 'right':
					style.right = '0%';
					break;
	
				case 'middle':
					style.left = '50%';
					style.transform = 'translateX(-50%)';
					break;
			}
	
			video.css(style);
			source.appendTo(video);
			video.prependTo(panel);
	
			setTimeout(function () {
				var url = /((?:ht|f)tps?):\/\/([A-Za-z0-9-_\.]+)(?::([0-9]+))?(\/(?:[A-Za-z0-9-_\/\.]*))*/;
				var path = panel.css('background-image').match(url)[0];
				path = path.slice(0, path.lastIndexOf('/') + 1);
	
				source.attr('src', base + item.src);
			}.bind(this), 100);
	
			return video;
		});
	};
	
	SPINJS.BigWin.Celebration.prototype.play = function () {
		if (!this.videos) {
			return;
		}
	
		this.videos.map(function (video) {
			video.css('display', 'block');
			video.el.load();
			video.el.play();
		});
	};
	
	SPINJS.BigWin.Celebration.prototype.stop = function () {
		if (!this.videos) {
			return;
		}
	
		this.videos.map(function (video) {
			video.el.pause();
			video.css('display', 'none');
		});
	};

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ac111633e1a26373c6a81d970650a825.webm";

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b6c6bfc327e247d31f75e5eb151bc483.webm";

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/8536f9b709151374dd965e96fe6b5254.webm";

/***/ },
/* 66 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.widget = {
		__init: function __init(config) {
			if (config.label) {
				this.label = $.div().addClass('label').html(config.label).appendTo(this);
			}
	
			if (typeof config.value !== 'undefined') {
				this._field = $.div().addClass('field').appendTo(this);
				this.field = $.div().addClass('value').appendTo(this._field);
	
				if (typeof config.value === 'number') {
					this.field.html(config.value.toString());
				} else if (typeof config.value === 'string') {
					this.field.html(config.value);
				}
			} else if (config.label) {
				this.label.addClass(config.type || 'center');
			}
		},
	
		set: function set(value) {
			if (this.field) {
				this.field.html(value);
			}
	
			return this;
		},
	
		addMenu: function addMenu(config, disabled) {
			var callback = config.callback || function () {
				return true;
			};
	
			delete config.callback;
	
			this.menu = $.div().apply('menu', config).appendTo(this);
	
			this.on('click', function (e) {
				if (disabled && game.panel.disabled) {
					return;
				}
	
				var el = e.target;
	
				do {
					if (el.classList.contains('menu')) {
						return;
					}
	
					if (el === this.el) {
						break;
					}
				} while ((el = el.parentNode) && el && el.classList);
	
				if (el !== this.el) {
					return;
				}
	
				if (callback.call(this) === false) {
					return;
				}
	
				this.menu.toggle();
			});
	
			return this.menu;
		}
	};

/***/ },
/* 67 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.button = {
		__init: function __init(config) {
			this.apply('widget', { label: config.label, value: config.value }).addClass('button');
		}
	};

/***/ },
/* 68 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.meter = {
		animate: false,
		_value: null,
		_delta: 0,
		_scale: null,
	
		__scale: {
			factor: 50,
			max: 4.25,
			min: 0
		},
	
		__format: function __format(value, scale) {
			if (typeof scale === 'undefined' || scale === null) {
				value = Math.floor(value);
				scale = true;
			} else if (typeof scale === 'number' && scale > 0) {
				if (scale <= .1) {
					value = Math.floor(value / (scale * 1000) * 100) / 100;
					scale = false;
				} else {
					value = Math.floor(value / scale);
				}
			} else if (scale === false) {
				value = Math.floor(value / 100 * 100) / 100;
				scale = false;
			} else {
				value = Math.floor(value) / 100;
				scale = false;
			}
	
			var parts = value.toFixed(scale ? 0 : 2).split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			value = parts.join('.');
	
			return value;
		},
	
		__init: function __init(config) {
			this.apply('widget', { label: config.label, value: true }).addClass('meter');
	
			if (typeof config.value !== 'undefined') {
				this.set(config.value);
			}
	
			if (config.animate) {
				this.animate = true;
			}
		},
	
		scale: function scale(value) {
			this._scale = value;
	
			return this.update();
		},
	
		inc: function inc(value, immediate) {
			this.set(this._value + value, immediate);
		},
	
		set: function set(value, immediate) {
			if (value === true) {
				return this.set(this._value, true);
			}
	
			this._base = this._value || 0;
			this._value = value;
			this._delta = this._value - this._base;
	
			if (!this._value || this._delta <= 0) {
				immediate = true;
			}
	
			if (this.animate && this._value && immediate !== true) {
				if (immediate && immediate.hasOwnProperty('progress')) {
					this._track = immediate;
				} else {
					var meterdata = $.plugins.meter.__scale;
					var scale = 1;
	
					if (immediate && immediate.scale) {
						scale = typeof immediate.scale === 'number' ? immediate.scale : this._scale;
					}
	
					var seconds = typeof immediate === 'number' ? immediate : (meterdata.max - meterdata.min) * (1 - Math.exp(-this._delta / (scale * meterdata.factor))) + meterdata.min;
	
					this._frames = Math.ceil(seconds * 24);
					this._frame = 0;
				}
	
				this.timer = setInterval(this.update.bind(this), 1000 / 24);
			} else {
				return this.update(true, immediate);
			}
		},
	
		update: function update(force, immediate) {
			var value = this._value;
	
			if (typeof value === 'number') {
				if (!force && this.animate) {
					var progress = 1;
	
					if (this._track) {
						progress = this._track.progress;
					} else if (this._frames) {
						progress = this._frame++ / this._frames;
					}
	
					if (typeof progress !== 'number' || progress >= 1) {
						progress = 1;
						force = true;
					}
	
					value = this._base + this._delta * progress;
				}
	
				value = $.plugins.meter.__format(value, this._scale);
			}
	
			if (typeof this.max !== 'undefined') {
				value = value + ' of ' + this.max;
			}
	
			this.field.html(value);
	
			if (force) {
				if (this.animate && (this._frames || this._track)) {
					this.timer = clearInterval(this.timer);
					delete this._frames;
					delete this._track;
	
					this.trigger('done');
				} else if (immediate && this._value !== 0) {
					this.trigger('done');
				}
			}
	
			return this;
		},
	
		isReady: function isReady() {
			if (this._track) {
				return this._track.progress >= 1;
			} else {
				return !this._frames;
			}
		}
	};

/***/ },
/* 69 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.fontstrip = {
		animate: false,
		_value: null,
		_delta: 0,
		_scale: null,
	
		__scale: {
			factor: 50,
			max: 4.25,
			min: 0
		},
	
		__format: function __format(value, scale) {
			if (typeof scale === 'undefined' || scale === null) {
				value = Math.floor(value);
				scale = true;
			} else if (typeof scale === 'number' && scale > 0) {
				if (scale <= .1) {
					value = Math.floor(value / (scale * 1000) * 100) / 100;
					scale = false;
				} else {
					value = Math.floor(value / scale);
				}
			} else if (scale === false) {
				value = Math.floor(value / 100 * 100) / 100;
				scale = false;
			} else {
				value = Math.floor(value) / 100;
				scale = false;
			}
	
			var parts = value.toFixed(scale ? 0 : 2).split('.');
			parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			value = parts.join('.');
	
			return value;
		},
	
		__init: function __init(config) {
			if (config.label === undefined) {
				config.label = '';
			}
			this.apply('widget', { label: config.label, value: true }).addClass('fontstrip');
	
			if (typeof config.value !== 'undefined') {
				this.set(config.value);
			}
	
			if (config.animate) {
				this.animate = true;
			}
	
			this.characters = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, '$', '.', ','];
			if (config.characters) {
				this.characters = config.characters;
			}
	
			this.characters = this.characters.map(function (char) {
				return char = char.toString();
			});
	
			this.field.pieces = [];
			this.field.length = 0;
		},
	
		scale: function scale(value) {
			this._scale = value;
	
			return this.update();
		},
	
		inc: function inc(value, immediate) {
			this.set(this._value + value, immediate);
		},
	
		set: function set(value, immediate) {
			if (value === true) {
				return this.set(this._value, true);
			}
			if (value === null || value === undefined) {
				value = 0;
			}
	
			this._base = this._value || 0;
			this._value = value;
			this._delta = this._value - this._base;
	
			if (!this._value || this._delta <= 0) {
				immediate = true;
			}
	
			if (this.animate && this._value && immediate !== true) {
				if (immediate && immediate.hasOwnProperty('progress')) {
					this._track = immediate;
				} else {
					var meterdata = $.plugins.meter.__scale;
					var scale = 1;
	
					if (immediate && immediate.scale) {
						scale = typeof immediate.scale === 'number' ? immediate.scale : this._scale;
					}
	
					var seconds = typeof immediate === 'number' ? immediate : (meterdata.max - meterdata.min) * (1 - Math.exp(-this._delta / (scale * meterdata.factor))) + meterdata.min;
	
					this._frames = Math.ceil(seconds * 24);
					this._frame = 0;
				}
	
				this.timer = setInterval(this.update.bind(this), 1000 / 24);
			} else {
				return this.update();
			}
		},
	
		update: function update(force) {
			var value = this._value;
	
			if (typeof value === 'number') {
				if (!force && this.animate) {
					var progress = 1;
	
					if (this._track) {
						progress = this._track.progress;
					} else if (this._frames) {
						progress = this._frame++ / this._frames;
					}
	
					if (typeof progress !== 'number' || progress >= 1) {
						progress = 1;
						force = true;
					}
	
					value = this._base + this._delta * progress;
				}
	
				value = $.plugins.meter.__format(value, this._scale);
			}
	
			if (typeof this.max !== 'undefined') {
				value = value + ' of ' + this.max;
			}
			var val = 0;
	
			if (value || value === 0) {
				val = value.toString();
			}
			this._length = val.length;
	
			var change_divs = this._length - this.field.length;
	
			if (change_divs > 0) {
				/* add more divs */
				for (var i = 0; i < change_divs; i++) {
					this.field.pieces.push($.div().appendTo(this.field));
					this.field.length++;
				}
			} else if (change_divs < 0) {
				/* remove divs */
				for (var i = 0; i < Math.abs(change_divs); i++) {
					this.field.pieces.shift().remove();
					this.field.length--;
				}
			}
	
			for (var i = 0; i < this.field.length; i++) {
				var index = this.characters.indexOf(val[i]);
	
				this.field.pieces[i].css('background-position', +(index / (this.characters.length - 1)) * 100 + '%');
				this.field.pieces[i].attr('class', '_' + index);
			}
	
			if (this.animate && force && (this._frames || this._track)) {
				this.timer = clearInterval(this.timer);
				delete this._frames;
				delete this._track;
	
				this.trigger('done');
			}
	
			return this;
		},
	
		font: function font(number) {},
	
		isReady: function isReady() {
			if (this._track) {
				return this._track.progress >= 1;
			} else {
				return !this._frames;
			}
		}
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	$.plugins.counter = {
		value: 0,
		values: [],
		labels: null,
	
		__init: function __init(config) {
			this.apply('widget', { label: config.label, value: true }).addClass('counter');
	
			if (config.menu) {
				this.addMenu(_typeof(config.menu) === 'object' ? config.menu : { transition: 'up' }, typeof config.menu_disabled === 'undefined' ? true : config.menu_disabled);
				this.items = [];
	
				if (typeof config.menu === 'string') {
					this.menu.addClass(config.menu);
				}
			} else {
				this.arrows = {
					dec: $.div().addClass('dec').appendTo(this).on('click', function () {
						if (game.panel.disabled) {
							return;
						}
	
						this.dec();
					}.bind(this)),
	
					inc: $.div().addClass('inc').appendTo(this).on('click', function () {
						if (game.panel.disabled) {
							return;
						}
	
						this.inc();
					}.bind(this))
				};
			}
	
			if (config.values) {
				this.reset(config.values);
			}
		},
	
		reset: function reset(values, value, labels) {
			this.values = values;
			this.labels = labels;
			this.value = value || 0;
	
			while (this.value < 0) {
				this.value += this.values.length;
			}
	
			if (this.menu) {
				this.addClass('button');
				this.menu.clear();
				this.items = [];
	
				for (var i = 0; i < this.values.length; i++) {
					value = this.values[i];
	
					if (typeof value === 'number') {
						value = $.plugins.meter.__format(value);
					}
	
					var label = this.labels && this.labels[i] ? this.labels[i] : value;
	
					var item = $.div().apply('button', { label: label });
					this.menu.addItem(item);
	
					item.on('click', function (i) {
						this.value = i;
						this.update();
					}.bind(this, i));
	
					this.items.push(item);
				}
	
				this.trigger('reset');
			} else {
				for (var b in this.arrows) {
					this.arrows[b].css('display', this.values.length > 1 ? null : 'none');
				}
			}
	
			this.update();
	
			return this;
		},
	
		update: function update() {
			var value = this.values[this.value];
	
			if (typeof value === 'number') {
				value = $.plugins.meter.__format(value);
			}
	
			this.field.html(this.labels && this.labels[this.value] ? this.labels[this.value] : value);
	
			this.trigger('update', { value: this.values[this.value], label: this.labels && this.labels[this.value] ? this.labels[this.value] : null });
	
			return this.values[this.value];
		},
	
		get: function get(label) {
			return label && this.labels && this.labels[this.value] ? this.labels[this.value] : this.values[this.value];
		},
	
		set: function set(value) {
			this.value = this.values.indexOf(value);
	
			if (this.value < 0) {
				this.value = 0;
			}
	
			return this.update();
		},
	
		dec: function dec() {
			if (this.disabled) {
				return;
			}
	
			if (this.value - 1 < 0 && !window.counter_wrap) {
				return this.update();
			}
	
			this.value = (this.value - 1 + this.values.length) % this.values.length;
	
			if (this.value < 0) {
				this.value = 0;
			}
	
			return this.update();
		},
	
		inc: function inc() {
			if (this.disabled) {
				return;
			}
	
			this.value = (this.value + 1) % this.values.length;
	
			return this.update();
		},
	
		max: function max() {
			if (this.disabled) {
				return;
			}
	
			this.value = this.values.length - 1;
	
			return this.update();
		}
	};

/***/ },
/* 71 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.roller = {
		value: 0,
		values: [],
		labels: null,
	
		__init: function __init(config) {
			this.apply('widget', { label: config.label }).addClass('roller');
	
			this.items = [];
	
			this.container = $.div().addClass('container').appendTo(this);
			this.slider = $.div().addClass('slider').appendTo(this.container);
	
			if (config.values) {
				this.reset(config.values);
			}
	
			var roller = this;
			var isdown = false;
			var zero = null;
			var em = null;
			this.container.on('touchstart', function (e) {
				isdown = true;
				em = parseFloat(window.getComputedStyle(roller.el).fontSize);
				roller.slider.removeClass('transition');
	
				var touch = e.touches[0] || e.changedTouches[0];
				zero = touch.clientY;
			});
	
			$(document).on('touchmove', function (e) {
				if (!isdown) {
					return;
				}
	
				var touch = e.touches[0] || e.changedTouches[0];
				var shift = -roller.value * 2.5 + (touch.clientY - zero) / em;
				roller.slider.css('transform', 'translateY(' + shift + 'em)');
				roller.slider.css('-webkit-transform', 'translateY(' + shift + 'em)');
			});
	
			$(document).on('touchend', function (e) {
				if (!isdown) {
					return;
				}
	
				isdown = false;
	
				var touch = e.touches[0] || e.changedTouches[0];
				var shift = -roller.value * 2.5 + (touch.clientY - zero) / em;
				var value = Math.round(-shift / 2.5);
	
				value = Math.min(Math.max(value, 0), roller.values.length - 1);
	
				roller.set(roller.values[value]);
			});
		},
	
		reset: function reset(values, value, labels) {
			this.values = values;
			this.labels = labels;
			this.value = value || 0;
	
			while (this.value < 0) {
				this.value += this.values.length;
			}
	
			this.slider.empty();
			this.items = [];
	
			for (var i = 0; i < this.values.length; i++) {
				value = this.values[i];
				if (typeof value === 'number') {
	
					if (value >= 1000000000) {
						value = value / 1000000000 + 'B';
					} else if (value >= 1000000 && value < 1000000000) {
						value = value / 1000000 + 'M';
					} else if (value >= 10000 && value < 1000000) {
						value = value / 1000 + 'K';
					} else {
						value = $.plugins.meter.__format(value);
					}
				}
	
				var label = this.labels && this.labels[i] ? this.labels[i] : value;
	
				var item = $.div().addClass('option').apply('widget', { label: label });
	
				item.appendTo(this.slider);
				this.items.push(item);
			}
	
			this.trigger('reset');
	
			this.update();
	
			return this;
		},
	
		update: function update() {
			var value = this.values[this.value];
	
			if (typeof value === 'number') {
				value = $.plugins.meter.__format(value);
			}
	
			this.slider.addClass('transition');
			setTimeout($p.removeClass.bind(this.slider, 'transition'), 250);
	
			var shift = -this.value * 2.5;
			this.slider.css('transform', 'translateY(' + shift + 'em)');
			this.slider.css('-webkit-transform', 'translateY(' + shift + 'em)');
	
			this.trigger('update', { value: this.values[this.value], label: this.labels && this.labels[this.value] ? this.labels[this.value] : null });
	
			return this.values[this.value];
		},
	
		get: function get(label) {
			return label && this.labels && this.labels[this.value] ? this.labels[this.value] : this.values[this.value];
		},
	
		set: function set(value) {
			this.value = this.values.indexOf(value);
	
			if (this.value < 0) {
				this.value = 0;
			}
	
			return this.update();
		},
	
		dec: function dec() {
			if (this.disabled) {
				return;
			}
	
			if (this.value - 1 < 0) {
				return this.update();
			}
	
			this.value = (this.value - 1 + this.values.length) % this.values.length;
	
			if (this.value < 0) {
				this.value = 0;
			}
	
			return this.update();
		},
	
		inc: function inc() {
			if (this.disabled) {
				return;
			}
	
			this.value = (this.value + 1) % this.values.length;
	
			return this.update();
		},
	
		max: function max() {
			if (this.disabled) {
				return;
			}
	
			this.value = this.values.length - 1;
	
			return this.update();
		}
	};

/***/ },
/* 72 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.toggle = {
		_value: false,
	
		__init: function __init(config) {
			this.apply('widget', { label: config.label }).addClass('button toggle');
	
			if (config.span !== false) {
				this.span = $.element('span').html('&nbsp;').appendTo(this.label || this);
			}
	
			this.toggle(config.value === false ? false : true);
	
			this.on('click', this.toggle.bind(this), true);
		},
	
		is: function is() {
			return this._value;
		},
	
		toggle: function toggle(force) {
			this._value = typeof force === 'boolean' ? !!force : !this._value;
	
			this.toggleClass('active', this._value);
	
			if (this.span) {
				this.span.toggleClass('active', this._value);
			}
	
			this.trigger('update', { value: this._value });
	
			return this;
		}
	};

/***/ },
/* 73 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.menu = {
		__init: function __init(config) {
			this.addClass('menu');
	
			if (game.panel) {
				game.panel.registerMenu(this);
			}
	
			if (config.transition) {
				this.addClass(config.transition);
			}
	
			this.addClass('show').hide();
		},
	
		addItem: function addItem(item) {
			item.appendTo(this);
	
			return this;
		},
	
		clear: function clear() {
			return this.empty();
		},
	
		toggle: function toggle() {
			if (this.hasClass('show')) {
				return this.hide();
			} else {
				return this.show();
			}
		},
	
		show: function show() {
			if (this.hasClass('show')) {
				return this;
			}
	
			if (game.panel && game.panel.menu) {
				game.panel.menu.trigger('showMenu');
			}
	
			this.addClass('show');
			this.css('display', null);
			this.reinsert();
	
			return this;
		},
	
		hide: function hide() {
			if (!this.hasClass('show')) {
				return this;
			}
	
			if (game.panel && game.panel.menu) {
				game.panel.menu.trigger('hideMenu');
			}
	
			this.removeClass('show');
			this.reinsert();
			setTimeout(function () {
				if (!this.hasClass('show')) {
					this.css('display', 'none');
				}
			}.bind(this), 500);
	
			return this;
		}
	};

/***/ },
/* 74 */
/***/ function(module, exports) {

	'use strict';
	
	$.plugins.dialog = {
		__init: function __init() {
			this.addClass('dialog');
	
			this.container = $.div().addClass('container').appendTo(this);
	
			this.pages = {};
	
			this._current = $.div();
			this._content = null;
			this._page = null;
	
			this.pager = $.div().addClass('pager').appendTo(this.container);
	
			this.pager.left = $.div().addClass('arrow left').appendTo(this.pager);
			this.pager.bubbles = $.div().addClass('bubbles').appendTo(this.pager);
			this.pager.right = $.div().addClass('arrow right').appendTo(this.pager);
	
			var dialog = this;
	
			this.pager.left.on('click', function () {
				dialog.page(dialog._page - 1);
			});
	
			this.pager.right.on('click', function () {
				dialog.page(dialog._page + 1);
			});
	
			this.pager.exit = $.div().addClass('close').appendTo(this.container);
			this.pager.exit.on('click', function () {
				dialog.hide();
			});
	
			this.addClass('show').hide();
		},
	
		hide: function hide() {
			this.trigger('hide', this._content);
	
			if (!this.hasClass('show')) {
				return this;
			}
	
			this.removeClass('show');
			this.reinsert();
	
			setTimeout(function () {
				if (!this.hasClass('show')) {
					this.css('display', 'none');
				}
			}.bind(this), 500);
	
			delete this._content;
	
			return this;
		},
	
		show: function show(content, page) {
			if (typeof content === 'string') {
				var slug = content;
	
				content = this.pages[slug];
	
				if (!content) {
					this.trigger('unknown', slug);
					return;
				}
	
				content.slug = slug;
			}
	
			if (!content) {
				throw new Error('Unknown content: ' + content);
			}
	
			this._content = content;
	
			this.container.attr('class', 'container');
	
			if (this._content.slug) {
				this.container.addClass(this._content.slug);
			}
	
			if (this._content.constructor === Array) {
				this.pager.css('display', null);
	
				var dialog = this;
	
				this.pager.bubbles.empty();
				this.pager.bubbles.length = this._content.length;
	
				for (var i = 0; i < this.pager.bubbles.length; i++) {
					this.pager.bubbles[i] = $.div().addClass('bubble').appendTo(this.pager.bubbles);
					this.pager.bubbles[i].on('click', function () {
						dialog.page(this.index());
					});
				}
			} else {
				this.pager.css('display', 'none');
			}
	
			if (this._content.constructor === this.constructor && this._content.hasClass('noexit')) {
				this.pager.exit.css('display', 'none');
			} else {
				this.pager.exit.css('display', null);
			}
	
			this.page(page || 0);
	
			this.addClass('show');
			this.css('display', null);
			this.reinsert();
	
			this.trigger('show', this._content);
	
			return this;
		},
	
		page: function page(_page) {
			if (this._content.constructor === Array && !this._content[_page]) {
				return;
			}
	
			if (this._content.constructor === Array) {
				this._page = _page;
	
				this._current.remove();
				this._current = this._content[this._page];
				this._current.prependTo(this.container);
	
				for (var i = 0; i < this.pager.bubbles.length; i++) {
					this.pager.bubbles[i].toggleClass('active', i === this._page);
				}
	
				if (this._page > 0) {
					this.pager.left.removeClass('disabled');
				} else {
					this.pager.left.addClass('disabled');
				}
	
				if (this._page < this._content.length - 1) {
					this.pager.right.removeClass('disabled');
				} else {
					this.pager.right.addClass('disabled');
				}
			} else {
				this._current.remove();
				this._current = this._content;
				this._current.prependTo(this.container);
			}
	
			return this;
		}
	};

/***/ },
/* 75 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(171);
	__webpack_require__(174);
	__webpack_require__(175);
	__webpack_require__(176);
	__webpack_require__(177);
	__webpack_require__(178);
	__webpack_require__(179);
	__webpack_require__(180);
	__webpack_require__(181);
	__webpack_require__(182);
	__webpack_require__(183);
	
	__webpack_require__(184);
	__webpack_require__(186);
	__webpack_require__(188);
	__webpack_require__(190);
	__webpack_require__(193);
	__webpack_require__(195);
	__webpack_require__(197);

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/* global $ */
	
	$.ready(function () {
		/* global controller, loader */
		/* global spinClear, spinInit, spinReady, spinDone */
	
		var game = window.game = $('game');
		game.engine = 'slot';
		game.container = $.div('container').appendTo(game);
		game.controller = controller;
	
		game.dimensions = {
			width: 1920,
			height: 1080,
			font: 36,
			screen_width: 1920,
			screen_height: 1080
		};
	
		loader.loadImages();
		loader.start('socket');
		loader.start('build');
	
		game.play = function () {
			if (game.panel.disabled) {
				return;
			}
	
			game.panel.disable('spin');
			game.panel.play.addClass('disabled');
	
			game.sounds.stop('win');
			game.panel.setWin(true);
	
			game.trigger('round_start', game.panel.getBet());
	
			var bet = game.panel.getBet();
			bet.bet = bet.coins;
			delete bet.coins;
	
			spinClear();
			game.spindle.spin();
	
			game.controller.socket.emit('spin', bet);
		};
	
		game.spin = function (response) {
			game.last = response;
	
			spinReady();
		};
	
		game.setTurbo = function (value) {
			this.turbo = !!value;
	
			if (value && game.spindle.stop > -1) {
				game.spindle.stop = -1;
			}
		};
	
		game.controller.socket.on('spin', function (response) {
			game.panel.play.removeClass('disabled');
			game.spin(response);
		});
	
		game.on('reable', function () {
			game.panel.play.removeClass('disabled');
		});
	
		game.controller.socket.on('open', function (config) {
			game.config = config;
	
			loader.stop('socket');
	
			game.trigger('ui', config);
	
			game.messaging.show('logo');
			game.panel.spin.update();
			game.panel.dialog.appendTo(game);
	
			game.sounds.loadSounds({
				reels: __webpack_require__(172),
				bell: __webpack_require__(173)
			});
	
			/* Recover / Recall */
	
			if (config.recover) {
				game.panel.disable('spin');
				var response = game.last = config.recover;
	
				if (typeof response.bet.bet !== 'undefined' && typeof response.bet.coins === 'undefined') {
					response.bet.coins = response.bet.bet;
					delete response.bet.bet;
				}
	
				game.panel.setBet(response.bet);
				game.pays.clear();
			} else if (config.recall) {
				var action = config.recall.actions[0];
	
				if (config.recall.date && action.response.bonuses) {
					action.response.bonuses = [];
				}
	
				action.response.credits = config.credits;
				game.showRecall(action);
			}
	
			loader.stop('build');
		});
	
		game.on('ready', function () {
			game.sounds.play(['background'], { loop: true });
	
			if (game.config.recover) {
				spinClear();
				spinInit();
				spinReady();
				spinDone();
	
				game.trigger('recover', game.config.recover);
			}
		});
	});

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ff3531853a3899258f241c2bb444a10b.mp3";

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/a83dc8dead7ebbbe98ee4c06eab0222b.mp3";

/***/ },
/* 174 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		/* global spinClear, spinInit, spinReady, spinDone */
	
		var feature = game.feature = $.div('feature').appendTo(game);
	
		feature.messages = $.div().addClass('messages');
	
		var messages = feature.messages2 = $.div().addClass('messages');
		messages.overall = $.div().apply('meter', {}).addClass('overall').appendTo(messages);
	
		feature.showMessage = function (type, value, noHide) {
			if (typeof value === 'number') {
				messages.overall.set(value);
				messages.overall.removeClass('hide');
			} else {
				messages.overall.addClass('hide');
			}
	
			feature.messages.removeClass('hide');
			messages.attr('class', 'messages ' + type);
			if (!noHide) {
				game.panel.hide(true);
			}
		};
	
		feature.hideMessages = function () {
			messages.addClass('hide');
			feature.messages.addClass('hide');
	
			game.panel.show(true);
		};
	
		game.features = {};
	
		game.feature.active = false;
	
		game.feature.begin = function (key) {
			game.old = game.last;
	
			game.feature.active = key;
	
			var bonus = game.features[key];
	
			if (!bonus) {
				game.panel.dialog.show('fatal');
	
				return;
			}
	
			game.sounds.fade(['background'], 1, 0, 0.5);
			game.sounds.play('bell');
	
			setTimeout(function () {
				feature.attr('class', 'active');
	
				game.panel.disable(key);
				messages.appendTo(bonus);
	
				bonus.methods.init();
				feature.messages.appendTo(feature);
				bonus.appendTo(feature);
	
				game.controller.socket.emit('feature', { name: key, action: 'begin' });
	
				setTimeout(function () {
					game.addClass('bonus');
				}, game.last.quickTransition ? 0 : 1000);
			}, game.last.quickTransition ? 0 : 3000);
		};
	
		game.feature.finish = function () {
			var last = game.last;
	
			game.last = game.old;
			game.last.win += last.win;
			game.last.credits = last.credits;
			game.last.raw = game.last.raw || last.raw;
	
			game.sounds.stop(game.feature.active);
			game.sounds.fade(['background'], 0, 1, 0.5);
	
			game.feature.active = false;
	
			spinClear(true);
			spinInit(true);
			spinReady(true);
			game.removeClass('bonus');
			feature.removeClass('show');
	
			if (game.panel.type === 'desktop') {
				game.panel.play.addClass('base');
				game.panel.spin.appendTo(game.panel.play);
			}
	
			if (game.panel.type === 'mobile') {
				game.panel.play.addClass('icon-spin');
			}
	
			setTimeout(function () {
				feature.empty();
				feature.attr('class', null);
				spinDone();
	
				game.feature.hideMessages();
			}, game.last.quickTransition ? 0 : 1000);
		};
	
		game.on('ui', function () {
			game.panel.registerCash(messages.overall, true);
		});
	
		game.controller.socket.on('feature', function (response) {
			var bonus = game.features[response.name];
	
			if (!bonus) {
				game.panel.dialog.show('fatal');
	
				return;
			}
	
			if (response.action === 'begin') {
				if (game.panel.type === 'desktop') {
					game.panel.spin.remove();
					game.panel.play.removeClass('base');
					game.panel.play.addClass(bonus.key);
				}
	
				if (game.panel.type === 'mobile') {
					game.panel.play.removeClass('icon-spin');
				}
	
				feature.addClass('show');
			} else if (response.action === 'spin') {
				game.spin(response);
			}
	
			game.last = response;
	
			if (bonus.methods[response.action]) {
				bonus.methods[response.action](response);
			}
	
			if (response.action === 'finish') {
				if (game.panel.type === 'desktop') {
					game.panel.play.removeClass(bonus.key);
				}
			}
		});
	});

/***/ },
/* 175 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var panel = game.panel = $.div('panel').apply('panel', { game: game }).appendTo(game);
	
		/* Overrides */
		/* globals base spinClear */
		{
			panel.setBet = function (values) {
				for (var key in values) {
					if (!this[key]) {
						continue;
					}
	
					this[key].set(values[key]);
				}
			};
	
			panel.getBet = function () {
				var bet = {
					denom: panel.denom.get(),
					coins: panel.coins.get()
				};
	
				if (game.pays.type === 'lines') {
					bet.lines = panel.lines.get();
				}
	
				game.trigger('bet', bet);
	
				return bet;
			};
		}
	
		/* Play Button */
		{
			panel.spin = $.div().apply('widget', { label: 'Spin', value: true }).addClass('meter');
	
			panel.spin.scale = function () {
				if (panel.isCash) {
					this._scale = 1 / panel.denom.get();
				} else {
					this._scale = false;
				}
	
				return this.update();
			};
	
			panel.spin.update = function () {
				var bet = panel.getBet();
				delete bet.denom;
	
				var cost = game.pays.cost || 1;
	
				var key;
	
				for (key in bet) {
					if (key.substr(-5) === '_cost') {
						continue;
					}
	
					if (typeof bet[key] === 'number') {
						cost *= bet[key];
					}
				}
	
				for (key in bet) {
					if (key.substr(-5) !== '_cost') {
						continue;
					}
	
					if (typeof bet[key] === 'number') {
						cost += bet[key] * bet.coins;
					}
				}
	
				if (typeof this._scale === 'number') {
					game.panel.spin.set($.plugins.meter.__format(cost / this._scale, false));
				} else {
					game.panel.spin.set($.plugins.meter.__format(cost));
				}
			};
	
			if (panel.type === 'desktop') {
				panel.registerCash(panel.spin);
	
				panel.play.addClass('base');
				panel.spin.appendTo(panel.play);
			}
	
			if (panel.type === 'mobile') {
				panel.play.addClass('icon-spin');
				panel.registerCash(panel.spin, true);
				panel.spin.label.html('Bet');
	
				panel.spin.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					game.panel.dialog.show(game.panel.bet);
					game.panel.hud.hide();
				});
	
				panel.addItem(panel.spin, 'bottom middle');
			}
		}
	
		/* Betting */
		{
			if (panel.type === 'desktop') {
				panel.lines = $.div().apply('counter', { label: 'Pays' });
				panel.addItem(panel.lines, 'left');
				panel.lines.on('update', function () {
					panel.spin.update();
	
					game.pays.clear(true, true);
					game.pays.drawLines(this.get());
	
					game.sounds.play(['buttons', 'lines', 'line_' + this.value]);
				});
	
				panel.coins = $.div().apply('counter', { label: 'Bet Per' });
				panel.addItem(panel.coins, 'right');
				panel.coins.on('update', function () {
					panel.spin.update();
					var betSound = this.value;
	
					while (!game.sounds.fallback && !game.sounds.sounds.buttons.coins['bet_' + betSound]) {
						betSound--;
					}
	
					game.sounds.play(['buttons', 'coins', 'bet_' + betSound]);
				});
	
				panel.denom = $.div().apply('counter', { label: 'Denom', menu: 'small' });
				panel.denom.max = null;
				panel.addItem(panel.denom, 'right far');
				panel.denom.on('update', function () {
					panel.spin.update();
					panel.updateCash();
	
					game.sounds.play(['buttons', 'denoms', 'denom_' + this.value]);
				});
	
				panel.denom.addClass('denom cash');
				panel.denom.field.addClass('cash');
				panel.denom.on('reset', function () {
					for (var i = 0; i < this.items.length; i++) {
						this.items[i].label.addClass('cash');
					}
				});
	
				panel.max = $.div().apply('button', { label: 'Max' });
				panel.addItem(panel.max, 'right mini');
				panel.max.on('click', function () {
					if (game.panel.disabled) {
						return;
					}
	
					panel.coins.max();
					panel.lines.max();
					game.sounds.play(['buttons', 'max']);
				});
			}
	
			if (panel.type === 'mobile') {
				panel.lines = $.div().apply('roller', { label: 'Pays' });
				panel.addItem(panel.lines, 'bet');
				panel.lines.on('update', function () {
					panel.spin.update();
	
					game.pays.clear(true, true);
					game.pays.drawLines(this.get());
					game.sounds.play(['buttons', 'lines', 'line_' + this.value]);
				});
	
				panel.coins = $.div().apply('roller', { label: 'Coins' });
				panel.addItem(panel.coins, 'bet');
				panel.coins.on('update', function () {
					panel.spin.update();
					game.sounds.play(['buttons', 'coins', 'bet_' + this.value]);
				});
	
				panel.denom = $.div().apply('roller', { label: 'Denom' });
				panel.denom.max = null;
				panel.addItem(panel.denom, 'bet');
				panel.denom.on('update', function () {
					panel.spin.update();
					panel.updateCash();
					game.sounds.play(['buttons', 'denoms', 'denom_' + this.value]);
				});
	
				panel.denom.addClass('cash');
				panel.denom.on('reset', function () {
					for (var i = 0; i < this.items.length; i++) {
						this.items[i].label.addClass('cash');
					}
				});
			}
		}
	
		/* Events */
	
		panel.on('play', function () {
			if (!game.feature.active || game.feature.active === 'freespin') {
				if (game.autoplay.isActive()) {
					game.autoplay.set(0);
	
					return;
				}
	
				game.spindle.stop = -1;
	
				if (!panel.win.isReady() || game.last && game.last.doubleRollup) {
					panel.setWin(true);
					game.trigger('slamPays');
					return;
				}
			}
	
			game.play();
		});
	
		panel.on('slam', function () {
			if (!game.feature.active || game.feature.active === 'freespin') {
				if (game.autoplay.isActive()) {
					game.autoplay.set(0);
	
					return;
				}
	
				game.spindle.stop = -1;
	
				if (!panel.win.isReady()) {
					panel.setWin(true);
					game.trigger('slamPays');
					return;
				}
			}
	
			if (game.feature.active && game.panel.state === game.feature.active) {
				game.features[game.feature.active].trigger('play');
	
				return;
			}
		});
	
		panel.dialog.on('hide', function (e) {
			if (!e.detail) {
				return;
			}
	
			if (e.detail.slug === 'credits') {
				spinClear();
				panel.enable();
			}
		});
	
		panel.win.on('done', function () {
			panel.setCredits(game.last.credits);
	
			if (game.feature.active) {
				game.sounds.fade([game.feature.active, 'background'], 0, 1, 1.5);
			} else {
				game.sounds.fade(['background'], 0, 1, 0.5);
			}
	
			if (game.last.doubleRollup) {
				return;
			}
	
			game.trigger('round_complete');
		});
	
		game.controller.socket.on('spin', function (response) {
			panel.setCredits(response.credits - (response._win || 0));
		});
	
		game.on('ui', function (config) {
			config = config.detail;
	
			panel.setCredits(config.credits);
	
			panel.coins.reset(config.bet.bets, 0);
	
			if (config.lines) {
				panel.lines.label.html('Lines');
				panel.lines.reset(config.bet.lines, -1);
			} else if (config.ways) {
				var ways = 0;
				if (config.rows.constructor === Array) {
					ways = config.rows.reduce(function (rows, reel) {
						return rows * reel;
					}, 1);
				} else {
					ways = Math.pow(config.rows, config.reels);
				}
	
				panel.lines.label.html('Ways');
				panel.lines.reset([ways], -1);
			}
	
			var denoms = [];
	
			for (var d = 0; d < config.bet.denoms.length; d++) {
				denoms.push($.plugins.meter.__format(config.bet.denoms[d], false));
			}
	
			panel.denom.reset(config.bet.denoms, 0, denoms);
	
			game.pays.clear();
		});
	
		game.on('ready', function () {
			if (!panel.state) {
				panel.enable();
			}
		});
	});

/***/ },
/* 176 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var autoplay = game.autoplay = {};
	
		autoplay.state = {};
	
		autoplay.set = function (count) {
			autoplay.state.count = count;
	
			if (!autoplay.state.count || typeof autoplay.state.count !== 'number') {
				if (autoplay.state.active) {
					if (game.panel.type === 'desktop') {
						game.panel.spin.label.html('Spin');
					}
	
					if (game.panel.type === 'mobile') {
						game.panel.play.removeClass('icon-stop').addClass('icon-spin');
					}
				}
	
				autoplay.state.count = 0;
				autoplay.state.active = false;
			}
	
			if (game.panel.type === 'desktop') {
				if (autoplay.state.count) {
					game.panel.auto.label.html(autoplay.state.count);
				} else {
					game.panel.auto.label.html('Auto');
				}
			}
	
			if (game.panel.type === 'mobile') {
				if (autoplay.state.count > 0) {
					game.panel.play.set(autoplay.state.count);
				} else {
					game.panel.play.set('');
				}
			}
		};
	
		autoplay.isActive = function () {
			return !game.feature.active && autoplay.state.active;
		};
	
		game.on('round_init', function () {
			if (game.feature.active) {
				return;
			}
	
			if (autoplay.state.count <= 1) {
				autoplay.set(0);
	
				return;
			}
	
			autoplay.state.active = true;
			autoplay.set(autoplay.state.count - 1);
	
			if (game.panel.type === 'desktop') {
				game.panel.spin.label.html('Stop');
			}
	
			if (game.panel.type === 'mobile') {
				game.panel.play.removeClass('icon-spin').addClass('icon-stop');
			}
		});
	
		game.on('round_complete', function () {
			if (game.feature.active) {
				return;
			}
	
			if (autoplay.state.count <= 0) {
				autoplay.set(0);
	
				return;
			}
	
			setTimeout(function () {
				if (autoplay.state.count <= 0) {
					autoplay.set(0);
	
					return;
				}
	
				game.play();
			}, 1000);
		});
	
		/* Panel */
		{
			if (game.panel.type === 'desktop') {
				game.panel.auto = $.div().addClass('auto').apply('counter', { label: 'Auto', menu: true, menu_disabled: false });
				game.panel.auto.removeClass('counter').addClass('button');
				game.panel.auto.menu.addClass('small');
				game.panel.addItem(game.panel.auto, 'left mini');
	
				game.panel.auto.on('click', function (e) {
					if (e.target === this.el || e.target === this.label.el) {
						game.sounds.play(['buttons', 'auto']);
					}
				});
	
				game.panel.auto.on('update', function () {
					autoplay.set(this.get());
	
					game.sounds.play(['buttons', 'autos', 'auto_' + this.value]);
				});
			}
	
			if (game.panel.type === 'mobile') {
				autoplay.bet = $.div();
				autoplay.bet.slug = 'bet';
	
				autoplay.bet.play = $.div().apply('button', { label: 'Bet play' }).addClass('play center').appendTo(autoplay.bet);
				autoplay.bet.play.on('click', function () {
					game.panel.dialog.hide();
					autoplay.set(game.panel.auto.get());
				});
	
				game.panel.auto = $.div().apply('roller', { label: 'Auto Play' }).appendTo(autoplay.bet);
	
				game.panel.auto.on('update', function () {
					autoplay.set(this.get());
					game.sounds.play(['buttons', 'autos', this.value]);
				});
	
				game.panel.hud.auto = $.div().apply('button', { label: 'Auto Play' });
				game.panel.addItem(game.panel.hud.auto, 'hud right top');
	
				game.panel.hud.auto.on('click', function (e) {
					game.panel.dialog.show(autoplay.bet);
					game.panel.hud.hide();
	
					if (e.target === this.el || e.target === this.label.el) {
						game.sounds.play(['buttons', 'auto']);
					}
				});
			}
		}
	
		game.on('ui', function (config) {
			config = config.detail;
	
			var autoplay = [];
	
			for (var d = 0; d < config.bet.autoplay.length; d++) {
				autoplay.push($.plugins.meter.__format(config.bet.autoplay[d]));
			}
	
			config.bet.autoplay.reverse();
			autoplay.reverse();
	
			config.bet.autoplay.push(0);
			autoplay.push('Off');
	
			game.panel.auto.reset(config.bet.autoplay, -1, autoplay);
		});
	});

/***/ },
/* 177 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $, game */
	
	$.ready(function () {
		/* global spinReady, spinDone, scatterCan */
	
		var spindle = game.spindle = $.div('spindle').appendTo(game.container);
		spindle.reels = [];
	
		var frame = game.frame = $.div('frame').appendTo(game.container);
		frame.reels = [];
	
		game.on('scale', function () {
			for (var reel = 0; reel < frame.reels.length; reel++) {
				for (var row = 0; row < frame.reels[reel].symbols.length; row++) {
					var symbol = frame.reels[reel].symbols[row];
	
					symbol.css('width', null);
					symbol.css('width', symbol.el.offsetWidth);
				}
			}
		});
	
		spindle.spin = function () {
			this.trigger('spin');
			for (var reel in spindle.reels) {
				spindle.reels[reel].addClass('start');
				spindle.reels[reel].update('first');
			}
		};
	
		spindle.clear = function () {
			for (var reel in spindle.reels) {
				spindle.reels[reel].removeClass('start loop end');
			}
		};
	
		spindle.on('animationend', 'reel', function () {
			var index = this.index();
	
			if (this.hasClass('start')) {
				if (spindle.stop === -1) {
					this.addClass('end');
				} else {
					this.addClass('loop');
				}
	
				this.removeClass('start');
	
				/* eslint-disable no-bitwise */
				spindle.ready |= 1 << index;
	
				if (spindle.ready === (1 << spindle.reels.length) - 1) {
					spinReady();
				}
				/* eslint-enable no-bitwise */
			} else if (this.hasClass('end')) {
				game.anticipation.hide(index);
	
				game.trigger('reel_stop', { index: index });
	
				if (spindle.stop >= 0) {
					spindle.stop++;
				}
	
				this.removeClass('end');
	
				/* eslint-disable no-bitwise */
				spindle.done |= 1 << index;
	
				if (spindle.done === (1 << spindle.reels.length) - 1) {
					spinDone();
				}
				/* eslint-enable no-bitwise */
			}
		});
	
		spindle.on('animationiteration', 'reel', function () {
			if (this.hasClass('loop')) {
				var index = this.index();
	
				if (spindle.stop === index) {
					/* jshint -W004 */
					for (var s in game.specials) {
						/* jshint +W004 */
	
						if (game.specials[s].anticipate && game.specials[s].count >= game.specials[s].min && scatterCan(s)) {
							if (!game.specials[s].count_spins) {
								game.specials[s].count_spins = 0;
	
								game.sounds.play(['anticipate', s]);
								game.anticipation.show(index);
							}
	
							game.specials[s].count_spins++;
	
							if (game.specials[s].count_spins < (game.specials[s].max_spins || 7)) {
								return;
							}
	
							game.specials[s].count_spins = 0;
							break;
						}
					}
				}
	
				if (spindle.stop === -1 || spindle.stop === index) {
					this.addClass('end');
					this.removeClass('loop');
	
					game.sounds.play(['reels'], 0.25);
					game.sounds.play(['reel', this.index()], 0.25);
	
					/* jshint -W004 */
					for (var s in game.specials) {
						/* jshint +W004 */
						if (game.specials[s].count === null) {
							continue;
						}
	
						if (!game.specials[s].reels || game.specials[s].reels.indexOf(index) !== -1) {
							if (game.last.matrix[index].indexOf(+s) !== -1 || game.specials[s].alternative && game.last.matrix[index].indexOf(game.specials[s].alternative) !== -1) {
								if (scatterCan(s)) {
									game.sounds.play(['drop', s, game.specials[s].count], 0.25);
								}
	
								if (game.specials[s].ignoreSequential === true) {
									game.sounds.play(['drop', s, game.specials[s].count], 0.25);
								}
	
								if (!game.specials[s].multiScatterReels) {
									game.specials[s].count++;
								} else {
									for (var symbol in game.last.matrix[index]) {
										if (game.last.matrix[index][symbol] === +s) {
											game.specials[s].count++;
										}
									}
								}
							} else if (game.pays.scatters && game.pays.scatters.sequential && game.specials[s].ignoreSequential !== true) {
								game.specials[s].count = null;
							}
						}
					}
				} else {
					spindle.reels[index].update();
				}
			}
		});
	
		game.on('ui', function (config) {
			config = config.detail;
	
			/* Clear UI */
			{
				spindle.empty();
				spindle.container = $.div().addClass('reels').appendTo(spindle);
				spindle.reels = [];
	
				frame.empty();
				frame.container = $.div().addClass('reels').appendTo(frame);
				frame.reels = [];
			}
	
			/* Build UI */
			{
				var reelUpdate = function reelUpdate(rows, flag) {
					if (flag === 'reset') {
						this.real.index = Math.floor(Math.random() * this.real.length);
					} else {
						this.real.index = (this.real.index + 15) % this.real.length;
					}
	
					for (var row = 0; row < rows; row++) {
						if (this.window.symbols[row].el.classList.length === 1) {
							this.window.symbols[row].attr('class', 'symbol symbol-' + this.real[row]);
						}
					}
	
					var i = 0;
	
					for (var row = 0; row < rows; row++) {
						var pos = (this.real.index + row) % this.real.length;
						this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
					}
	
					for (var row = 0; row < rows * 2; row++) {
						var pos = (this.real.index + row) % this.real.length;
						this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
					}
	
					setTimeout(function () {
						for (row = 0; row < rows; row++) {
							var pos = (this.real.index + row) % this.real.length;
							this.symbols[i++].attr('class', 'symbol symbol-' + this.real[pos]);
						}
					}.bind(this), flag === 'first' ? 0 : 400 / 2);
				};
	
				for (var reel = 0; reel < config.reels; reel++) {
					var rows = config.rows;
					if (rows.constructor === Array) {
						rows = rows[reel];
					}
	
					frame.reels[reel] = $.div().addClass('reel reel-' + reel).appendTo(frame.container);
					frame.reels[reel].symbols = [];
	
					spindle.reels[reel] = $.div().addClass('reel reel-' + reel).appendTo(spindle.container);
					spindle.reels[reel].symbols = [];
					spindle.reels[reel].window = $.div().addClass('window');
					spindle.reels[reel].window.symbols = [];
					spindle.reels[reel].real = [];
					spindle.reels[reel].update = reelUpdate.bind(spindle.reels[reel], rows);
	
					for (var row = 0; row < rows; row++) {
						spindle.reels[reel].window.symbols[row] = $.div().addClass('symbol').appendTo(spindle.reels[reel].window);
						frame.reels[reel].symbols[row] = $.div().addClass('symbol').appendTo(frame.reels[reel]);
						$.div().appendTo(frame.reels[reel].symbols[row]);
	
						// var symbol = frame.reels[reel].symbols[row];
						// symbol.css('width', symbol.el.offsetWidth);
					}
	
					var i = 0;
	
					for (var row = 0; row < rows; row++) {
						spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
					}
	
					spindle.reels[reel].window.appendTo(spindle.reels[reel]);
	
					for (var row = 0; row < rows * 2; row++) {
						spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
					}
	
					for (var row = 0; row < rows; row++) {
						spindle.reels[reel].symbols[i++] = $.div().addClass('symbol').appendTo(spindle.reels[reel]);
					}
				}
			}
		});
	
		game.controller.socket.on('reels', function (reels) {
			game.trigger('reel_init', { reels: reels });
	
			for (var reel = 0; reel < spindle.reels.length; reel++) {
				spindle.reels[reel].real = reels[reel];
				spindle.reels[reel].update('reset');
			}
		});
	});

/***/ },
/* 178 */
/***/ function(module, exports) {

	'use strict';
	
	/* global $, game */
	
	$.ready(function () {
		var pays = game.pays = $.div('pays').appendTo(game.container);
	
		pays.canvas = $.element('canvas').appendTo(pays).el.getContext('2d');
	
		pays.list = [];
	
		game.on('scale', function () {
			pays.canvas.canvas.width = pays.canvas.canvas.clientWidth;
			pays.canvas.canvas.height = pays.canvas.canvas.clientHeight;
			pays.canvas.lineWidth = Math.max(Math.floor(pays.canvas.canvas.height / 100), 1);
			pays.canvas.lineJoin = 'round';
			pays.canvas.lineCap = 'round';
		});
	
		pays.init = function (type) {
			this.type = type;
			this.clear();
		};
	
		pays.add = function (type, pay) {
			var item = {
				box: true,
				type: type
			};
	
			if (item.type === 'line') {
				item.color = this.getColor(pay[0], this.lines.length);
				item.win = pay[2];
				item.spots = pay[3];
				item.symbol = pay[4];
				item.line = pay[0];
				item.lineAugment = '';
				item.excludeMult = pay[5] ? 1 : 0;
	
				if (game.feature.active && game.features.freespin && game.features.freespin.multiplier && !item.excludeMult) {
					if (typeof item.win === 'number') {
						item.win *= game.features.freespin.multiplier;
					} else if (item.win.constructor === Array) {
						item.win[0] *= game.features.freespin.multiplier;
						item.win[2] *= game.features.freespin.multiplier;
					}
				}
			} else if (item.type === 'way') {
				item.color = this.getColor(pay[0], Object.keys(this.paytable).length + 2);
				item.win = pay[1];
				item.spots = pay[4] || pay[3];
				item.symbol = pay[0];
				if (game.feature.active && game.features.freespin && game.features.freespin.multiplier) {
					if (typeof item.win === 'number') {
						item.win *= game.features.freespin.multiplier;
					} else if (item.win.constructor === Array) {
						item.win[0] *= game.features.freespin.multiplier;
						item.win[2] *= game.features.freespin.multiplier;
					}
				}
	
				var waysCount = [];
	
				for (var i = 0; i < item.spots.length; i++) {
					var reelPos = item.spots[i][0];
	
					if (!waysCount[reelPos]) {
						waysCount[reelPos] = 0;
					}
	
					waysCount[reelPos]++;
				}
	
				var numWays = 1;
	
				for (var i = 0; i < waysCount.length; i++) {
					if (waysCount[i] !== undefined) {
						numWays *= waysCount[i];
					}
				}
	
				item.numWays = numWays;
			} else if (item.type === 'scatter') {
				item.color = this.getColor(pay[0], Object.keys(this.paytable).length + 2);
				item.win = pay[2];
				item.spots = pay[3];
				item.symbol = pay[0];
				if (game.feature.active && game.features.freespin && game.features.freespin.multiplier) {
					if (typeof item.win === 'number') {
						item.win *= game.features.freespin.multiplier;
					} else if (item.win.constructor === Array) {
						item.win[0] *= game.features.freespin.multiplier;
						item.win[2] *= game.features.freespin.multiplier;
					}
				}
			}
	
			if (typeof item.win === 'string') {
				item.win = item.win.replace(/_/g, ' ').replace(/\w\S*/g, function (word) {
					return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase();
				});
			} else if (typeof item.win === 'number') {
				item.win = $.plugins.meter.__format(item.win);
			} else if (item.win.constructor === Array) {
				item.win = [$.plugins.meter.__format(item.win[0]), 'x', $.plugins.meter.__format(item.win[1]), '=', $.plugins.meter.__format(item.win[2])].join(' ');
			}
	
			this.trigger('pay', item);
	
			this.list.push(item);
		};
	
		pays.show = function (cycles) {
			if (!this.list.length) {
				return;
			}
	
			if (pays.forceCycles) {
				cycles = 1;
			}
	
			this.canvas.shadowOffsetX = 0;
			this.canvas.shadowOffsetY = 0;
			this.canvas.shadowBlur = 0;
			this.canvas.shadowColor = 'black';
	
			timer = setTimeout(function () {
				game.messaging.show('pays');
				pays.next(0, cycles ? cycles : 0);
			}, 500);
		};
	
		pays.clear = function (hold, hide) {
			if (!hold) {
				pays.list = [];
			}
	
			if (!hold || hide) {
				game.messaging.hide('pays');
				clearTimeout(timer);
			}
	
			this.canvas.clearRect(0, 0, this.canvas.canvas.width, this.canvas.canvas.height);
	
			game.frame.removeClass('win');
	
			for (var reel in game.frame.reels) {
				for (var row in game.frame.reels[reel].symbols) {
					game.frame.reels[reel].symbols[row].removeClass('win pop');
				}
			}
		};
	
		var timer = null;
	
		pays.next = function (index, cycles) {
			if (!this.list.length) {
				return null;
			}
	
			if (index >= this.list.length) {
				return this.next(0, cycles + 1);
			}
	
			if (cycles === 0 && this.list.length === 1) {
				return this.next(0, cycles + 1);
			}
	
			var pay = this.list[index];
	
			this.clear(true);
			this.canvas.strokeStyle = pay.color;
	
			if (typeof pay.line !== 'undefined') {
				this.drawLine(pay.line, null, pay);
			}
	
			for (var spot in pay.spots) {
				spot = pay.spots[spot];
				var pos_override = [];
				pays.trigger('next', { pay: pay, spot: spot, pos_override: pos_override, cycles: cycles });
	
				var reel = spot[0];
				var row = spot[1];
	
				if (cycles > 0) {
					game.frame.reels[reel].symbols[row].addClass('win');
	
					var symbol = game.frame.reels[reel].symbols[row];
					symbol.css('width', symbol.el.offsetWidth);
				} else {
					game.frame.reels[reel].symbols[row].addClass('pop');
				}
	
				// x, y, width, height
				var pos = this.getPosition(reel, row);
				if (pos_override.length === 4) {
					pos = pos_override;
				}
	
				pos[0] += this.canvas.lineWidth / 2;
				pos[1] += this.canvas.lineWidth / 2;
				pos[2] -= this.canvas.lineWidth;
				pos[3] -= this.canvas.lineWidth;
	
				if (pay.box) {
					this.canvas.clearRect(pos[0], pos[1], pos[2], pos[3]);
					this.canvas.strokeRect(pos[0], pos[1], pos[2], pos[3]);
				}
			}
	
			game.frame.addClass('win');
	
			if (pay.type === 'line') {
				var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
				pays.messaging.html('Symbol ' + symbol + ' wins ' + pay.win + ' on Line ' + (pay.line + 1) + pay.lineAugment);
				pays.trigger('update', { line: pay.line + 1 });
			} else if (pay.type === 'way') {
				var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
				pays.messaging.html('Symbol ' + symbol + ' by ' + pay.numWays + ' wins ' + pay.win);
			} else if (pay.type === 'scatter') {
				var symbol = '<span class="mini symbol-' + pay.symbol + '" ></span>';
				pays.messaging.html('Scatter symbol ' + symbol + ' wins ' + pay.win);
				pays.trigger('updateScatter', { pay: pay.win });
			}
	
			var time = 500;
			if (cycles === 0 && game.pays.cycleTime) {
				time = game.pays.cycleTime;
			} else if (game.pays.time) {
				time = game.pays.time;
			} else if (cycles !== 0) {
				time = 2000;
			}
	
			timer = setTimeout(pays.next.bind(pays, index + 1, cycles), time);
		};
	
		game.on('ui', function (config) {
			config = config.detail;
	
			delete pays.wild;
			delete pays.lines;
			delete pays.cost;
			delete pays.scatters;
	
			pays.paytable = [];
	
			if (config.lines) {
				pays.wild = config.lines.wild;
				pays.lines = config.lines.lines;
	
				for (var key in config.lines.paytable) {
					if (pays.paytable.indexOf(key) === -1) {
						pays.paytable.push(key);
					}
				}
	
				pays.init('lines');
			}
	
			if (config.ways) {
				pays.wild = config.ways.wild;
				pays.cost = config.ways.cost;
	
				for (var key in config.ways.paytable) {
					if (pays.paytable.indexOf(key) === -1) {
						pays.paytable.push(key);
					}
				}
	
				pays.init('ways');
			}
	
			if (config.scatters) {
				pays.scatters = {};
	
				if (config.scatters.constructor === Array) {
					for (var i in config.scatters) {
						if (config.scatters[i].sequential) {
							pays.scatters.sequential = config.scatters[i].sequential;
						}
	
						if (config.scatters[i].block) {
							pays.scatters[config.scatters[i].block] = 'block';
						}
	
						for (var key in config.scatters[i].paytable) {
							if (pays.paytable.indexOf(key) === -1) {
								pays.paytable.push(key);
							}
						}
					}
				} else {
					if (config.scatters.sequential) {
						pays.scatters.sequential = config.scatters.sequential;
					}
	
					if (config.scatters.block) {
						pays.scatters[config.scatters.block] = 'block';
					}
	
					for (var key in config.scatters.paytable) {
						if (pays.paytable.indexOf(key) === -1) {
							pays.paytable.push(key);
						}
					}
				}
			}
		});
	});

/***/ },
/* 179 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var pays = game.pays;
	
		pays.colors = [[255, 0, 0], [255, 255, 0], [0, 255, 0], [0, 255, 255], [0, 0, 255], [255, 0, 255]];
	
		pays.getPosition = function (reel, row, offsetY) {
			var x;
			var y;
			var width;
			var height;
	
			if (typeof offsetY === 'undefined') {
				x = game.frame.reels[reel].el.offsetLeft;
				x += game.frame.reels[reel].symbols[row].el.offsetLeft;
	
				y = game.frame.reels[reel].el.offsetTop;
				y += game.frame.reels[reel].symbols[row].el.offsetTop;
	
				width = game.frame.reels[reel].symbols[row].el.offsetWidth;
				height = game.frame.reels[reel].symbols[row].el.offsetHeight;
	
				return [x, y, width, height];
			} else {
				x = game.frame.reels[reel].el.offsetLeft;
				x += game.frame.reels[reel].symbols[row].el.offsetLeft;
				x += game.frame.reels[reel].symbols[row].el.offsetWidth / 2;
	
				y = game.frame.reels[reel].el.offsetTop;
				y += game.frame.reels[reel].symbols[row].el.offsetTop;
				y += game.frame.reels[reel].symbols[row].el.offsetHeight * (offsetY || 0);
	
				return [x, y];
			}
		};
	
		pays.drawLines = function (lines) {
			if (!pays.lines) {
				return;
			}
	
			var counts = [];
			var offsets = {};
	
			function process(line) {
				offsets[line] = [];
	
				for (var reel = 0; reel < pays.lines[line].length; reel++) {
					var row = pays.lines[line][reel];
	
					if (!counts[reel]) {
						counts[reel] = [];
					}
	
					if (!counts[reel][row]) {
						counts[reel][row] = 0;
					}
	
					offsets[line][reel] = counts[reel][row];
					counts[reel][row]++;
				}
			}
	
			function processPost(line) {
				offsets[line] = {
					counts: offsets[line],
					offsets: []
				};
	
				for (var reel = 0; reel < pays.lines[line].length; reel++) {
					var row = pays.lines[line][reel];
					offsets[line].offsets[reel] = (offsets[line].counts[reel] + 1) / (counts[reel][row] + 1);
				}
			}
	
			this.canvas.shadowOffsetX = 0;
			this.canvas.shadowOffsetY = 4;
			this.canvas.shadowBlur = 4;
			this.canvas.shadowColor = 'black';
	
			var line;
	
			if (typeof lines === 'number') {
				for (line = 0; line < lines; line++) {
					process(line);
				}
	
				for (line = 0; line < lines; line++) {
					processPost(line);
				}
	
				for (line = 0; line < lines; line++) {
					this.drawLine(line, offsets[line].offsets);
				}
			} else {
				for (line in lines) {
					process(lines[line]);
				}
	
				for (line in lines) {
					processPost(lines[line]);
				}
	
				for (line in lines) {
					this.drawLine(lines[line], offsets[lines[line]].offsets);
				}
			}
		};
	
		pays.drawLine = function (lineNumber, offset, pay) {
			this.canvas.beginPath();
			this.canvas.strokeStyle = this.getColor(lineNumber, pays.lines.length);
	
			var line = pays.lines[lineNumber];
	
			for (var reel = 0; reel < line.length; reel++) {
				var row = line[reel];
	
				var point = {
					reel: reel,
					line: line,
					lineNumber: lineNumber,
					pay: pay
				};
	
				point.track = game.frame.reels[reel].symbols[row];
	
				if (reel === 0 || reel === line.length - 1) {
					point.offset = pays.canvas.lineWidth;
				}
	
				this.trigger('line', point);
	
				point.x = game.frame.reels[reel].el.offsetLeft;
				point.x += game.frame.reels[reel].symbols[row].el.offsetLeft;
				point.x += game.frame.reels[reel].symbols[row].el.offsetWidth / 2;
	
				point.y = game.frame.reels[reel].el.offsetTop;
				point.y += point.track.el.offsetTop;
				point.y += point.track.el.offsetHeight * (offset && typeof offset[reel] === 'number' ? offset[reel] : 0.5);
	
				if (reel === 0) {
					this.canvas.moveTo(point.offset, point.y);
				}
	
				this.canvas.lineTo(point.x, point.y);
	
				if (reel === line.length - 1) {
					this.canvas.lineTo(pays.canvas.canvas.offsetWidth - point.offset, point.y);
				}
			}
	
			this.canvas.stroke();
		};
	
		pays.getColor = function (point, max, rgba) {
			var w = max / this.colors.length;
			var g = point % w / w;
			var m = Math.floor(point % max / w);
			var n = (m + 1) % this.colors.length;
	
			var rgb = [Math.floor(g * (this.colors[n][0] - this.colors[m][0]) + this.colors[m][0]), Math.floor(g * (this.colors[n][1] - this.colors[m][1]) + this.colors[m][1]), Math.floor(g * (this.colors[n][2] - this.colors[m][2]) + this.colors[m][2])];
	
			if (typeof rgba !== 'undefined') {
				rgb.push(rgba);
	
				return 'rgba(' + rgb.join(',') + ')';
			} else {
				/* jshint -W016 */
				return '#' + ((1 << 24) + (rgb[0] << 16) + (rgb[1] << 8) + rgb[2]).toString(16).slice(1);
				/* jshint +W016 */
			}
		};
	});

/***/ },
/* 180 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var messaging = game.messaging = $.div('messaging').appendTo(game.container);
		messaging.objects = {};
	
		messaging.add = function (key, object) {
			this.objects[key] = object;
			this.objects[key].appendTo(this);
	
			return this;
		};
	
		messaging.show = function (key) {
			if (this.objects[key] && !this.objects[key].hasClass('show')) {
				this.objects[key].addClass('show');
				this.objects[key].appendTo(this);
			}
	
			return this;
		};
	
		messaging.hide = function (key) {
			if (key) {
				if (this.objects[key] && this.objects[key].hasClass('show')) {
					this.objects[key].removeClass('show');
					this.objects[key].reinsert();
				}
	
				return this;
			}
	
			for (key in this.objects) {
				if (this.objects[key].hasClass('show')) {
					this.objects[key].removeClass('show');
					this.objects[key].reinsert();
				}
			}
	
			return this;
		};
	
		/* Logo */
		{
			game.logo = $.div('logo');
			messaging.add('logo', game.logo);
		}
	
		/* Pays */
		{
			var pays = game.pays.messaging = $.div().addClass('pays');
			messaging.add('pays', pays);
		}
	});

/***/ },
/* 181 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var anticipation = game.anticipation = $.div('anticipation');
	
		anticipation.show = function (reel) {
			reel = game.spindle.reels[reel];
	
			for (var i = 0; i < game.spindle.reels.length; i++) {
				game.spindle.reels[i].removeClass('anticipate');
			}
	
			game.spindle.addClass('anticipate');
			reel.addClass('anticipate');
		};
	
		anticipation.hide = function (reel) {
			reel = game.spindle.reels[reel];
	
			game.spindle.removeClass('anticipate');
	
			setTimeout(function () {
				reel.removeClass('anticipate');
			}, 250);
		};
	});

/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		game.panel.on('recall', function () {
			game.controller.socket.emit('recall');
		});
	
		game.showRecall = function (action) {
			/* global spinClear, spinInit, spinReady, spinDone */
			if (action.event === 'spin') {
				if (typeof action.request.bet !== 'undefined' && typeof action.request.coins === 'undefined') {
					action.request.coins = action.request.bet;
					delete action.request.bet;
				}
	
				game.panel.setBet(action.request);
				game.panel.setCredits(action.response.credits);
			}
	
			game.last = action.response;
			spinClear(true);
			spinInit(true);
			spinReady(true);
			spinDone(true);
		};
	
		game.controller.socket.on('recall', function (cycles) {
			if (!cycles) {
				return;
			}
	
			if (cycles.constructor === Array) {
				if (!cycles.length) {
					return;
				}
	
				game.recall.show(cycles);
			} else {
				game.panel.setRecall();
				loader.setRecall();
				game.inRecall = true;
	
				var counter = -1;
				var begun = false;
				var next = function next(again) {
					counter = (counter + 1) % cycles.actions.length;
	
					var action = cycles.actions[counter];
	
					while (begun && action.response.action === 'begin' || action.response.action === 'timer') {
						counter = (counter + 1) % cycles.actions.length;
						action = cycles.actions[counter];
					}
	
					var trigger = {
						delay: 5000,
						action: action
					};
	
					game.trigger('recall_action', trigger);
	
					if (action.event === 'spin') {
						game.showRecall(action);
					} else if (action.event === 'feature') {
						var bonus = game.features[action.response.name];
	
						if (!bonus) {
							game.panel.dialog.show('fatal');
	
							return;
						}
	
						if (action.response.action === 'begin') {
							begun = true;
	
							if (game.panel.type === 'desktop') {
								game.panel.spin.remove();
								game.panel.play.removeClass('base');
								game.panel.play.addClass(bonus.key);
							}
	
							game.feature.active = action.response.name;
							game.feature.attr('class', 'active show');
							game.feature.messages.appendTo(game.feature);
							game.feature.messages2.appendTo(bonus);
							bonus.methods.init(true);
							bonus.appendTo(game.feature);
	
							game.addClass('bonus');
						} else if (action.response.action === 'finish') {
							begun = false;
	
							setTimeout(function () {
								game.removeClass('bonus');
								game.feature.removeClass('show');
								game.feature.empty();
								game.feature.attr('class', null);
								game.feature.hideMessages();
	
								game.feature.active = false;
							}, trigger.delay);
						}
	
						game.last = action.response;
	
						if (bonus.methods[action.response.action]) {
							bonus.methods[action.response.action](action.response, trigger);
						}
	
						if (action.response.action === 'spin') {
							game.panel.setWin(0, true);
							game.showRecall(action);
						}
					} else {
						console.log(counter, action);
					}
	
					if (again !== false) {
						setTimeout(next.bind(this), trigger.delay);
					}
				};
	
				next(false);
	
				if (cycles.actions.length === 1) {
					return;
				}
	
				game.on('ready', function () {
					setTimeout(function () {
						next();
					}, 5000);
				});
			}
		});
	});

/***/ },
/* 183 */
/***/ function(module, exports) {

	'use strict';
	
	function scatterCan(symbol) {
		symbol = +symbol;
	
		if (!game.specials[symbol].reels) {
			return true;
		}
	
		if (game.specials[symbol].reels.indexOf(game.spindle.stop) === -1) {
			return false;
		}
	
		if ([1, 2].indexOf(game.spindle.stop) !== -1 && game.specials[symbol].reels.indexOf(0) !== -1) {
			if (game.last.matrix[0].indexOf(symbol) !== -1) {
				return true;
			}
		}
	
		if (game.specials[symbol].completesWin) {
			if (game.spindle.stop > 1) {
				return game.last.animate[game.spindle.stop - 1].indexOf(true) !== -1;
			}
		}
	
		if (game.specials[symbol].count === null) {
			return false;
		}
	
		var can = 0;
	
		for (var reel = game.spindle.stop; reel < game.spindle.reels.length; reel++) {
			if (game.specials[symbol].reels.indexOf(reel) !== -1) {
				can++;
			}
		}
	
		if (!game.specials[symbol].needs || game.specials[symbol].count + can >= game.specials[symbol].needs) {
			return true;
		}
	
		return false;
	}
	
	function spinClear() {
		if (!game.feature.active) {
			game.messaging.show('logo');
		}
	
		game.spindle.clear();
		game.spindle.stop = -3;
		game.spindle.ready = 0;
	
		game.panel.setWin(0, true);
		game.pays.clear();
	
		for (var reel in game.frame.reels) {
			for (var row in game.frame.reels[reel].symbols) {
				game.spindle.reels[reel].window.symbols[row].removeClass('hide');
	
				if (!game.last.sticky || !game.last.sticky[reel][row]) {
					game.frame.reels[reel].symbols[row].attr('class', 'symbol');
				}
			}
		}
	
		game.trigger('spin_clear');
	}
	
	function spinInit(recall) {
		var response = game.last;
	
		game.panel.hide();
	
		game.spindle.done = 0;
		game.spindle.stop = 0;
	
		if (game.turbo) {
			game.spindle.stop = -1;
		}
	
		var reel;
		var row;
		var pay;
	
		response.animate = [];
	
		for (reel in game.frame.reels) {
			response.animate[reel] = [];
	
			for (row in game.frame.reels[reel].symbols) {
				response.animate[reel][row] = false;
			}
		}
	
		if (response.lines && response.lines.win) {
			if (response.lines.pays && response.lines.pays.length) {
				for (pay in response.lines.pays) {
					pay = response.lines.pays[pay];
	
					var line = pay[0];
	
					for (reel = 0; reel < pay[1]; reel++) {
						row = game.pays.lines[line][reel];
	
						response.animate[reel][row] = true;
					}
				}
			}
		}
	
		if (response.ways && response.ways.win) {
			if (response.ways.pays && response.ways.pays.length) {
				for (pay in response.ways.pays) {
					pay = response.ways.pays[pay];
	
					var symbol = pay[0];
	
					for (reel = 0; reel < pay[2]; reel++) {
						for (row = 0; row < response.matrix[reel].length; row++) {
							if (response.matrix[reel][row] === symbol || response.matrix[reel][row] === game.pays.wild) {
								response.animate[reel][row] = true;
							}
						}
					}
				}
			}
		}
	
		game.trigger('spin_init');
	
		game.trigger('round_init', {
			recall: recall,
			bet: game.last._cost,
			win: game.last.win
		});
	}
	
	function spinReady(recall) {
		if (game.spindle.stop === -3) {
			game.spindle.stop = -2;
			return;
		}
	
		var response = game.last;
	
		for (var reel in response.matrix) {
			for (var row in response.matrix[reel]) {
				game.spindle.reels[reel].window.symbols[row].attr('class', 'symbol symbol-' + response.matrix[reel][row]);
			}
		}
	
		for (var s in game.specials) {
			game.specials[s].count = 0;
		}
	
		if (!recall) {
			game.trigger('spin_ready');
		}
	
		spinInit();
	}
	
	function spinDone(recall) {
		var response = game.last;
	
		game.pays.clear();
	
		var pay;
		var reel;
		var row;
		var symbol;
		var source;
		var target;
	
		if (response.scatters && response.scatters.pays && response.scatters.pays.length) {
			for (pay in response.scatters.pays) {
				pay = response.scatters.pays[pay];
				symbol = pay[0];
				var spots = pay[3] = [];
	
				var condition = game.pays.scatters.sequential ? game.specials[symbol].reels ? game.specials[symbol].reels[pay[1] - 1] + 1 : pay[1] : true;
	
				for (reel in game.last.matrix) {
					for (row in game.last.matrix[reel]) {
						var data = {
							reel: reel,
							row: row,
							symbol: symbol,
							matrix: game.last.matrix[reel][row],
							match: (condition === true || reel < condition) && game.last.matrix[reel][row] === symbol
						};
	
						game.pays.trigger('identify-scatter', data);
	
						if (!data.match) {
							continue;
						}
	
						spots.push([reel, row]);
	
						game.last.animate[reel][row] = true;
	
						source = game.spindle.reels[reel].window.symbols[row];
						target = game.frame.reels[reel].symbols[row];
	
						target.attr('class', source.attr('class')).addClass('win');
						source.addClass('hide');
					}
				}
	
				game.pays.add('scatter', pay);
			}
		}
	
		game.trigger('spin_pre_done');
		game.sounds.fade(['spin'], 1, 0, 1);
		game.sounds.fade([game.feature.active, 'spin'], 1, 0, 1);
	
		if (!recall && response.bonuses && response.bonuses.length && !game.last.delayBonus) {
			game.messaging.hide('logo');
			game.pays.show();
			game.feature.begin(response.bonuses.pop());
	
			return;
		} else if (game.last.delayBonus) {
			game.last.delayBonus = false;
	
			return;
		}
	
		if (response.lines && response.lines.win) {
			if (response.lines.pays && response.lines.pays.length) {
				response.lines.pays.sort(function (a, b) {
					if (a[1] === b[1] && a[2] === b[2]) {
						return a[0] > b[0] ? 1 : -1;
					} else if (a[2] === b[2]) {
						return a[1] < b[1] ? 1 : -1;
					} else {
						return a[2] < b[2] ? 1 : -1;
					}
				});
	
				for (pay in response.lines.pays) {
					pay = response.lines.pays[pay];
					if (typeof pay[4] !== 'number') {
						pay[4] = pay[3];
					}
	
					pay[3] = [];
	
					for (reel = 0; reel < pay[1]; reel++) {
						row = game.pays.lines[pay[0]][reel];
	
						pay[3].push([reel, row]);
					}
				}
	
				for (pay in response.lines.pays) {
					// console.log(response.lines.pays[pay]);
					game.pays.add('line', response.lines.pays[pay]);
				}
			}
		}
	
		if (response.ways && response.ways.win) {
			if (response.ways.pays && response.ways.pays.length) {
	
				for (pay in response.ways.pays) {
					pay = response.ways.pays[pay];
	
					pay[3] = [];
	
					for (reel = 0; reel < pay[2]; reel++) {
						for (row = 0; row < game.last.matrix[reel].length; row++) {
							if (game.last.matrix[reel][row] === pay[0] || game.last.matrix[reel][row] === game.pays.wild || game.last.sticky && game.last.sticky[reel][row]) {
								pay[3].push([reel, row]);
							}
						}
					}
				}
	
				for (pay in response.ways.pays) {
					pay = response.ways.pays[pay];
				}
	
				for (pay in response.ways.pays) {
					game.pays.add('way', response.ways.pays[pay]);
				}
			}
		}
	
		for (reel in game.frame.reels) {
			for (row in game.frame.reels[reel].symbols) {
				if (response.animate[reel][row] || response.sticky && response.sticky[reel][row]) {
					source = game.spindle.reels[reel].window.symbols[row];
					target = game.frame.reels[reel].symbols[row];
	
					if (response.sticky && response.sticky[reel][row]) {
						target.attr('class', 'symbol symbol-0');
					} else {
						target.attr('class', source.attr('class'));
					}
	
					source.addClass('hide');
				}
			}
		}
	
		if (!recall) {
	
			if (!game.feature.active && game.panel.state !== 'lock') {
				game.panel.enable();
			}
		}
	
		game.panel.show();
	
		if (!game.last._cost && game.old && !game.old._cost) {
	
			var bet;
	
			if (game.config.lines) {
				bet = game.panel.getBet();
	
				game.last._cost = bet.lines * bet.coins;
			} else {
				bet = game.panel.getBet();
	
				game.last._cost = game.config.ways.cost * bet.coins;
			}
		}
	
		if (response.win) {
			game.messaging.hide();
	
			if (!game.last.delayWin) {
				game.pays.show();
			}
	
			if (recall) {
				game.panel.setWin(response.win, true);
				game.trigger('round_complete');
			} else {
				if (game.feature.active) {
					game.sounds.fade([game.feature.active, 'background'], 1, 0.15, 0.5);
				} else {
					game.sounds.fade(['background'], 1, 0.15, 0.5);
				}
	
				if (!game.last.delayWin) {
					game.panel.setWin(response.win);
				}
			}
		} else if (game.pays.list && game.pays.list.length) {
			game.messaging.hide();
	
			if (!game.last.delayWin) {
				game.pays.show();
				setTimeout(function () {
					game.trigger('round_complete');
				}, recall ? 0 : 2000);
			}
		} else if (!game.last.doubleRollup) {
			game.trigger('round_complete');
		}
	
		game.trigger('spin_done');
		game.trigger('round_done', { recall: recall });
	}
	
	window.scatterCan = scatterCan;
	window.spinClear = spinClear;
	window.spinInit = spinInit;
	window.spinReady = spinReady;
	window.spinDone = spinDone;

/***/ },
/* 184 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 185 */,
/* 186 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 187 */,
/* 188 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 189 */,
/* 190 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 191 */,
/* 192 */,
/* 193 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 194 */,
/* 195 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 196 */,
/* 197 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 198 */,
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	__webpack_require__(200);
	
	$.ready(function () {
		game.generateFreespin = function (key, config) {
			if ((typeof key === 'undefined' ? 'undefined' : _typeof(key)) === 'object') {
				config = key;
				key = null;
			}
	
			key = key || 'freespin';
	
			var freespin = $.div('bonus-' + key);
			freespin.key = key;
	
			config = freespin.config = config || {};
	
			game.on('spin_init', function () {
				if (game.last.scatters) {
					for (var i = 0; i < game.last.scatters.pays.length; i++) {
						if (game.last.scatters.pays[i][2] === key) {
							game.last.scatters.pays[i][2] = config.name || 'Free Spins';
						}
					}
				}
			});
	
			/* Play Button */
			{
				freespin.play = $.div().addClass('message');
				freespin.play.message = $.div().html('Touch to Begin').appendTo(freespin.play);
	
				freespin.playing = $.div();
	
				freespin.spins = $.div().apply('meter', { label: 'Spins' }).addClass('spins').appendTo(freespin.playing);
	
				freespin.total = $.div().apply('meter', { label: 'Total' }).addClass('total').appendTo(freespin.playing);
	
				game.panel.registerCash(freespin.total);
			}
	
			if (config.banners) {
				for (var i = 0; i < config.banners; i++) {
					var banner = $.div().addClass('banner ' + key + '-banner-' + i);
					game.messaging.add(key + '-banner-' + i, banner);
	
					freespin.banners = {
						index: -1,
						count: config.banners
					};
				}
	
				var minTriggers = config.minTriggers || 3;
				freespin.singleTriggerBanner = null;
	
				if (config.triggerBanners) {
					freespin.singleTriggerBanner = config.triggerBanners === 1 ? true : false;
	
					if (!freespin.singleTriggerBanner) {
						for (var j = 0; j < config.triggerBanners; j++) {
							var bannerNum = j + minTriggers;
							var triggerBanner = $.div().addClass('banner ' + key + '-triggerBanner-' + bannerNum);
							game.messaging.add(key + '-triggerBanner-' + bannerNum, triggerBanner);
						}
					} else {
						var triggerBanner = $.div().addClass('banner ' + key + '-triggerBanner');
						game.messaging.add(key + '-triggerBanner', triggerBanner);
					}
	
					freespin.triggerBanners = {
						index: -1,
						count: config.triggerBanners
					};
				}
			}
	
			freespin.on('play', function () {
				if (!freespin.ready || freespin.inited || freespin.config.waitStart) {
					return;
				}
	
				freespin.inited = true;
				game.sounds.play([freespin.key, 'click']);
	
				freespin.addClass('spinning');
				freespin.removeClass('pause');
	
				if (game.panel.type === 'desktop') {
					this.play.remove();
					this.playing.appendTo(game.panel.play);
				}
	
				if (game.panel.type === 'mobile') {
					setTimeout(function () {
						game.panel.play.removeClass('icon-begin');
						game.panel.play.addClass('icon-spin');
						freespin.total.addClass('bottom right').appendTo(game.panel);
					}, 750);
				} else {
					freespin.total.appendTo(freespin.playing);
				}
	
				freespin.methods.next(game.last.spins);
			});
	
			freespin.methods = {};
	
			for (var method in game.generateFreespin.methods) {
				freespin.methods[method] = game.generateFreespin.methods[method].bind(freespin);
			}
	
			game.on('round_complete', function () {
				if (game.feature.active !== freespin.key || game.last.delayWin || game.last.stopSpins || game.last.doubleRollup) {
					return;
				}
	
				if (freespin.config.down) {
					freespin.spins.max = game.last.state.spins_aquired;
				}
	
				freespin.spins.set(freespin.config.down ? game.last.state.spins_aquired - game.last.state.spins : game.last.state.spins);
	
				freespin.total.set(game.last.state.win * game.panel.denom.get() + freespin.initial_credits);
	
				var didRetrigger = false;
	
				if (game.last.scatters) {
					var count = game.last.scatters.counts[freespin.config.symbol];
	
					if (game.config.scatters.constructor === Array) {
						for (var i in game.config.scatters) {
							if (game.config.scatters[i].paytable[freespin.config.symbol]) {
								didRetrigger = didRetrigger || game.config.scatters[i].paytable[freespin.config.symbol][count - 1];
							}
						}
					} else {
						if (game.config.scatters.paytable[freespin.config.symbol]) {
							didRetrigger = game.config.scatters.paytable[freespin.config.symbol][count - 1];
						}
					}
				}
	
				if (game.last.retriggered) {
					didRetrigger = true;
				}
	
				setTimeout(function () {
					freespin.methods.next(game.last.spins);
				}, freespin.config.triggerTime && didRetrigger ? freespin.config.triggerTime : 1000);
			});
	
			return freespin;
		};
	
		game.generateFreespin.methods = {
			init: function init(recall) {
				this.inited = false;
				this.ready = false;
				this.attr('class', 'intro');
	
				if (recall) {
					this.initial_credits = game.last.win;
				}
	
				setTimeout(function () {
					game.panel.auto.label.html('Auto');
				}, 500);
	
				if (this.config.introSymbol) {
					game.feature.showMessage('intro_' + game.last.scatters.counts[this.config.introSymbol]);
				} else if (this.config.symbol === 0 || this.config.symbol) {
					game.feature.showMessage('intro_' + game.last.scatters.counts[this.config.symbol]);
				} else if (!this.config.noIntroMessage) {
					game.feature.showMessage('intro');
				}
	
				if (!this.config.noAutomatedSounds) {
					var intro = game.sounds.play([this.key, 'intro']);
	
					game.sounds.play([this.key, 'background'], { loop: true, time: intro ? intro.buffer.duration : 0 });
				}
	
				if (game.panel.type === 'mobile') {
					game.panel.spin.css('display', 'none');
					game.panel.addItem(this.spins, 'bottom middle');
					this.total.addClass('bottom right').appendTo(game.panel);
					this.total.label.appendTo(this.total);
					this.total.animate = true;
					this.total.exclusiveSet = false;
	
					game.panel.on('setWin', function (event) {
						if (game.feature.active !== this.key) {
							return;
						}
	
						if (event.detail.value === 0 || this.total.exclusiveSet) {
							return;
						}
	
						this.total.exclusiveSet = true;
	
						this.total.set(game.last.state.win * game.panel.denom.get() + this.initial_credits, event.detail.immediate);
					}.bind(this));
				}
	
				this.trigger('init', { recall: recall });
			},
	
			begin: function begin(response, recall) {
				this.trigger('begin', { recall: recall });
				this.scattersCount = null;
				this.multiplier = response.multiplier;
	
				if (!recall) {
					this.initial_credits = 0;
				}
	
				if (this.config.initial_credits && !recall) {
					var sym = this.config.symbol || this.config.initial_credits.symbol;
	
					for (var i = 0; i < game.old.scatters.pays.length; i++) {
						if (game.old.scatters.pays[i][0] === sym && typeof game.old.scatters.pays[i][2] === 'number') {
							this.initial_credits = game.old.scatters.pays[i][2];
							break;
						}
					}
				}
	
				if (this.config.line_trigger && !recall) {
					this.initial_credits = game.old.triggering_pay || 0;
				}
	
				this.total.set(response.total * game.panel.denom.get() + this.initial_credits);
	
				if (this.config.down) {
					this.spins.max = game.last.spins_aquired;
				}
	
				this.spins.set(this.config.down ? game.last.spins_aquired - game.last.spins : game.last.spins);
	
				var freespin = this;
				setTimeout(function () {
					if (!freespin.config.noIntroMessage) {
						game.feature.hideMessages();
					}
	
					freespin.addClass('pause');
					freespin.removeClass('intro');
	
					if (!recall) {
						if (game.panel.type === 'desktop') {
							freespin.play.appendTo(game.panel.play);
						}
	
						if (game.panel.type === 'mobile') {
							game.panel.play.addClass('icon-begin');
						}
					}
	
					freespin.trigger('intro', { recall: recall });
	
					freespin.ready = true;
	
					if (recall) {
						freespin.addClass('spinning');
						freespin.removeClass('pause');
	
						freespin.trigger('play');
					}
				}, recall ? 2000 : this.config.introTime || 7500);
			},
	
			next: function next(spins) {
				this.trigger('next');
	
				if (spins) {
					spinClear();
					game.spindle.spin();
				}
	
				game.controller.socket.emit('feature', { name: this.key, action: spins ? 'spin' : 'finish' });
			},
	
			spin: function spin(response, recall) {
				this.trigger('spin', { recall: recall });
	
				this.spins.set(this.spins._value - 1);
	
				this.total.exclusiveSet = false;
	
				game.panel.win.appendTo(game.panel);
	
				if (this.triggerBanners) {
					if (!this.singleTriggerBanner) {
						game.messaging.hide(this.key + '-triggerBanner-' + this.triggerBanners.index);
					} else {
						game.messaging.hide(this.key + '-triggerBanner');
					}
				} else if (this.banners) {
					game.messaging.hide(this.key + '-banner-' + this.banners.index);
				}
	
				if ((this.scattersCount > 2 || this.scattersCount >= this.config.minTriggerBanners) && this.triggerBanners) {
					if (!this.singleTriggerBanner) {
						this.triggerBanners.index = this.scattersCount;
						game.messaging.hide('logo');
						game.messaging.show(this.key + '-triggerBanner-' + this.triggerBanners.index);
					} else {
						game.messaging.hide('logo');
						game.messaging.show(this.key + '-triggerBanner');
					}
				} else if (this.banners) {
					this.banners.index = (this.banners.index + 1) % this.banners.count;
					game.messaging.hide('logo');
					game.messaging.show(this.key + '-banner-' + this.banners.index);
				} else if (!this.banners) {
					game.messaging.show('logo');
				}
	
				if (game.last.scatters) {
					this.scattersCount = game.last.scatters.counts[this.config.symbol];
				}
			},
	
			finish: function finish(response, recall) {
				this.trigger('finish', { recall: recall });
	
				game.messaging.hide();
				game.messaging.show('logo');
	
				this.playing.remove();
	
				if (game.panel.type === 'mobile') {
					game.features.freespin.total.remove();
				}
	
				game.feature.showMessage('outro', response.win + this.initial_credits);
				this.addClass('final');
				this.removeClass('spinning');
	
				game.sounds.fade([this.key, 'background'], 1, 0, 0.5);
				game.sounds.play([this.key, 'outro']);
	
				if (game.panel.type === 'mobile') {
					game.panel.spin.css('display', null);
					this.spins.remove();
				}
	
				if (recall) {
					return;
				}
	
				setTimeout(game.feature.finish, this.config.outroTime || 2500);
			}
		};
	});

/***/ },
/* 200 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 201 */,
/* 202 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
	
		game.addPays = function () {
			var response = game.last;
			if (response.lines && response.lines.win) {
				if (response.lines.pays && response.lines.pays.length) {
					response.lines.pays.sort(function (a, b) {
						if (a[1] === b[1] && a[2] === b[2]) {
							return a[0] > b[0] ? 1 : -1;
						} else if (a[2] === b[2]) {
							return a[1] < b[1] ? 1 : -1;
						} else {
							return a[2] < b[2] ? 1 : -1;
						}
					});
	
					for (pay in response.lines.pays) {
						pay = response.lines.pays[pay];
	
						pay[3] = [];
	
						for (reel = 0; reel < pay[1]; reel++) {
							row = game.pays.lines[pay[0]][reel];
	
							pay[3].push([reel, row]);
						}
					}
	
					for (pay in response.lines.pays) {
						game.pays.add('line', response.lines.pays[pay]);
					}
				}
			}
	
			for (reel in game.frame.reels) {
				for (row in game.frame.reels[reel].symbols) {
					if (response.animate[reel][row] || response.sticky && response.sticky[reel][row]) {
						source = game.spindle.reels[reel].window.symbols[row];
						target = game.frame.reels[reel].symbols[row];
	
						if (response.sticky && response.sticky[reel][row]) {
							target.attr('class', 'symbol symbol-0');
						} else {
							target.attr('class', source.attr('class'));
						}
	
						source.addClass('hide');
					}
				}
			}
		};
	});

/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	$.ready(function () {
		var fancy = {};
		var loader = window.loader;
	
		fancy.base = $.div().addClass('fancy base').prependTo(loader);
		fancy.guy = $.div().addClass('fancy guy').prependTo(fancy.base);
	
		fancy.hair = [];
		fancy.hair[0] = $.div().addClass('leftUpper hair').appendTo(fancy.guy);
		fancy.hair[1] = $.div().addClass('leftLower hair').appendTo(fancy.guy);
		fancy.hair[2] = $.div().addClass('right hair').appendTo(fancy.guy);
	
		fancy.earrings = [];
		fancy.earrings[0] = $.div().addClass('left earring').appendTo(fancy.guy);
	
		fancy.feathers = $.div().addClass('feathers').appendTo(fancy.guy);
	
		fancy.backdrop = $.div('backdrop').prependTo(loader);
		fancy.face = $.div().addClass('face').appendTo(fancy.guy);
		fancy.blink = $.div().addClass('blink').appendTo(fancy.guy);
		fancy.smile = $.div().addClass('smile').appendTo(fancy.guy);
	
		fancy.frame = $.div().addClass('frame').appendTo(fancy.base);
		fancy.logo = $.div().addClass('logo').appendTo(fancy.base);
		fancy.info = $.div().addClass('action').appendTo(fancy.base);
		fancy.info = $.div().addClass('xtra').appendTo(fancy.base);
		fancy.info = $.div().addClass('TwoinOne').appendTo(fancy.base);
		fancy.konami = $.div().addClass('konami').appendTo(fancy.base);
		fancy.legal = $.div().addClass('legal').appendTo(fancy.base);
	
		fancy.earrings[1] = $.div().addClass('right earring').appendTo(fancy.guy);
	
		fancy.thumb = $.div().addClass('thumb').appendTo(fancy.guy);
	
		fancy.mask = $.div().addClass('mask').appendTo(fancy.guy);
	
		fancy.arms = [];
		fancy.arms[0] = $.div().addClass('left arm').appendTo(fancy.guy);
	
		game.on('scale', function (e) {
			e.detail.resize({ width: 1920, height: 1080, font: 24 }, fancy.base);
	
			fancy.guy.attr('class', '');
	
			setTimeout(function () {
				fancy.guy.attr('class', 'fancy guy');
			}, 10);
		});
	});

/***/ },
/* 204 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 456 */,
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/7641d4823e2c9aba0e999cb31d8d36dd.mp3";

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/92b4b016309d96171b55714b6662c14d.mp3";

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e5484097ba677767b81f8f21f1f49ae0.mp3";

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/293e63a43b19b80ae7b43f31010179fc.mp3";

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/eaba30d658a067224100e253fbfdb168.mp3";

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e46956b6d04ed6f1f242377654f54c10.mp3";

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/05e4d92af37b72c34e81330287d9f9be.mp3";

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/6f8107499f9dd222961901e0b974d1ae.mp3";

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/31980deaaa89f6f7468386f6f969a032.mp3";

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/a9885e9742060dc6885240eb4b570b0d.mp3";

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e3d98c98513ca5630786784110256c5e.mp3";

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/8aea38f4c1b1a2a9b7c348a18ec4c086.mp3";

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4eb9f8be081619c11b2a6ebbd24bf6d0.mp3";

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e6bc6b7311c789f0eda2ead897cd0ef7.mp3";

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4ba9f659d724922731bbdad6761a595f.mp3";

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/376d4f2d1a4061d7804aa661d1182d26.mp3";

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e2d4458a43fdf5a6ec5c177dcac746c4.mp3";

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/53dd6d86e11845165f31515a2845dd24.mp3";

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/de408e316d2a5f66490d788dde8a5e0d.mp3";

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/d97588129b816bca61ef93e4910c419e.mp3";

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/b47a2651c3898d81593d5c9f1c23d31d.mp3";

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bc98d3cc1b52b22550b863b7cf4b05e4.mp3";

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fb4b196e3141225bfeb1ec92f3b2866e.mp3";

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fbe7001169be7c233e8fa235afef9bd0.mp3";

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/6b83be15947354fe28ae3136fff74100.mp3";

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/76e4b2218018da1f32ef1d52262cb60d.mp3";

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/04180d354c7365c49271ff8f8a62fa3c.mp3";

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4c1e128f49aced3ee80b0d6af8e471c4.mp3";

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4a2d6b22a467169e4fa73da914795627.mp3";

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/c3fe5d53be6a6fbf923b5578e92e1f74.mp3";

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cbe5c6e731c3c179f1b03f3b60f76368.mp3";

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/187165068a26f9530b6c3deee66ddec3.mp3";

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/5d590dd66884af88095d4898a9a6d8ca.mp3";

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cba56888064dae0a0da579cd68185931.mp3";

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/691932dc0a15bdb6e926c6c4ce7b2998.mp3";

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/89179c6a51f3f12e39ed82cd37edc76a.mp3";

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/e5dab62b8d9573cbfce003ef6c6b41bc.mp3";

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/3e2da1fc87191f91dc591566b33a1299.mp3";

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/2717b54c170c688b4da95254eeb5e559.mp3";

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/3e7ac0b1376c0070c85f36b9aaaa33d8.mp3";

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/d0fe9439c0c0a5d8944b4318b55d008f.mp3";

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/2dc29bc3ab8d9c69ebfa62ef08c6265c.mp3";

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/4302d02af7c417f4e5acdee4e66ee10c.mp3";

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/9e675ec8eee3afd45cb9a1686032cedd.mp3";

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/1d71843bdd4ba98ee7a4be43a4e293e6.mp3";

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/844977ca9350647ab293c29140ed62ad.mp3";

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/cff68d496f7ae699c002e054fcc89864.mp3";

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/fa858ce287508aebe8e0b6abeefa8a79.mp3";

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/49fc0dcb81aa096df2462c5a5216a470.mp3";

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/244fb9b4b0a7f9f630f9b093e527926b.mp3";

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/255ae1a2ac830dad73d1ce42003be9df.mp3";

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/6d3bffbed8112ed876525139d39b6fa4.mp3";

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/c46027bc10850684ed47f882137c7124.mp3";

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/ae1e5efeea9f248b1c346bfb328877c4.mp3";

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** main.min.js
 **/